import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterUser_template} from "./filterUser_template";
import { filterWebsiteUser_template } from "./filterWebsiteUser_template";
import {
    filterDropdown_template
} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {
    filterSingleDate_template
} from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSingleDate_template';
import {
    imagePicker_template
} from '../../../vendor/valnet/valnet_imagePicker/js/components/templates/imagePicker_template';
import {
    multipleSelector_template
} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterTag_template} from "./filterTag_template";
import {filterDataset_template} from "./filterDataset_template";
import {filterArticle_template} from "./filterArticle_template";
import {filterAutocomplete_template} from "./filterAutocomplete_template";
import {productReview_template} from "./productReview_template";
import {articleContent_template} from "./articleContent_template";
import {productReviewView_template} from "./productReviewVIew_template.";
import {articleReviewHistory_template} from "./articleReviewHistory_template";
import {directoryEdit_template} from './directoryEdit_template';
import {infoButton_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";
import {articleUserList_template, User} from "./articleUserList_template";
import {tagPicker_template} from "./tagPicker_template";
import * as rfdc from "rfdc";
import {articlePinnedTags_template} from "./articlePinnedTags_template";
import {imageWidget_template} from "./imageWidget_template";
import {articleAnalytics_template} from "./articleAnalytics_template";
import {directoryView_template} from "./directoryView_template";

import {warningDialog_template} from "./warningDialog_template";
import {disableAllEditors} from "../../utils/Helpers";
import {DragAndDropHandler} from "../../utils/DragAndDropHandler";
import videoPicker_template from '../../../vendor/valnet/valnet_imagePicker/js/components/templates/videoPicker_template';
import {articlePicker_template} from "./articlePicker_template";
import {articlePicker_helper} from "../../modules/articlePicker_helper";
import EmbedsSizesGenerator from "../../utils/embeds/EmbedsSizesGenerator";
import {EmbedInfo, Result, ViewportSize} from "../../utils/embeds/types";

import {imagePickerHelper} from '../../../vendor/valnet/valnet_imagePicker/js/modules/imagePickerHelper';
import {videoPickerHelper} from '../../../vendor/valnet/valnet_imagePicker/js/modules/videoPickerHelper';
import { genericPrompt_template } from "./genericPrompt_template";
import { sensaiProgressBar_template } from "./sensaiProgressBar_template";
import EmbedHelper, { embedTypesList } from "../../utils/EmbedHelper";
import sensai_chat_template from "./sensai_chat_template";
import {articles_edit_new} from '../../modules/articles_edit_new';

declare var ko: any;
declare var CKEDITOR: any;

enum Tab {
    ARTICLE = 'article',
    REVISION = 'revision',
    SANDBOX = 'sandbox',
    RECOVERY = 'recovery',
    REPUBLISH = 'republish',
    NEWSLETTER = 'newsletter',
    REVIEWS = 'reviews',
}
enum Previewable {
    ARTICLE = 'article',
    SANDBOX = 'sandbox',
    REPUBLISH = 'republish',
}

enum Recoverable {
    CONTENT = 'content',
    SANDBOX = 'sandbox',
    REPUBLISH = 'republish',
}

enum ArticleStatus {
    DRAFT = 1,
    SUBMIT_FOR_APPROVAL,
    CHANGES_REQUIRED,
    COMPLETED = 6,
    TRASH,
    SANDBOX
}

enum AuthorPaymentTypeForRepublish {
    AMOUNT = "Amount",
    PERCENTAGE = "Percentage"
}

enum EmbedContext {
    FEATURED = "featured",
    CONTENT = "content"
}

const ID_TEMPLATE_VIDEO = 15;
const ID_TEMPLATE_THREAD = 16;
const TEMPLATE_VIDEO_ENABLED = true;

const ID_PREMIUM_CLASSFICATION = 2;

export class articlesEdit_template_new extends vnTemplate {

    DEFAULT_ARTICLE_TEMPLATE_ID = 2 //Regular
    set featureImageToolTip(value: infoButton_template) {
        this._featureImageToolTip = value;
    }


    protected filterUser_author: filterUser_template;
    protected filterUser_SrEditor: filterUser_template;
    protected filterUser_JrEditor: filterUser_template;
    protected filterUser_ideator: filterUser_template;
    public filterUser_republish_author: filterUser_template;
    public filterUser_republish_SrEditor: filterUser_template;
    public filterUser_republish_JrEditor: filterUser_template;
    public filterUser_scheduled_republish_author: filterUser_template;
    public filterUser_scheduled_republish_SrEditor: filterUser_template;
    public filterUser_scheduled_republish_JrEditor: filterUser_template;
    protected filterUser_display_author: filterUser_template;
    protected filterWebsiteUser_prompt_author: filterWebsiteUser_template;
    protected toolTip_prompt_author: infoButton_template;
    protected display_authors: articleUserList_template;
    public paymentCategoryFilter: filterDropdown_template;
    public scheduledRepublishPaymentCategoryFilter: filterDropdown_template;
    public filterCategory: multipleSelector_template;
    public filterTag: filterTag_template;
    public filterDataset: filterDataset_template;
    public datePicker: filterSingleDate_template;
    public scheduleDatePicker: filterSingleDate_template;
    public giveawayDatePicker: filterSingleDate_template;
    public republishDatePicker: filterSingleDate_template;
    public scheduledRepublishDatePicker: filterSingleDate_template;
    public dateDevelopingStoryCoverageStartPicker: filterSingleDate_template;
    public dateDevelopingStoryCoverageEndPicker: filterSingleDate_template;
    protected developingStoryCoverageToolTip: infoButton_template;
    protected developingStoryCoverageToolTipContent;
    public sensaiPromptTemplate: genericPrompt_template;
    public imagePicker: imagePicker_template;
    public filterArticle: filterArticle_template;
    public filterArticleDirectory: filterArticle_template;
    public articleDirectory: directoryEdit_template;
    public sandboxDirectory: directoryEdit_template;
    public revisionDirectory: directoryView_template;
    public recoveryDirectory: directoryView_template;
    public recoverySandboxDirectory: directoryView_template;
    public recoveryRepublishDirectory: directoryView_template;
    protected productReview: productReview_template;
    public productReviewSandbox: productReview_template;
    public productReviewRepublish: productReview_template;
    protected articleContent: articleContent_template;
    protected sandboxContent: articleContent_template;
    protected republishContent: articleContent_template;
    protected recoveryReviewSection: productReviewView_template;
    protected recoverySandboxReviewSection: productReviewView_template;
    protected recoveryRepublishReviewSection: productReviewView_template;
    protected articleAnalytics: articleAnalytics_template;
    protected articleReviewHistory: articleReviewHistory_template;
    protected revisionReviewSection: productReviewView_template;
    protected toolTipButton : infoButton_template;
    protected customRecipientsToolTipButton : infoButton_template;

    protected pinnedTagTooltip: infoButton_template;
    protected pinnedTagTooltipContent;
    protected selectProductTooltip: infoButton_template;
    protected selectProductTooltipContent;

    private _featureImageToolTip: infoButton_template;
    protected featureImageTooltipContent;

    protected featuredTagSectionFeaturedImagePreview;
    protected featuredTagImagePreviewToolTip: infoButton_template;
    protected featuredTagSectionThumbnailImagePreview;
    protected featuredTagThumbnailPreviewToolTip: infoButton_template;

    protected thumbnailImageToolTip: infoButton_template;
    protected thumbnailImageTooltipContent;
    protected alternateSocialMediaImageToolTip: infoButton_template;
    protected alternateSocialMediaImageTooltipContent;

    protected emakiLabHelperTooltipContent;
    protected emakiLabHelperTooltip: infoButton_template;
    protected previewableTabs: Array<string> = [Previewable.ARTICLE, Previewable.SANDBOX, Previewable.REPUBLISH];
    public filterProducts: filterAutocomplete_template;
    public filterProductTypes: filterAutocomplete_template;
    public filterAffiliates: filterAutocomplete_template;
    public tagPicker: tagPicker_template;
    public filterPinnedTag: filterAutocomplete_template;
    public articlePinnedTags: articlePinnedTags_template;
    public articlePicker: articlePicker_template;
    public articlePickerHelper: articlePicker_helper;
    public filterReviewTag: filterAutocomplete_template;

    protected copyLeaksResultsSectionTooltipContent;
    protected copyLeaksResultsSectionTooltip: infoButton_template;

    public imageWidgetForThumbnailImage : imageWidget_template;
    public imageWidgetForAlternateImage : imageWidget_template;
    public imageWidgetForFeaturedImage : imageWidget_template;
    public imageWidgetForTagImageGroup : imageWidget_template;
    public imageWidgetForTagIcon : imageWidget_template;

    public warningDialog_WhenLogOut : warningDialog_template;
    public warningDialog_WhenArticleLock : warningDialog_template;

    public videoInstructionToolTip : infoButton_template;

    // public imageWidgetForFeaturedVideo : imageWidget_template

    public videoPicker : videoPicker_template;

    public republishDirectory: directoryEdit_template;
    public warningDialog_sandboxDelete : warningDialog_template;
    public warningDialog_newsletterSendingConfirmation : warningDialog_template;
    public warningDialog_republishDelete : warningDialog_template;
    public warningDialog_republishCreateAndUpdate : warningDialog_template;
    public updateTimeToolTipButton: infoButton_template;
    public newsletterDateScheduledSelector: filterSingleDate_template;

    public sensaiProgressBar: sensaiProgressBar_template;
    private newsletterTemplateSelector: filterDropdown_template;
    public imagePickerHelper: imagePickerHelper;
    public videoPickerHelper: videoPickerHelper;
    public embedHelper: EmbedHelper;
    public sourceNewsDatePicker: filterSingleDate_template;

    public sensaiChat: sensai_chat_template;
    protected delay = 4000;
    protected debounceTimerId: number;

    protected getTemplateHtml(): string {

        return /* html */`
            <div class="w-form w-form-sub faq" data-bind="css: { 'is-showing' : isFaqAddFormShown }" xmlns="http://www.w3.org/1999/html">
                    <div class="form-header">
                        <h3 class="form-title">Add FAQ</h3>
                        <button class="close-button icon i-close-2" type="button" data-bind="event: { click: onClickCancelFaq }"></button>
                    </div>
                    <div class="w-form-body">
                        <div class="form-body full-width">
                            <div class="form-group inside-label">
                                <label for="" class="form-label">Question</label>
                                <textarea type="text" class="input-text" data-bind="value: question" data-bind="disable: idStatus() == 6 && !permissions()['article_edit_publishingControl'].write"></textarea>
                            </div>
                            <div class="form-group">
                                <label for="article_faq" class="form-label">Answer</label>
                                <textarea id="article_faq"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="form-footer">
                        <button class="btn" type="button" data-bind="event: { click: onClickCancelFaq }">Cancel</button>
                        <button class="btn highlight" type="button" data-bind="event: { click: onClickSaveFaq }">Add</button>
                    </div>
                </div>
                <div class="w-form temp-selector-new" data-bind="css: { 'is-showing' : idTemplate() == ''}"> <!-- .is-showing -->
                        <div class="form-header">
                            <strong class="form-title">Select Preset</strong>
                            <button class="close-button icon i-close-2" type="button" data-bind="event: { click: onClickCancel }"></button>
                        </div>
                        <div class="w-form-body">
                            <div class="form-body">
                                <div class="form-group group-1">
                                    <button class="btn-temp-new temp-regular" type="button" data-bind="event: { click: onClickTemplateTab.bind($data, 2) }"><div class="w-icon"><span class="icon i-regular-template"></span></div><div class="temp-info"><span>Regular</span><p>News, editorials, how-tos, general content</p></div></button>
                                    <button class="btn-temp-new temp-list" type="button" data-bind="event: { click: onClickTemplateTab.bind($data, 3) }"><div class="w-icon"><span class="icon i-regular-template"></span></div><div class="temp-info"><span>List</span><p>Rankings, top lists, tips, groups of similar content</p></div></button>
                                    <button class="btn-temp-new temp-regular" type="button" data-bind="event: { click: onClickTemplateTab.bind($data, 14) }"><div class="w-icon"><span class="icon i-regular-template"></div><div class="temp-info"><span>How to Watch</span><p>In-depth how-to focused guide</p></div></button>
                                    <!--<button class="btn-temp temp-product-review" type="button" data-bind="event: { click: onClickTemplateTab.bind($data, 5) }"><img src="/assets/images/template-selector/temp-product-review.png" alt=""><div class="temp-info"><span>Product Review</span><p>Deep examination of a single product</p></div></button>-->
                                    <!--<button class="btn-temp temp-buyers-guide" type="button" data-bind="event: { click: onClickTemplateTab.bind($data, 6) }"><img src="/assets/images/template-selector/temp-buyers-guide.png" alt=""><div class="temp-info"><span>Buyer's Guide</span><p>In-depth comparison of multiple products</p></div></button>-->
                                </div>
                                <div class="form-group group-2">
                                    <button class="btn-temp-new temp-directory" type="button" data-bind="event: { click: onClickTemplateTab.bind($data, 7) }"><div class="w-icon"><span class="icon i-directory-template"></div><div class="temp-info"><span>Directory</span><p>Shared table of contents for a group of articles</p></div></button>
                                </div>
                                <div class="form-group group-3">
                                    <button class="btn-temp-new temp-buyers-guide-light" type="button" data-bind="event: { click: onClickTemplateTab.bind($data, 9) }"><div class="w-icon"><span class="icon i-commerce-template"></div><div class="temp-info"><span>Buyer’s Guide Light</span><p>Lightweight commerce-focused purchasing guide</p></div></button>
                                    <button class="btn-temp-new temp-buyers-guide-light" type="button" data-bind="event: { click: onClickTemplateTab.bind($data, 10) }"><div class="w-icon"><span class="icon i-commerce-template"></div><div class="temp-info"><span>Deals</span><p>Commerce-focused presentation of deals</p></div></button>
                                    <button class="btn-temp-new temp-product-collection" type="button" data-bind="event: { click: onClickTemplateTab.bind($data, 12) }"><div class="w-icon"><span class="icon i-commerce-template"></div><div class="temp-info"><span>Collection</span><p>Quick comparison of several similar products</p></div></button>
                                    <button class="btn-temp-new temp-versus" type="button" data-bind="event: { click: onClickTemplateTab.bind($data, 11) }"><div class="w-icon"><span class="icon i-commerce-template"></div><div class="temp-info"><span>Versus</span><p>In-depth comparison of two products with similar specs</p></div></button>
                                </div>
                                <div class="form-group group-4">
                                    <button class="btn-temp-new" type="button" data-bind="event: { click: onClickTemplateTab.bind($data, 13) }"><div class="w-icon"><span class="icon i-sub-content-template"></div><div class="temp-info"><span>Sub-content</span><p>Published as child content of a listing page</p></div></button>
                                </div>
                                <div class="form-group group-5">
                                    <button class="btn-temp-new temp-regular" type="button" data-bind="event: { click: onClickTemplateTab.bind($data, ${ID_TEMPLATE_VIDEO}) }"><div class="w-icon"><span class="icon i-video-template"></span></div><div class="temp-info"><span>Video</span><p>Video-focused with supporting content</p></div></button>
                                    <button class="btn-temp-new temp-regular" type="button" data-bind="event: { click: onClickTemplateTab.bind($data, ${ID_TEMPLATE_THREAD}) }"><div class="w-icon"><span class="icon i-thread-template"></span></div><div class="temp-info"><span>Thread</span><p>Focused on generating discussion on a topic</p></div></button>
                                </div>
                            </div>
                        </div>
                </div>

                <div class="w-form temp-selector center" data-bind="css: { 'is-showing' : showSegmentTab}"> <!-- .is-showing -->
                    <div class="form-header">
                        <strong class="form-title">Select Segment</strong>
                        <button class="close-button icon i-close-2" type="button" data-bind="event: { click: onClickCancel }"></button>
                    </div>
                    <div class="w-form-body">
                        <div class="form-body">
                            <div class="form-group segments" data-bind="foreach : segments">
                                <button class="btn-temp temp-regular" type="button"
                                data-bind="event: { click: function() { $parent.onClickSegmentTab($data.id) } }">
                                    <img data-bind="attr : { src: $data.logoPath }" alt="">
                                    <div class="temp-info">
                                        <span data-bind="text : $data.name"></span>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="ww-form w-form-article" data-bind="visible: (idTemplate() != '' && !showSegmentTab())">


                    <div class="w-form w-form-large ">

                        <div class="form-header">
                            <strong class="form-title icon i-edit">Post Edit</strong>

                            <div>
                                <!--
                                <button class="btn light icon i-sandbox" data-bind="event: { click: onClickCopyContent }, visible: selectedTab() == 'article'" type="button">Insert Content into Sandbox</button>
                                <button class="btn light icon i-article-regular" data-bind="event: { click: onClickRevertSandbox }, visible: selectedTab() == 'sandbox', disable: idStatus() == 6 && !permissions()['article_edit_publishingControl'].write" type="button">Insert Sandbox into Content</button>
                                -->
                                <a class="btn icon dark" type="button" data-bind="visible: (idPublishStatus() == 3 || idPublishStatus() == 4) && !isSubContent(), event: { click: onClickViewOnSite }">Live version</a>
                            </div>

                        </div>

                        <div class="form-msg is-scheduled" data-bind="visible: idRepublish">
                            <p class="icon i-scheduled">There is a scheduled republish for this article.  Changes to the article will not sync to the website until the schedule date is reached.</p>
                        </div>

                        <div class="form-pagination">
                            <button class="btn icon i-article" type="button" data-bind="event: { click: onClickTab.bind($data,'article') }, css: { 'is-activated' : selectedTab() == 'article'}"><span class="btn-text">Article</span></button>
                             
                            <button class="btn icon i-review" type="button" data-bind="event: { click: onClickTab.bind($data,'widgets') }, css: { 'is-activated' : selectedTab() == 'widgets'}"><span class="btn-text">Widgets</span></button>

                            <!-- ko if: idTemplate() != ${ID_TEMPLATE_VIDEO} && idTemplate() != ${ID_TEMPLATE_THREAD}  -->
                            <button class="btn icon i-revision" type="button" data-bind="event: { click: onClickTab.bind($data,'revision') }, css: { 'is-activated' : selectedTab() == 'revision'}"><span class="btn-text">Revision</span></button>
                            <!-- /ko -->
                            <button class="btn icon i-sandbox" type="button" data-bind="visible: (selectedTab() == 'sandbox' || isSandboxActive()),  event: { click: onClickTab.bind($data,'sandbox') }, css: { 'is-activated' : selectedTab() == 'sandbox'}"><span class="btn-text">Sandbox</span></button>
                            <button class="btn icon i-redo" type="button" data-bind="visible: (selectedTab() == 'republish' || isRepublishActive()), event: { click: onClickTab.bind($data,'republish') }, css: { 'is-activated' : selectedTab() == 'republish'}"><span class="btn-text">Republish Rewrite</span></button>
                            <button class="btn icon i-performance" type="button" data-bind="disable : isGlobalLockEnabled() ,event: { click: onClickTab.bind($data,'analytics') }, css: { 'is-activated' : selectedTab() == 'analytics', 'copyleaks' : plagiarismStatus() == 'Submitted'}"><span class="btn-text">Analytics</span></button>
                            <!-- ko if: idTemplate() != ${ID_TEMPLATE_VIDEO} && idTemplate() != ${ID_TEMPLATE_THREAD}   -->
                            <button class="btn icon i-recovery" type="button" data-bind="event: { click: onClickTab.bind($data,'recovery') }, css: { 'is-activated' : selectedTab() == 'recovery', 'highlight' : recoveryContent() != null || sandboxRecoveryContent() != null },"><span class="btn-text">Recovery <span>Available</span></span></button>
                            <!-- /ko -->
                            <!-- ko if: idTemplate() != ${ID_TEMPLATE_VIDEO} && idTemplate() != ${ID_TEMPLATE_THREAD}   -->
                            <button class="btn icon i-newsletter" type="button" data-bind="event: { click: onClickTab.bind($data,'newsletter') }, css: { 'is-activated' : selectedTab() == 'newsletter'}, visible: newsletterServiceType() && newsletterServiceType().value == 'Valnet' && permissions()['newsletter_email_edit'].write"><span class="btn-text">Newsletter</span></button>
                            <!-- /ko -->
                            <!-- ko if: idTemplate() != ${ID_TEMPLATE_VIDEO} && idTemplate() != ${ID_TEMPLATE_THREAD}   -->
                            <button class="btn icon i-feedback ai-hightlight" type="button" data-bind="event: { click: onClickTab.bind($data,'reviews') }, css: { 'is-activated' : selectedTab() == 'reviews', 'highlight' : hasNewFeedback() }"><span class="btn-text">Feedback</span></button>
                            <!-- /ko -->

                        </div>

                        <!-- ----------------- -->
                        <!-- Article          -->
                        <!-- ----------------- -->
                        <div class="w-tabs-content" data-bind="css: { 'is-showing' : selectedTab() == 'article'}"><!-- .is-showing -->
                            <div class="w-form-body">

                                <div class="form-body full-width">
                                    <!-- ----------------- -->
                                    <!-- General Info      -->
                                    <!-- ----------------- -->

                                    <div class="w-justify form-group">
                                        <div class="w-left">

                                            <div class="w-form-dropdown-menu" data-bind="visible: permissions()['article_edit_display_options'].write">
                                                <button class="btn-form light template-option icon i-dropdown-simple i-t-option" type="button" data-bind="disable : isGlobalLockEnabled() ,event: { click: onClickDisplayOptionToggle }">Display options</button>

                                                <div class="w-form form-dropdown-menu">

                                                       <button class="close-btn icon-only icon i-close" type="button" data-bind="event: { click: onClickDisplayOptionToggle }"><span class="hide-text">close</span></button>
                                                       <div class="form-group">
                                                            <span class="form-sub-title">Layout</span>
                                                             <div class="multi-row" data-bind="visible: permissions()['article_edit_config_ads'].write">
                                                                <input type="checkbox" data-bind="disable : isGlobalLockEnabled() ,checked: isAdHidden" id="AdHidden">
                                                                <label class="icon i-check" for="AdHidden">Hide Ads</label>
                                                            </div>
                                                            <div class="multi-row">
                                                                <input type="checkbox" data-bind="checked: isReadNextDisabled" id="ReadNext">
                                                                <label class="icon i-check" for="ReadNext">Hide Read Next Footer</label>
                                                            </div>
                                                            <div class="multi-row">
                                                                <input type="checkbox" data-bind="checked: isSidebarHidden" id="SidebarHidden">
                                                                <label class="icon i-check" for="SidebarHidden">Hide Sidebar</label>
                                                            </div>
                                                       </div>
                                                       <!-- ko if: showQuickShopLinks()  -->
                                                       <div class="form-group">
                                                            <span class="form-sub-title">Auto Units</span>
                                                            <div class="multi-row">
                                                                <input type="checkbox" data-bind="checked: isDisplayCardQuickLinksShown" id="CardQuickLinks">
                                                                <label class="icon i-check" for="CardQuickLinks">Quick Shop Links</label>
                                                            </div>
                                                            <div class="multi-row">
                                                                <input type="checkbox" data-bind="checked: isDisplayCardQuickLinksMobileShown" id="CardQuickLinksMobile">
                                                                <label class="icon i-check" for="CardQuickLinksMobile">Quick Shop Links (Mobile Only)</label>
                                                            </div>
                                                       </div>
                                                       <!-- /ko -->
                                                </div>
                                            </div>
                                            <button class="btn-form light icon i-emaki-lab e-lab" id="helper-button" data-bind="event: { click: onClickAutoCategorizeAndTag }, visible: permissions()['emaki_lab'].write && idTemplate() != ${ID_TEMPLATE_THREAD}, css: { 'is-disable' : id() == null || autoCategorizationGenerationAttemptsRemaining() == 0 }" type="button"><span class="msg-1">EmakiLab Helper</span><span class="msg-2">Generating...</span> <span class="counter" data-bind="text: autoCategorizationGenerationAttemptsRemaining"></span></button>
                                            <div class="w-tooltips-adv pos-bottom short" data-bind="visible: permissions()['emaki_lab'].write" style=" top: 5px;left:5px;">
                                            <!-- ko if: idTemplate() != ${ID_TEMPLATE_THREAD}  -->
                                            ${this.emakiLabHelperTooltip.getHtmlBuild()}
                                            <!-- /ko -->
                                            </div>
                                        </div>
                                        <div class="w-right">
                                            <!-- ko if: idTemplate() != ${ID_TEMPLATE_VIDEO} && idTemplate() != ${ID_TEMPLATE_THREAD}  -->
                                            <button class="btn-form icon light no-wrap icon i-sandbox" style="margin-left: 1rem" type="button" data-bind="visible: !isSandboxActive() && !isRepublishActive(), event: { click: onClickOpenSandboxOrRepublish.bind($data, 'sandbox') }, text: 'Open General Sandbox'"></button>
                                            <button class="btn-form icon light no-wrap icon i-redo" style="margin-left: 1rem" type="button" data-bind="visible: !isSandboxActive() && !isRepublishActive(), event: { click: onClickOpenSandboxOrRepublish.bind($data, 'republish') }, text: 'Begin a Rewrite for Republish'"></button>
                                            <!-- /ko -->
                                            <!--<button class="btn-form light icon i-sandbox" data-bind="event: { click: onClickCopyContent }, visible: selectedTab() == 'article',  disable: isSaveButtonDisabled() || isGlobalLockEnabled(), text: isSaveButtonDisabled() ? 'Autosaving...' : 'Insert Content into Sandbox'" type="button"></button>-->
                                            <!--<button class="btn-form icon light" style="margin-left: 1rem" type="button" data-bind="event: { click: onClickSaveAndPreview.bind($data, 'article') },  disable: isSaveButtonDisabled(), text: isSaveButtonDisabled() ? 'Autosaving...' : 'Save and Preview Article'"></button>
                                            <button class="btn-form icon light" style="margin-left: 1rem" type="button" data-bind="visible: idTemplate() != 5 && idTemplate() != 6, event: { click: onClickSaveAndPreviewAMP.bind($data, 'article') },  disable: isSaveButtonDisabled(), text: isSaveButtonDisabled() ? 'Autosaving...' : 'Save and Preview AMP Version of Article'"></button>-->
                                            <button class="btn-form icon light no-wrap icon i-view" style="margin-left: 1rem" type="button" data-bind="visible : !isSubContent(), disable : (isSaveButtonDisabled() || isPublishingControl() || isGlobalLockEnabled()), event: { click: onClickPreviewNoSave.bind($data, 'article') }, text: isSaveButtonDisabled() ? 'Autosaving...' : 'Preview Article'"></button>
<!--                                            <button class="btn-form icon light" style="margin-left: 1rem" type="button" data-bind="disable : (isPublishingControl() || isGlobalLockEnabled()), visible: idTemplate() != 5 && idTemplate() != 6 && idTemplate() != 8, event: { click: onClickPreviewAMPNoSave.bind($data, 'article') }, text: 'Preview AMP Version of Article'"></button>-->
                                            <!--
                                            <a class="btn-form icon dark" type="button" data-bind="visible: idPublishStatus() == 3 || idPublishStatus() == 4, event: { click: onClickViewOnSite }">Live version</a>
                                            <button class="btn-form icon light" type="button" data-bind="event: { click: onClickSaveAndPreview.bind($data, 'article') }">Save and Preview</button>
                                            -->
                                        </div>
                                    </div>

                                   <strong class="form-sub-title ">General Info</strong>


                                    <div class="form-group inside-label">
                                        <label for="" class="form-label">Title</label>
                                        <input type="text" class="input-text" data-bind="attr: { readonly : isPublishingControl() || isGlobalLockEnabled() }, value: title, event: { focusout: onFocusOutTitle }, css: { 'is-disable' : isTitleDisabled() }"/>
                                    </div>

                                    <div class="form-group inside-label permalink-block" data-bind="visible: !isSubContent()">
                                        <!-- <label for="" class="form-label" data-bind="text: permalink, visible: !allowEditPermalink()">Slug</label> -->
                                        <div>
                                          <label for="" class="form-label">Permalinks</label>
                                          <input
                                              type="text"
                                              class="input-text"
                                              data-bind="
                                                  attr: { readonly : isPublishingControl() || isGlobalLockEnabled() },
                                                  value: permalink,
                                                  event: { keyup: onKeyUpPermalinkParts }
                                              "
                                           "/>
                                        </div>
                                        <div>
                                            <button class="input-checkbox permalink-button btn-form"
                                                    id="isPermalinkHistory"
                                                    data-bind="event: { click: onClickShowPermalinkHistoryModal }, css: { 'button-red': permalinkRedirects() && permalinkRedirects().length > 0 }">
                                                    <span class="permalink-history-changes-total"
                                                            id="permalinkHistoryChangesTotal"
                                                            data-bind="text: permalinkHistory() && permalinkHistory().length ? '(' + permalinkHistory().length + ')' : ''; " >
                                                    </span>

                                                    <span data-bind="html: permalinkHistory() && permalinkHistory().length > 0 ? '&nbsp;History |&nbsp;' : ''; "></span>
                                                    <span class="permalink-redirects"
                                                            id="permalinkRedirects"
                                                            data-bind="text: permalinkRedirects() && permalinkRedirects().length ? ' Active Redirect: ' +  permalinkRedirects().length : ' No redirects found'; ">
                                                    </span>
                                            </button>
                                        </div>
                                    </div>

                                    <div class="form-group row start">


                                        <!-- Pop-up Window -->


                                        <div data-bind="css: {'is-visible' : isPermalinkPopupShown()}" id="permalink-popup" class="w-lightbox light-theme">
                                            <div class="lightbox-content w-form" id="permalinkEditWarning">
                                                <div class="form-header warning-header">
                                                    <span class="form-title">Permalink History</span>
                                                    <button class="close-button icon i-close-2" data-bind="click: onClickClosePermalinkHistoryModal"></button>
                                                </div>
                                                <div class="form-body">
                                                    <div class="form-group">
                                                        <p>
                                                            <strong>Warning:</strong> Changing URLs can negatively impact performance if not handled carefully.
                                                            URLs should only be changed to correct errors, or after keyword research and analysis.
                                                            If a live article needs to have its URL changed more than once, please alert a Lead Editor or Content Manager so they can have a second redirected created by IT.
                                                        </p>
                                                    </div>
                                                    <div class="form-group">
                                                        <p>Permalink Changes</p>
                                                    </div>
                                                    <div class="form-group">
                                                        <table class="list-action">
                                                            <thead>
                                                                <tr>
                                                                    <th><span>Date Created</span></th>
                                                                    <th><span>Permalinks</span></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody data-bind="foreach: permalinkHistory()">
                                                                <tr>
                                                                    <td><span data-bind="text: $data.dateCreated"></span></td>
                                                                    <td><span data-bind="text: $data.newPermalink"></span></td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    <div class="form-group">
                                                        <p>Redirects</p>
                                                    </div>
                                                    <div class="form-group">
                                                        <table class="list-action">
                                                            <thead>
                                                                <tr>
                                                                    <th><span>From</span></th>
                                                                    <th><span>Redirected To</span></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody data-bind="foreach: permalinkRedirects()">
                                                                <tr>
                                                                    <td><span data-bind="text: $data.oldPermalink"></span></td>
                                                                    <td><span data-bind="text: $data.newPermalink"></span></td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group row permalink-match " data-bind="visible : permalinkParts().length >0  ">
                                        <p>This article will be part of this menu section:</p>
                                        <ul data-bind="foreach: permalinkParts">
                                            <li><a data-bind="text: permalinkPartMatch, attr: { href: permalinkPartMatch }" ></a></li>
                                        </ul>
                                    </div>

                                    <!-- ko if: showSubContent()  -->
                                    <div class="form-group row start" style="margin-top: .5rem">
                                        <div class="form-check-inline" style="width: auto;">
                                            <input type="checkbox" data-bind="checked: isSubContent, disable: idStatus() == 6 && !permissions()['article_edit_publishingControl'].write" class="input-checkbox" id="isSubContent">
                                            <label class="form-label icon i-check" for="isSubContent">Sub Content</label>
                                        </div>
                                        <div class="w-tooltips-adv pos-bottom short" style="margin-top: .5rem">
                                        </div>
                                    </div>
                                    <!-- /ko -->

                                </div>
                            </div>



                            <div class="w-form-body">
                                <div class="form-body">


                                    <div class="form-group inside-label" data-bind="visible: isExcerptVisible()" >
                                         <label for="template" class="form-label">Excerpt (max 150 char)</label>
                                         <textarea data-bind="attr: { readonly : isPublishingControl() || isGlobalLockEnabled() }, value: excerpt" maxlength="150"></textarea>
                                    </div>

                                    <div class="form-group inside-label" >
                                         <label for="template" class="form-label">Include in directory</label>
                                         ${this.filterArticleDirectory.getHtmlBuild()}
                                    </div>

                                    <div class="form-group inside-label icon">
                                        <label class="form-label">Display Poll</label>
                                         <div class="w-spec-search icon i-auto-complete i-poll-a">
                                            <input class="input-text" list="polls" type="text"
                                            data-bind="attr: { readonly : isPublishingControl() || isGlobalLockEnabled() },
                                                       event:{
                                                           keyup: () => onChangePoll($data.pollName()),
                                                           blur: onSelectedPoll
                                                       },
                                                       textInput: pollName, valueUpdate: 'afterkeydown'" />
                                            <datalist id="polls" data-bind="foreach: poll_options">
                                                <option data-bind="value: name" >
                                            </datalist>
                                         </div>
                                    </div>

                                    <div class="form-group form-check-inline"  >
                                        <!-- ko if: showSponsoredDisclaimer()  -->
                                        <input type="checkbox" data-bind="disable: isPublishingControl() || isGlobalLockEnabled() , checked: isSponsored" id="sponsored-content">
                                        <label for="sponsored-content" class="form-label icon i-check" style="margin-right: 2rem">Sponsored Disclaimer</label>
                                        <!-- /ko -->
                                        <!-- ko if: showDevelopingStoryDisclaimer()  -->
                                        <div style="display: inline-block;">
                                            <input type="checkbox" data-bind="disable: isPublishingControl() || isGlobalLockEnabled(), checked: isDevelopingStory" id="developing-story">
                                            <label for="developing-story" class="form-label icon i-check">Live Blogging</label>
                                            <div class="w-tooltips-adv pos-top short" data-bind="visible: isDevelopingStory()" style="position: absolute;right: -25px;top: 10px;">
                                                ${this.developingStoryCoverageToolTip.getHtmlBuild()}
                                            </div>
                                        </div>
                                        <!-- /ko -->
                                        <div class="form-group inside-label date-w no-border no-margin-inline" data-bind="visible: (isDevelopingStory() && showDevelopingStoryDisclaimer())" style="margin-top: 1.5rem;">
                                            <label for="dateDevelopingStoryCoverageStartPicker" class="form-label">Developing Story Start Date</label>
                                            ${this.dateDevelopingStoryCoverageStartPicker.getHtmlBuild()}
                                        </div>
                                        <div class="form-group inside-label date-w no-border no-margin-inline" data-bind="visible: (isDevelopingStory() && showDevelopingStoryDisclaimer())">
                                            <label for="dateDevelopingStoryCoverageEndPicker" class="form-label">Developing Story End Date</label>
                                            ${this.dateDevelopingStoryCoverageEndPicker.getHtmlBuild()}
                                        </div>
                                    </div>
                                    <!-- ko if: showSponsoredDisclaimer() || showDevelopingStoryDisclaimer()  -->
                                    <div class="form-group hr" ><hr /></div>
                                    <!-- /ko -->

                                    <div data-bind="visible:isNewsArticle" class="w-timeliness">
                                        <div class="form-group inside-label d-flex" style="align-items: center;gap: 1rem">
                                            <label for="" class="form-label label-tooltips">
                                                Source/Inspiration
                                                <button class="w-tooltips icon i-tooltips" type="button">
                                                    <span class="tooltips">Input the URL of the original source where the news was first reported. If this article was the first to break the news, click the "Self" button to automatically populate the Source/Inspiration URL and DateTime fields with this article’s information.</span>
                                                </button>
                                            </label>
                                            <input type="text" class="input-text" data-bind="attr: { readonly : isPublishingControl() || isGlobalLockEnabled() }, textInput: sourceUrl">
                                            <span> Or </span>
                                            <span class="d-flex">
                                                <button class="input-checkbox btn-form label-height" id="sourceNewsIsFromSelf" data-bind="click: onClickSourceNewsIsSelf">
                                                    Self
                                                </button>
                                            </span>
                                        </div>
                                        <div class="form-group inside-label d-flex w-datetime">
                                            <label for="" class="form-label label-tooltips">
                                                Datetime
                                                <button class="w-tooltips icon i-tooltips" type="button">
                                                    <span class="tooltips">Use the Datetime field to capture the original publish date and time of the Source/Inspiration URL. Click "Get Time" to attempt to auto-fill it; if unsuccessful, enter the date and time manually.</span>
                                                </button>
                                            </label>
                                            ${this.sourceNewsDatePicker.getHtmlBuild()}
                                            <span class="d-flex">
                                                <button class="input-checkbox btn-form label-height" data-bind="click: onClickSourceNewsGetTime, css: { loading: isLoadingSrcTimeBtn }, enable: isSourceUrlValid">
                                                    Get Time
                                                </button>
                                            </span>

                                        </div>
                                    </div>

                                    <div class="form-group row" data-bind="visible: idTemplate() == 3">
                                        <label for="list_numbering" class="form-label">List Numbering</label>
                                        <select id="list_numbering" data-bind="value: listOrder, disable: isPublishingControl() || isGlobalLockEnabled()">
                                            <option value="ascending">Ascending</option>
                                            <option value="descending">Descending</option>
                                            <option value="none">None</option>
                                        </select>
                                    </div>

                                    <!-- ko if: showTableOfContents()  -->
                                        <div class="form-group hr" ><hr /></div>
                                        <div class="form-group form-check-inline">
    <!--                                        <input type="checkbox" data-bind="disable: isPublishingControl() || isGlobalLockEnabled(), checked: isAmpDisabled" id="enable-amp">-->
    <!--                                        <label for="enable-amp" class="form-label icon i-check" style="margin-right: 7.2rem">AMP Disabled</label>   -->
                                            <input type="checkbox" data-bind="disable: isPublishingControl() || isGlobalLockEnabled(), checked: tableOfContents" id="tableOfContents">
                                            <label for="tableOfContents" class="form-label icon i-check" for="tableOfContents">Table of contents</label>
                                        </div>
                                    <!-- /ko -->
                                    <!-- ko if: affiliateBrands().includes(brand().id) -->
                                    <div class="form-group form-check-inline">
                                        <input type="checkbox" data-bind="disable: !permissions()['article_edit_config_affiliate_linker'].write || isPublishingControl() || isGlobalLockEnabled, checked: isAffiliateLinkerEnabled" id="disable-affiliate-linker">
                                        <label for="disable-affiliate-linker" class="form-label icon i-check">Auto-Affiliate Links</label>
                                    </div>
                                    <!-- /ko -->
                                    <!-- ko if: articlePageSettings()['additionalCreditEnabled'] -->
                                        <div class="form-group hr" ><hr /></div>
                                        <div class="form-group form-check-inline width-full">
                                            <label class="form-label">Additional Credit</label>
                                            <textarea data-bind="attr: {id: 'additional_credit'}"></textarea>
                                        </div>
                                    <!-- /ko -->
                                </div>

                                <div class="form-body">

                                    <div class="form-group" style="margin-bottom: 2rem">

                                        <!--
                                        <div class="form-check-inline width-auto" data-bind="visible: idTemplate() != 2 && idTemplate() != 3">
                                            <label for="featuredImage" class="form-label">Featurgergered Image</label>
                                        </div>
                                        -->
                                        <div data-bind="visible: idTemplate() == 2 || idTemplate() == 3 || idTemplate() == 9 || idTemplate() == 10 || idTemplate() == 11 || idTemplate() == 14">

                                            <div class="form-check-inline width-auto">
                                                <input type="radio" name="featuredSection" id="_featuredImage"  data-bind="disable: isPublishingControl() || isGlobalLockEnabled(), checkedValue : 'featuredImage', checked: featuredSectionValue, event: { change: onChangeFeaturedSection }"/>
                                                <label class="form-label" for="_featuredImage">Featured Image</label>
                                            </div>

                                            <div class="form-check-inline width-auto">
                                                <input type="radio" name="featuredSection" id="_featuredTag" data-bind="disable: isFeaturedTagDisabled() || isPublishingControl() || isGlobalLockEnabled(), checkedValue : 'featuredTag', checked: featuredSectionValue, event: { change: onChangeFeaturedSection }" />
                                                <label class="form-label" for="_featuredTag">Featured Tag</label>
                                            </div>

                                            <div class="form-check-inline width-auto">
                                                <input type="radio" name="featuredVideo" id="_featuredVideo" data-bind="disable: isFeaturedVideoDisabled() || isPublishingControl() || isGlobalLockEnabled(), checkedValue : 'featuredVideo', checked: featuredSectionValue, event: { change: onChangeFeaturedSection }" />
                                                <label class="form-label" for="_featuredVideo">Featured Video</label>
                                            </div>

                                            <div data-bind="visible: isFeaturedTagActive()">
                                                <div class="form-group row" style="margin: 1rem 0;">
                                                    <label for="type" class="form-label" style="margin: 0;">Featured Tag</label>

                                                    <button class="btn-form icon i-tag"  data-bind="disable: isPublishingControl() || isGlobalLockEnabled() , visible: !featuredTags(), event: { click: onClickFeaturedTag }" type="button" data-bind="">Select Tag</button>

                                                    <!-- ko if: featuredTags  -->
                                                        <div data-bind="visible: featuredTags().tagObject">
                                                            <button class="btn-form icon i-edit" data-bind="disable: isPublishingControl() || isGlobalLockEnabled(), event: { click: onClickFeaturedTagEdit }" type="button" >Edit Selection</button>
                                                            <button class="btn-form icon i-delete" data-bind="disable: isPublishingControl() || isGlobalLockEnabled(), event: {click: onClickFeaturedTagDelete}"></button>
                                                        </div>
                                                    <!-- /ko -->
                                                    </select>
                                                </div>

                                                <!-- ko if: featuredTags  -->
                                                <ul class="tag-list" id="tag-selection" data-bind="" style="height: auto;">

                                                    <li class="tag-item" data-bind="foreach: featuredTags().tagObject">
                                                            <div class="w-img" data-bind="">
                                                                <div class="ratio-content">
                                                                <!-- ko if: $data.image -->
                                                                    <img data-bind="attr:{src: $data.image.url}" />
                                                                <!-- /ko -->

                                                                </div>
                                                            </div>
                                                            <div class="w-info">
                                                                <strong data-bind="text:$data.name"></strong>
                                                            </div>
                                                    </li>
                                                </ul>
                                                <!-- /ko -->
                                                <div class="form-check-inline width-auto" style="margin-top: 1rem;">
                                                <!-- ko if: isFeaturedTagActive  -->
                                                    <input type="checkbox" data-bind="disable: isPublishingControl() || isGlobalLockEnabled(), checked: isVersusStyle" id="isVersusStyle">
                                                    <label class="icon i-check" for="isVersusStyle">Apply VS Style</label>
                                                <!-- /ko -->
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group featured-video embed" data-bind="visible : isFeaturedVideoActive()">
                                        <label class="form-label" data-bind="visible: featuredVideo() || (!showSelectFeaturedEmbed() && !showFeaturedImage())">Featured Video</label>
                                        <!-- ko if: showSelectFeaturedEmbed()  -->
                                        <label class="form-label" data-bind="visible: !featuredVideo() && featuredEmbed()">Featured Embed</label>
                                        <!-- /ko -->
                                         <div style="text-align: right">
                                            <!-- ko if: showSelectFeaturedVideo()  -->
                                            <button class="btn-form icon i-video-2" data-bind="click : onClickSelectFeaturedVideo, visible: !featuredVideo() && !featuredEmbed()">Select Video</button>
                                            <!-- /ko -->
                                            <!-- ko if: showSelectFeaturedEmbed()  -->
                                            <button class="btn-form icon i-video-2" data-bind="click : onClickSelectFeaturedEmbed, visible: !featuredEmbed() && !featuredVideo()">Select Embed</button>
                                            <!-- /ko -->
                                        </div>

                                        <div data-bind="if: featuredVideo()" class="w-video">
                                            <div class="w-btn right">
                                                <button class="btn-form icon i-video-2 active" data-bind="click : onClickSelectFeaturedVideo">Select Video</button>
                                            </div>
                                            <div class="w-btn left">
                                                <button class="btn-form icon icon-only i-full-size" data-bind="click : onClickPreviewFeaturedVideo"></button>
                                                <button class="btn-form icon icon-only i-edit" data-bind="click : onClickEditFeaturedVideo"></button>
                                                <button class="btn-form icon icon-only i-delete" data-bind="click : onClickRemoveFeaturedVideo"></button>
                                            </div>
                                            <span class="feature-video-title" data-bind="text : featuredVideo().title"></span>
                                            <video data-bind="attr: {src: featuredVideo().url, width : 650, height : 365  , poster : featuredVideo().thumbnail.url }">
                                        </div>
                                        <div data-bind="if: featuredEmbed() && !featuredVideo()" class="w-video">
                                            <div class="w-btn right">
                                                <button class="btn-form icon i-video-2 active" data-bind="click : onClickSelectFeaturedEmbed">Select Embed</button>
                                            </div>
                                            <div class="w-btn left">
                                                <button class="btn-form icon icon-only i-delete" data-bind="click : onClickRemoveFeaturedEmbed"></button>
                                            </div>
                                            <div class="w-embed" data-bind="html : featuredEmbed()"></div>
                                        </div>

                                        <!-- ko if: featuredVideo()  -->
                                        <div>
                                            <label for="" class="form-label">Video Title</label>
                                            <input type="text" class="input-text" data-bind="value: featuredVideoTitle"/>
                                            <label for="template" class="form-label">Video Description</label>
                                            <textarea data-bind="value: featuredVideoDescription"></textarea>
                                        </div>
                                        <!-- /ko -->
                                    </div>

                                    <!-- ko if: showFeaturedImage()  -->
                                    <div class="form-group img" data-bind="visible: (!isFeaturedTagActive() || isFeaturedEmbedActive() || featuredTags() ) , css: {'featured-tag-selected':isFeaturedTagActive()}">
                                        <div style="display: flex;align-items: center">
                                            <label class="form-label" data-bind="visible: (isFeaturedVideoActive() && !featuredVideo() && featuredEmbed()) || isFeaturedImageActive()" style="">Featured Image</label>
                                            <div class="w-tooltips-adv pos-top short" data-bind="visible: (!isFeaturedTagActive() && !isFeaturedVideoActive() && isFeaturedEmbedActive()) || isFeaturedImageActive()">
                                                ${this._featureImageToolTip.getHtmlBuild()}
                                            </div>

                                        </div>
                                        <div style="display: flex;align-items: center">
                                            <label for="featuredImage" class="form-label" data-bind="visible: (!isFeaturedTagActive() && !isFeaturedVideoActive() && isFeaturedEmbedActive())">Featured Image</label>
                                            <div class="w-tooltips-adv pos-top short" data-bind="visible: (isFeaturedTagActive() && featuredImage())">
                                                ${this.featuredTagImagePreviewToolTip.getHtmlBuild()}
                                            </div>
                                        </div>
                                            <!-- ko if: isFeaturedImageActive() || (isFeaturedVideoActive() && !featuredVideo() && featuredEmbed()) -->
                                            ${this.imageWidgetForFeaturedImage.getHtmlBuild()}
                                            <!-- /ko -->

                                            <!-- ko if: featuredImageIsPortrait -->
                                            <p style="color: red">Aspect ratio is too low. Featured images must have a minimum aspect ratio of 16:9. Image will be cropped to fit 16:9</p>
                                            <!-- /ko -->

                                        <div style="display: flex;justify-content: space-between;align-items: center;">
                                            <!-- ko if: featuredImage() && IsFeaturedImageMobileOptimized() -->
                                                <span class="mobile icon i-mobile">Mobile Optimized</span>
                                            <!-- /ko -->
                                        </div>
                                    </div>
                                    <!-- /ko -->

                                    <div class="form-group" style="border-top: 1px dashed #d3d3d3; margin-top: 2rem; padding-top: 2rem;">
                                        <div class="form-group img" style="margin: 0;">
                                            <div style="display: flex;align-items: center;">
                                                <label for="thumbnailImage" class="form-label">Article Thumbnail Image</label>

                                                <div class="w-tooltips-adv pos-top short" data-bind="visible: (!isFeaturedTagActive())">
                                                    ${this.thumbnailImageToolTip.getHtmlBuild()}
                                                </div>
                                                <!-- ko if: isFeaturedTagActive  -->
                                                <div class="w-tooltips-adv pos-top short">
                                                    ${this.featuredTagThumbnailPreviewToolTip.getHtmlBuild()}
                                                </div>
                                                <!-- /ko -->

                                            </div>

                                             ${this.imageWidgetForThumbnailImage.getHtmlBuild()}
                                        </div>
                                    </div>

<!--                                   <div class="form-group" style="margin-top: 3rem" data-bind="visible: idTemplate() == 2 || idTemplate() == 3 || idTemplate() == 9 || idTemplate() == 10 || idTemplate() == 14"><hr></div>-->
<!--                                  -->
<!--                                    <div class="form-group inside-label" data-bind="visible: idTemplate() == 2 || idTemplate() == 9 || idTemplate() == 10 || idTemplate() == 14">-->
<!--                                         <label for="template" class="form-label">File Widget Url</label>-->
<!--                                         <input type="text" class="input-text" data-bind="disable: isPublishingControl() || isGlobalLockEnabled() , value: fileUrl"/>-->
<!--                                    </div>-->
                                </div>
                            </div>

                            <div class="w-form-body">
                                <div class="form-body" id="categorize-section" >
                                    <!-- ----------------- -->
                                    <!-- Categorization    -->
                                    <!-- ----------------- -->
                                    <strong class="form-sub-title categorization" style="flex: 1 100%;">Categorization</strong>
                                        <div data-bind="visible: idStatus() != 6 || (idStatus() == 6 && permissions()['article_edit_publishingControl'].write)">
                                            <div class="form-group row" style="justify-content:start;">
                                                  ${this.filterCategory.getHtmlBuild()}
                                                  <button class="btn-form light icon i-emaki-lab e-lab" style="margin-left: 1rem;" data-bind="event: { click: onClickAutoCategorize }, visible: permissions()['emaki_lab'].write, css: { 'is-disable' : id() == null || autoCategorizationGenerationAttemptsRemaining() == 0 }" type="button"><span class="counter" data-bind="text: autoCategorizationGenerationAttemptsRemaining"></span></button>
                                                 <div style="display: none;" id="filters-selected" class="filters-selected"></div>
                                            </div>
                                            <div class="form-group w-radio" data-bind="foreach: selectedCategories, childrenComplete : handleDragAndDrop($element, selectedCategories ,'.category-element')">
                                                <div class="btn-selection category-element" data-bind="css: { 'auto-generated' :  $data.isAIGenerated }">
                                                    <div class="drag-handle i-move short"><button type="button" class="btn no-bg icon i-drag"></button></div>
                                                    <input type="radio" name="category" data-bind="disable: $parent.isPublishingControl() || $parent.isGlobalLockEnabled(), attr: { value: $data.category.id, id: 'category_' + $data.category.id }, checked: $parent.idPrimaryCategory">
                                                    <label class="form-label" for="active_no" data-bind="text: $data.category.name, attr: { for: 'category_' + $data.category.id }"></label>
                                                    <button class="icon i-x-after" type="button" data-bind="disable: $parent.isPublishingControl() || $parent.isGlobalLockEnabled(), visible: $parent.idStatus() != 6 || ($parent.idStatus() == 6 && $parent.permissions()['article_edit_publishingControl'].write), event: { click: $parent.onClickDeleteSelectedCategory }"></button>
                                                </div>
                                            </div>
                                        </div>

                                        <div data-bind="visible: (idStatus() != 6 || (idStatus() == 6 && permissions()['article_edit_publishingControl'].write) && !isSubContent())">
                                             <div class="form-group inside-label icon row" style="align-items: flex-start;">
                                               <label class="form-label" style="width: auto;">Tags</label>
                                               ${this.filterTag.getHtmlBuild()}
                                               <!--<input type="text" class="input-text" />-->
                                               <button class="btn-form light icon i-emaki-lab e-lab" style="margin-left:1rem;" data-bind="event: { click: onClickAutoTag }, visible: permissions()['emaki_lab'].write, css: { 'is-disable' : id() == null || autoCategorizationGenerationAttemptsRemaining() == 0 }" type="button"><span class="counter" data-bind="text: autoCategorizationGenerationAttemptsRemaining">4</span></button>
                                            </div>
                                            <div class="form-group" data-bind="foreach: selectedTags, childrenComplete : handleDragAndDrop($element, selectedTags ,'.tag-element')">
                                                <div class="btn-selection tag-element" data-bind="css: { 'auto-generated' :  $data.isAIGenerated }">
                                                    <div class="drag-handle i-move short"><button type="button" class="btn no-bg icon i-drag"></button></div>
                                                    <input type="radio" name="tag" data-bind="disable: $parent.isPublishingControl() || $parent.isGlobalLockEnabled(), attr: { value: $data.tag.id, id: 'tag_' + $data.tag.id }, checked: $parent.idPrimaryTag">
                                                    <label class="form-label" for="active_no" data-bind="text: $data.tag.name + ' ' + $data.tag.formattedTagTypeAndDataset, attr: { for: 'tag_' + $data.tag.id }"></label>
                                                    <button class="icon i-x-after" type="button" data-bind="visible: $parent.idStatus() != 6 || ($parent.idStatus() == 6 && $parent.permissions()['article_edit_publishingControl'].write), event: { click: $parent.onClickDeleteSelectedTag }"></button>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- ko if: [5, 24].includes(idContentType())  -->
                                        <div data-bind="visible: (idStatus() != 6 || (idStatus() == 6 && permissions()['article_edit_publishingControl'].write) && !isSubContent())">
                                            <div class="form-group inside-label icon row" style="align-items: flex-start;">
                                                <div class="full-width">
                                                    ${this.filterReviewTag.getHtmlBuild()}
                                                </div>
                                            </div>
                                        </div>
                                        <!-- /ko -->

                                </div>

                                <div class="form-body" data-bind="visible: newsNowBrands().includes(brand().id), css: { 'grayed-out': checkIsNewsNowArticle || !permissions()['article_edit_publishingControl'].write }" style="position: relative">

                                    <strong class="form-sub-title amazon">

                                    <!-- ko if: newsNowBrands().includes(brand().id)  -->
                                    News Now
                                    <!-- /ko -->
                                    </strong>
                                    <div class="overlay">
                                    </div>
                                    <input type="checkbox" class="invert" data-bind="visible:newsNowBrands().includes(brand().id),checked: isNewsNowArticle ,disable: !permissions()['article_edit_publishingControl'].write" id="isNewsNowArticle">
                                    <label for="isNewsNowArticle" class="form-label icon i-check" style="color:#ffffff;">Include in Feed</label>

                                    <div class="form-group inside-label" style="display:flex;justify-content: flex-start;">
                                        <label class="form-label" for="">Article title</label>
                                        <input type="text" class="input-text" data-bind="disable: isPublishingControl() || isGlobalLockEnabled() , value:  newsNowArticleTitle">
                                    </div>
                                </div>
                            </div>

                            <!-- ----------------- -->
                            <!--Pinned Tags        -->
                            <!-- ----------------- -->
                            <div data-bind="visible: showPinnedTags() && (idTemplate() == 2 || idTemplate() == 3 || idTemplate() == 9 || idTemplate() == 10 || idTemplate() == 14)">
                                ${this.articlePinnedTags.getHtmlBuild()}
                            </div>

                            <div class="w-form-body" data-bind="visible: idTemplate() == 15">

                                <div class="form-body">
                                    <div style="display:flex;">
                                        <div class="form-group">
                                            <label for="" class="form-label">Channel</label>
                                            <p data-bind="text: channelName() ? channelName() : 'None'"></p>
                                        </div>

                                        <div class="form-group" data-bind="if: idChannel()">
                                            <label for="" class="form-label">Playlists</label>
                                            <!-- ko if: playlists().length > 0 -->
                                                <ul data-bind="foreach: playlists">
                                                    <li><p data-bind="text: name ? name : 'None'"></p></li>
                                                </ul>
                                            <!-- /ko -->
                                            <!-- ko if: playlists().length == 0 -->
                                                <p>None</p>
                                            <!-- /ko -->
                                        </div>
                                    </div>
                                </div>


                                <!-- <button class="btn-form icon i-video-2" data-bind="click : onClickEditChannel">Edit Channel</button> -->
                             </div>


                            <div class="w-form-body">

                                <!-- ko if: showSEO()  -->
                                <div class="form-body">
                                    <!-- ----------------- -->
                                    <!-- SEO               -->
                                    <!-- ----------------- -->

                                    <strong class="form-sub-title search-engine">SEO</strong>


                                    <div class="form-group inside-label">
                                        <label for="seoTitle" class="form-label">Title</label>
                                        <input type="text" class="input-text" name="seoTitle" data-bind="attr :{readonly : isPublishingControl() || isGlobalLockEnabled() }, value: seoTitle"/>
                                    </div>

                                    <div class="form-group inside-label">
                                        <label for="seoDescription" class="form-label">Description (max 150 char)</label>
                                        <textarea name="seoDescription" maxlength="150" data-bind="attr :{readonly : isPublishingControl() || isGlobalLockEnabled() }, value: seoDescription"/></textarea>
                                    </div>

                                    <div class="form-group inside-label" data-bind="visible: idTemplate() != 7 && (idStatus() != 6 || (idStatus() == 6 && permissions()['article_edit_publishingControl'].write)) && !isSubContent()">
                                        <label class="form-label" for="idArticle" >Next Article</label>
                                        ${this.filterArticle.getHtmlBuild()}
                                    </div>

                                    <!--Video uploads-->
                                    <!--Video uploads-->
                                </div>
                                <!-- /ko -->

                                <div class="form-body">

                                    <!-- ----------------- -->
                                    <!-- SMO               -->
                                    <!-- ----------------- -->
                                    <div class="social-media">
                                        <strong class="form-sub-title social-media">Social Media</strong>

                                        <div class="form-group inside-label">
                                            <label for="smoTitle" class="form-label">SMO Title</label>
                                            <input type="text" class="input-text" name="smoTitle" data-bind="attr :{readonly : isPublishingControl() || isGlobalLockEnabled() }, value: smoTitle"/>
                                        </div>

                                        <div class="form-group inside-label">
                                            <label for="smoDescription" class="form-label">SMO Description (max 150 char)</label>
                                            <textarea name="smoDescription" maxlength="150" data-bind="attr :{readonly : isPublishingControl() || isGlobalLockEnabled() }, value: smoDescription"/></textarea>
                                        </div>


                                        <div class="form-group inside-label">
                                            <label for="socialTagLine" class="form-label">Social Tagline</label>
                                            <input type="text" class="input-text" name="socialTagLine" data-bind="attr :{readonly : isPublishingControl() || isGlobalLockEnabled() }, value: socialTagLine"/>
                                        </div>

                                        <div class="form-group img">
                                            <div style="display: flex;align-items: center">
                                                <label for="alternateImage" class="form-label">Alternate Image</label>
                                                <div class="w-tooltips-adv pos-top short">
                                                    ${this.alternateSocialMediaImageToolTip.getHtmlBuild()}
                                                </div>
                                            </div>
                                            ${this.imageWidgetForAlternateImage.getHtmlBuild()}
                                        </div>
                                    </div>

                                </div>

                            </div>
                            ${this.productReview.getHtmlBuild()}
                            <div data-bind="visible: showContent">
                                ${this.articleContent.getHtmlBuild()}
                            </div>


                            <div class="w-form-body">
                                <div class="form-body">
                                    <!-- ----------------- -->
                                    <!-- THREAD            -->
                                    <!-- ----------------- -->
                                    <strong class="form-sub-title search-engine">Thread</strong>
                                    <div class="form-group inside-label">
                                        <label for="prompt" class="form-label">Prompt (max 150 char)</label>
                                        <input type="text" class="input-text" name="prompt" data-bind="attr :{readonly : isPublishingControl() || isGlobalLockEnabled() }, textInput: prompt, event: { focusout: onFocusOutPrompt }"/>
                                    </div>

                                    <div class="form-group inside-label">
                                        <label for="prompt_response" class="form-label">Prompt Response</label>
                                        <textarea id="prompt_response" name="prompt_response" maxlength="2000" data-bind="attr :{readonly : isPublishingControl() || isGlobalLockEnabled() }, textInput: promptResponse,  valueUpdate: ['afterkeydown', 'input']"/></textarea>
                                    </div>
                                    <div class="form-group inside-label" data-bind="visible: isPromptAuthorVisible()">
                                        <label for="authorName" class="form-label label-tooltips" style="display: flex; align-items: center; gap: 8px; margin: 0; top: -.8rem;">
                                            <span>
                                                Prompt Author
                                            </span>
                                            <div class="w-tooltips-adv pos-right short">
                                                 ${this.toolTip_prompt_author.getHtmlBuild()}
                                            </div>
                                        </label>
                                        ${this.filterWebsiteUser_prompt_author.getHtmlBuild()}
                                    </div>
                                    <div class="form-group inside-label">
                                        <label for="prompt" class="form-label">Prompt Link</label>
                                        <input type="text" class="input-text" name="promptLink" data-bind="attr :{readonly : isPublishingControl() || isGlobalLockEnabled() }, value: promptLink,  valueUpdate: ['afterkeydown', 'input']"/>
                                    </div>
                                    <div class="form-group inside-label" data-bind="hidden : idTemplate() == ${ID_TEMPLATE_THREAD}">
                                        <input type="checkbox" data-bind="checked: isCommentsDisabled" id="CommentsDisabled">
                                        <label class="icon i-check" for="CommentsDisabled">Hide Comments</label>
                                    </div>
                                    <div class="form-group inside-label">
                                        <input type="checkbox" data-bind="checked: isCommentsPaused" id="CommentsPaused">
                                        <label class="icon i-check" for="CommentsPaused">Pause Comments</label>
                                    </div>
                                    <!-- TODO AndyC When we need to add ratings enabled setting uncomment the following START-->
                                    <!--<div class="form-group inside-label">
                                        <input type="checkbox" data-bind="checked: isRatingEnabled" id="ratingEnabled">
                                        <label class="icon i-check" for="ratingEnabled">Enable Rating</label>
                                    </div> -->
                                    <!-- TODO AndyC END-->
                                </div>
                            </div>

                            ${this.articleDirectory.getHtmlBuild()}

                            <div class="w-form-body" data-bind="visible: function(){return [2,3,5,6,7,9,10,11,12].includes(idTemplate())} ">
                                <!-- ko if: showFAQ()  -->
                                <div class="form-body form-section faq">
                                    <!-- ----------------- -->
                                    <!--FAQ                -->
                                    <!-- ----------------- -->
                                    <strong class="form-sub-title faq">FAQ</strong>

                                    <button class="form-section-btn icon i-plus" type="button" data-bind="disable: isPublishingControl() || isGlobalLockEnabled() , event: { click: onClickAddFaq }"><span class="hide">Add Faq</span></button>
                                    <div class="form-group">
                                        <div class="w-list">
                                            <ul data-bind="foreach: faqs">
                                                <li>
                                                    <div class="item-header">
                                                        <div>
                                                            <button class="btn-form icon i-delete" type="button" data-bind="disable: $parent.isPublishingControl()|| $parent.isGlobalLockEnabled() , visible: $parent.idStatus() != 6 || ($parent.idStatus() == 6 && $parent.permissions()['article_edit_publishingControl'].write),event: { click: $parent.onClickDeleteFaq }"><span class="hide">Delete</span></button>
                                                            <button class="btn-form icon i-edit" type="button" data-bind="disable: $parent.isPublishingControl() || $parent.isGlobalLockEnabled(), visible: $parent.idStatus() != 6 || ($parent.idStatus() == 6 && $parent.permissions()['article_edit_publishingControl'].write),event: { click: $parent.onClickEditFaq.bind($data, $index())  }"><span class="hide">Edit</span></button>
                                                        </div>
                                                    </div>
                                                    <strong data-bind="text: $data.question">Question</strong>
                                                    <p data-bind="html: $data.answer"></p>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <!-- /ko -->
                            </div>


                         
                        </div>
                        
                           <div class="w-tabs-content" data-bind="css: { 'is-showing' : selectedTab() == 'widgets'}">

                                    <div class="w-form-body">

                                     <div class="form-body full-width">

                                        <div data-bind="visible: !showSummary()" >
                                             <strong class="form-sub-title">Summaries</strong>

                                            <div class="form-group no-result">
                                                <span class="icon i-review"></span>
                                                <h2 class="form-title no-margin">This article is not currently eligible for this feature.</h2>
                                            </div>
                                        </div>
                                        <div id="widgets-section-summary" data-bind="visible: showSummary()">

                                             <!--<div class="form-group row start" style="margin-top: .5rem">
                                                 <div class="form-check-inline" style="width: auto;">
                                                     <input type="checkbox" data-bind="attr: { readonly : isPublishingControl() || isGlobalLockEnabled() },checked: updateSummariesWithContent" class="input-checkbox" id="updateSummariesWithContent">
                                                     <label class="form-label icon i-check" for="updateSummariesWithContent">Enable</label>
                                                 </div>
                                                 <div class="w-tooltips-adv pos-bottom short" style="margin-top: .5rem">
                                                 </div>
                                             </div>-->
                                             <div class="form-group widget-controls" style="margin-top: .5rem">

                                                <button class="btn highlight" type="button" data-bind="attr: { disabled : isPublishingControl() || isGlobalLockEnabled() }, click: onClickGenerateArticleSummaries">Generate Article Summaries</button>
                                                <div class="form-check-inline" style="width: auto;">
                                                     <input type="checkbox" data-bind="checked: isFactualSummaryEnabled" class="input-checkbox" id="isFactualSummaryEnabled">
                                                     <label class="form-label icon i-check" for="isFactualSummaryEnabled">Factual Summary</label>
                                                 </div>
                                                 <div class="form-check-inline" style="width: auto;">
                                                     <input type="checkbox" data-bind="checked: isSimpleSummaryEnabled" class="input-checkbox" id="isSimpleSummaryEnabled">
                                                     <label class="form-label icon i-check" for="isSimpleSummaryEnabled">Simple Summary</label>
                                                 </div>
                                                 <div class="form-check-inline" style="width: auto;">
                                                     <input type="checkbox" data-bind="checked: isSatiricalCommentaryEnabled" class="input-checkbox" id="isSatiricalCommentaryEnabled">
                                                     <label class="form-label icon i-check" for="isSatiricalCommentaryEnabled">Lighthearted Summary</label>
                                                 </div>                                                 
                                             </div>

                                            <div class="form-group">
                                                <label class="form-label">Factual Summary</label>
                                                <textarea id="factualSummary" name="factualSummary" class="input-text" data-bind=" value: factualSummary"></textarea>
                                            </div>

                                            <div class="form-group">
                                                <label class="form-label">Simple Summary</label>
                                                <textarea id="simpleSummary" name="simpleSummary" class="input-text" data-bind="value: simpleSummary"></textarea>
                                            </div>
                                      
                                            <div class="form-group">
                                                <label class="form-label">Lighthearted Summary</label>
                                                <textarea id="satiricalCommentary" name="satiricalCommentary" class="input-text" data-bind="value: satiricalCommentary"></textarea>
                                            </div>
                                   </div>
                                    </div>       
                            </div>

                        </div>

                        <!-- end w-tabs-content -->
                        <!-- ----------------- -->
                        <!-- Revision          -->
                        <!-- ----------------- -->
                        <div class="w-tabs-content" data-bind="css: { 'is-showing' : selectedTab() == 'revision'}"><!-- .is-showing -->

                            <div class="w-form-body revision"  data-bind="visible: revisions().length > 0">
                                <div class="form-body side">
                                    <div class="form-group">
                                        <ul class="user-list" data-bind="foreach: revisions">
                                            <li class="user-item" data-bind="css: { 'is-selected' : $index() == $parent.selectedRevisionIndex() }">
                                                 <button class="user-link" type="button" data-bind="event: {click: $parent.onClickRevision.bind($data, $index) }">
                                                    <div>
                                                        <strong class="side" data-bind="text: $data.dateCreated" ></strong>
                                                        <span data-bind="if: $data.content.author"><span data-bind="text: $data.content.author.valnet_user.fullName"></span></span>
                                                    </div>
                                                 </button>
                                            </li>
                                        </ul>

                                    </div>
                                </div>
                                <div class="form-body revision">
                                    <div class="form-group-header">
                                        <button class="btn-form icon i-compare" type="button" data-bind="disable: isGlobalLockEnabled() , css: {  'is-selected' : revisions().length > 1 && !isGlobalLockEnabled() }, event: { click: onClickCompareRevision }">compare</button>
                                        <!-- <button class="btn-form no-bg icon i-revision" type="button" data-bind="visible: idStatus() != 6 || permissions()['article_edit_publishingControl'].write, event: { click: onClickRevertRevision }">Revert</button>-->
                                        <button class="btn-form no-bg icon i-revision" type="button" data-bind="disable: isPublishingControl() || isGlobalLockEnabled(), event: { click: checkIfReviewItemsNeedAnUpdate.bind($data, 'revision') }">Revert</button>
                                    </div>

                                    <div class=" buyers-guide">
                                        ${this.revisionReviewSection.getHtmlBuild()}
                                    </div>

                                    <div class="w-content">
                                        <strong class="form-sub-title content" >Content</strong>
                                        <div class="form-group" data-bind="html: revisionContent"></div>
                                    </div>

                                    <div>
                                     ${this.revisionDirectory.getHtmlBuild()}
                                    </div>

                                </div>

                            </div>
                            <div class="w-form-body revision" data-bind="visible: revisions().length == 0">
                                <div class="form-group full-width">
                                    <p>No Revision Available</p>
                                </div>
                            </div>

                        </div><!-- end w-tabs-content -->

                        <!-- ----------------- -->
                        <!-- Sandbox          -->
                        <!-- ----------------- -->
                        <div class="w-tabs-content" data-bind="css: { 'is-showing' : selectedTab() == 'sandbox'}"><!-- .is-showing -->

                            <div class="w-form-body">

                                <div class="form-body full-width">

                                    <div class="form-group w-justify" style="margin-bottom: 0;">
                                        <div class="w-left">
                                            <button class="btn-form light icon i-article-regular" data-bind="event: { click: checkIfReviewItemsNeedAnUpdate.bind($data, 'sandbox') }, visible: selectedTab() == 'sandbox', disable: (isPublishingControl() || isGlobalLockEnabled() || isSaveButtonDisabled()),  text: isSaveButtonDisabled() ? 'Autosaving...' : 'Insert Sandbox into Content'" type="button"></button>
                                            <button class="btn-form icon light" style="margin-left: 1rem" type="button" data-bind="event: { click: onClickDeleteSandbox}, text: 'Delete Sandbox'"></button>
                                        </div>
                                        <div class="w-right">
                                            <button class="btn-form icon i-compare" type="button" data-bind="disable : isGlobalLockEnabled(), css: {  'is-selected' : isSandboxContent()  && revisions().length > 0}, event: { click: onClickCompareSandbox.bind($data, 'sandbox')  }">Compare To Latest Revision</button>
                                            <button class="btn-form icon light" style="margin-left: 1rem" type="button" data-bind="disable: isGlobalLockEnabled() ,event: { click: onClickPreviewNoSave.bind($data, 'sandbox') }, text: 'Preview Sandbox'"></button>
<!--                                            <button class="btn-form icon light" style="margin-left: 1rem" type="button" data-bind="disable: isGlobalLockEnabled(), visible: idTemplate() != 5 && idTemplate() != 6 && idTemplate() != 8, event: { click: onClickPreviewAMPNoSave.bind($data, 'sandbox') }, text: 'Preview AMP Version of Sandbox'"></button>-->
                                        </div>
                                    </div>
                                    ${this.productReviewSandbox.getHtmlBuild()}
                                    ${this.sandboxContent.getHtmlBuild()}
                                </div>
                            </div>
                            ${this.sandboxDirectory.getHtmlBuild()}
                        </div><!-- end w-tabs-content -->


                        <!-- ----------------- -->
                        <!-- Republish          -->
                        <!-- ----------------- -->
                        <div class="w-tabs-content" data-bind="css: { 'is-showing' : selectedTab() == 'republish' }"><!-- .is-showing -->

                            <div class="w-form-body">

                                <div class="form-body">

                                    <div class="form-group w-justify" style="margin-bottom: 0;flex-wrap:wrap;">
                                        <div class="w-left">
                                            <button class="btn-form icon light alert align-left icon i-redo" style="margin-left: 1rem;width: 241px;" type="button" data-bind="disable: idRepublishStatus() != 6 || isPublishingControl() || isGlobalLockEnabled() ,event: { click: onClickRepublishCreateAndUpdate }, text: 'Create Republish and Update Article Content with this Version'"></button>
                                            <button class="btn-form icon light alert no-wrap icon i-delete" style="margin-left: 1rem" type="button" data-bind="event: { click: onClickDeleteRepublish}, text: 'Delete Republish'"></button>

                                        </div>
                                        <div class="w-right">
                                            <button class="btn-form icon i-compare" type="button" data-bind="disable : isGlobalLockEnabled(), css: {  'is-selected' : revisions().length > 0}, event: { click: onClickCompareSandbox.bind($data, 'republish') }">Compare To Latest Revision</button>
                                            <button class="btn-form icon light no-wrap icon i-view" style="margin-left: 1rem" type="button" data-bind="disable: isGlobalLockEnabled() ,event: { click: onClickPreviewNoSave.bind($data, 'republish')}, text: 'Preview Republish'"></button>

                                        </div>

                                    </div>

                                </div>

                            </div>

                            <div class="w-form-body republish">
                                <strong class="form-sub-title secondary">Republish</strong>
                                <div class="form-body">
                                    <strong class="form-sub-title">Information</strong>
                                    <div class="form-group inside-label date">
                                        <label class="form-label">republish date</label>
                                        ${this.republishDatePicker.getHtmlBuild()}
                                    </div>
                                    <div class="form-group">
                                        <hr>
                                    </div>
                                    <div class="form-group" style="margin: 2rem 2rem">
                                        <label  class="form-label">Status</label>
                                         <select id="idStatusRepublish" data-bind="disable: (idRepublishStatus() == 6 && isPublishingControl()) || isGlobalLockEnabled(), options: articleRepublishStatus_options, optionsText: 'name', value: idRepublishStatus, optionsValue: 'id', event: {change: onChangeArticleStatus}"></select>
                                    </div>
                                    <div class="form-group">
                                        <hr>
                                    </div>
                                    <div class="form-group form-check-inline" data-bind="if: permissions()['article_edit_embargo'].read" style="margin: 0 2rem">
                                        <input type="checkbox" data-bind="disable: !permissions()['article_edit_embargo'].write || isPublishingControl() || isGlobalLockEnabled(), checked: republishIsUnderEmbargo" id="rep-under-embargo">
                                        <label for="rep-under-embargo" class="form-label icon i-check" style="line-height: 1.3;">Republish Under Embargo</label>
                                    </div>
                                </div>

                                <div class="form-body">

                                    <strong class="form-sub-title">Contributors</strong>


                                    <div class="form-group inside-label">
                                        <label for="authorName" class="form-label">Author</label>
                                         ${this.filterUser_republish_author.getHtmlBuild()}
                                    </div>

                                    <div class="form-group inside-label">
                                        <label for="srEditorName" class="form-label">Segment Lead</label>
                                         ${this.filterUser_republish_SrEditor.getHtmlBuild()}
                                    </div>

                                    <div class="form-group inside-label">
                                        <label for="jrEditorName" class="form-label">Editor</label>
                                         ${this.filterUser_republish_JrEditor.getHtmlBuild()}
                                    </div>
                                </div>

                                <div class="form-body">

                                    <strong class="form-sub-title">Payment</strong>

                                    <div class="form-group row">
                                        <label class="form-label" style="width: 16rem">Payment Category</label>
                                        <div style="width: 100%">
                                            ${this.paymentCategoryFilter.getHtmlBuild()}
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <hr>
                                    </div>

                                     <!--Payment type dropdown-->

                                    <div class="form-group row">
                                        <label class="form-label" style="width: 16rem;">Author Payment</label>
                                        <select
                                        data-bind="options: paymentTypeRepublish,
                                                   optionsCaption: 'Choose a payment type',
                                                   optionsValue: 'name',
                                                   optionsText: 'name' ,
                                                   value: choosenPaymentTypeRepublish,
                                                   event : {change : onChangepaymentTypeRepublish } "
                                                   >
                                        </select>
                                    </div>
                                     <!-- Show Input -->
                                    <div class="form-group row" data-bind="visible: choosenPaymentTypeRepublish">
                                        <!-- ko if: choosenPaymentTypeRepublish() == 'Amount' -->

                                        <div  style="display: flex;align-items: center;width: 50%;">
                                            <input  id="amountAuthor"
                                                style="text-transform: capitalize;margin-right: 1rem"
                                                data-bind="disable: !permissions()['article_edit_publishingControl'].write, value: amountAuthor, attr: { 'placeholder':  choosenPaymentTypeRepublish().toLowerCase() }"
                                                class="input-text"
                                                type="number"
                                                min="0"
                                            >
                                            <span class="form-indic">$</span>
                                        </div>

                                        <!-- /ko -->

                                        <!-- ko if: choosenPaymentTypeRepublish() == 'Percentage' -->

                                        <div style="display: flex;align-items: center;width: 50%;">
                                            <input  id="percentageAuthor"
                                                style="text-transform: capitalize;margin-right: 1rem"
                                                data-bind=" disable: !permissions()['article_edit_publishingControl'].write,
                                                            value: percentageAuthor,
                                                            attr: { 'placeholder':  choosenPaymentTypeRepublish().toLowerCase() }"
                                                class="input-text"
                                                type="number"
                                                min="0"
                                                max="999"
                                                step="any"
                                            >
                                            <span class="form-indic">%</span>
                                        </div>
                                        <!-- /ko -->
                                    </div>


                                    <div class="form-group">
                                        <hr>
                                    </div>

                                    <!-- Edirepublish-newtor percentage (Always %) -->
                                    <div class="form-group inside-label row start">
                                        <label class="form-label" style="width: 12rem;">Editor Payment</label>
                                        <div style="display: flex;align-items: center;width: 50%;">
                                            <input
                                                data-bind=" disable: !permissions()['article_edit_publishingControl'].write,
                                                            value: percentageEditor,
                                                            attr: { 'placeholder': 'Percentage' }"
                                                class="input-text num"
                                                type="number"
                                                min="0"
                                                max="999"
                                                step="any"
                                                style="margin-right: 1rem"
                                            >
                                            <span class="form-indic">%</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="w-form-body">

                                    ${this.productReviewRepublish.getHtmlBuild()}
                                    <div style="width: 100%">
                                        ${this.republishContent.getHtmlBuild()}
                                    </div>


                            </div>
                            ${this.republishDirectory.getHtmlBuild()}
                        </div><!-- end w-tabs-content -->


                        <!-- ----------------- -->
                        <!-- Recovery          -->
                        <!-- ----------------- -->
                        <div class="w-tabs-content" data-bind="css: { 'is-showing' : selectedTab() == 'recovery'}"><!-- .is-showing -->

                            <div class="w-form-body recovery">
                               <div class="form-body full-width block" data-bind="visible: recoveryContent() != null || sandboxRecoveryContent() != null || republishRecoveryContent() != null">
                                    <div class="form-group-header tabs">
                                        <div class="form-group w-sub-tab">
                                            <button class="btn is-selected" type="button" data-bind="event: { click: onClickRecoveryTab }, css: { 'is-selected' : selectedRecoveryTab() == 'content'}">Content</button>
                                            <button class="btn" type="button" data-bind="visible: sandboxRecovery() != '', event: { click: onClickSandboxRecoveryTab }, css: { 'is-selected' : selectedRecoveryTab() == 'sandbox'}">Sandbox</button>
                                            <button class="btn" type="button" data-bind="visible: republishRecovery() != '', event: { click: onClickRepublishRecoveryTab }, css: { 'is-selected' : selectedRecoveryTab() == 'republish'}">Republish</button>
                                        </div>
                                         <div class="user-link">
                                            <!--<img src="/assets/images/default-user.png" alt="">-->
                                            <div style="text-align: left">
                                                <strong data-bind="text: dateRecovery"></strong>
                                                <span data-bind="text: recoveryUser"></span>
                                            </div>
                                         </div>
                                     </div>
                                </div>
                                <div class="form-body full-width is-selected " data-bind="visible: recoveryContent() != null || sandboxRecoveryContent() != null || republishRecoveryContent() != null">
                                    <div class="form-group-header border row">

                                        <button class="btn-form icon i-compare" type="button" data-bind="disable: isGlobalLockEnabled() , event: { click: onClickCompareRecovery.bind($data, 'content') }, css: {  'is-selected' :  revisions().length > 0 && !isGlobalLockEnabled()  }, visible: (selectedRecoveryTab() == 'content' && (idStatus() != 6 || permissions()['article_edit_publishingControl'].write))">Compare To Latest Revision</button>
                                        <!--<button class="btn-form icon i-revision" type="button" data-bind="event: { click: onClickRevertRecovery }, visible: (selectedRecoveryTab() == 'content' && (idStatus() != 6 || permissions()['article_edit_publishingControl'].write))">Revert Content</button>-->

                                        <button class="btn-form icon i-revision" type="button" data-bind="event: { click: checkIfReviewItemsNeedAnUpdate.bind($data, 'recovery') }, visible: selectedRecoveryTab() == 'content', disable: (isSaveButtonDisabled() || (selectedRecoveryTab() == 'content' && (isPublishingControl() || isGlobalLockEnabled()))),  text: isSaveButtonDisabled() ? 'Autosaving...' : 'Revert Content'"></button>
                                        <button class="btn-form icon i-compare" type="button" data-bind="event: { click: onClickCompareRecovery.bind($data, 'sandbox') }, css: {  'is-selected' : selectedRecoveryTab() == 'sandbox' && isSandboxContent()}, visible: selectedRecoveryTab() == 'sandbox', disable : isPublishingControl() || isGlobalLockEnabled() ">Compare To SandBox</button>
                                        <button class="btn-form icon i-compare" type="button" data-bind="event: { click: onClickCompareRecovery.bind($data, 'republish') }, css: {  'is-selected' : selectedRecoveryTab() == 'republish'}, visible: selectedRecoveryTab() == 'republish', disable : isPublishingControl() || isGlobalLockEnabled() ">Compare To Republish</button>
                                        <button class="btn-form icon i-revision" type="button" data-bind="event: { click: onClickRevertSandboxRecovery }, visible: selectedRecoveryTab() == 'sandbox', disable: isSaveButtonDisabled() || isGlobalLockEnabled() ,  text: isSaveButtonDisabled() ? 'Autosaving...' : 'Revert Sandbox'"></button>
                                        <button class="btn-form icon i-revision" type="button" data-bind="event: { click: onClickRevertRepublishRecovery }, visible: selectedRecoveryTab() == 'republish', disable: isSaveButtonDisabled() || isGlobalLockEnabled() ,  text: isSaveButtonDisabled() ? 'Autosaving...' : 'Revert Republish'"></button>
                                    </div>

                                    <div data-bind="visible: selectedRecoveryTab() == 'content'">

                                        <div class="form-group w-content buyers-guide">
                                            ${this.recoveryReviewSection.getHtmlBuild()}
                                        </div>

                                        <div class="form-group w-content">
                                            <strong class="form-sub-title content" >CONTENT</strong>
                                            <div data-bind="html: recoveryContent" ></div>
                                        </div>

                                         <div class="">
                                            ${this.recoveryDirectory.getHtmlBuild()}
                                        </div>

                                    </div>

                                    <div data-bind="visible: selectedRecoveryTab() == 'sandbox'">

                                        <div class="form-group w-content buyers-guide">
                                            ${this.recoverySandboxReviewSection.getHtmlBuild()}
                                        </div>

                                        <div class="form-group w-content">
                                            <strong class="form-sub-title content" >CONTENT</strong>
                                            <div data-bind="html: sandboxRecoveryContent" ></div>
                                        </div>

                                        <div class="form-group w-content">
                                            ${this.recoverySandboxDirectory.getHtmlBuild()}
                                        </div>
                                    </div>

                                    <div data-bind="visible: selectedRecoveryTab() == 'republish'">

                                        <div class="form-group-group" data-bind="visible: republishRecovery() && republishRecovery().republishes && republishRecovery().republishes.length > 0">
                                            <div class="form-group">
                                                <label class="form-label">Republish Date:</label>
                                                <span data-bind="text: republishRecoveryDate"></span>
                                            </div>
                                            <div class="form-group">
                                                <label class="form-label">Status:</label>
                                                <span data-bind="text: republishRecoveryStatus"></span>
                                            </div>
                                            <div class="form-group">
                                                <label class="form-label">Author:</label>
                                                <span data-bind="text: republishRecoveryAuthor"></span>
                                            </div>
                                            <div class="form-group">
                                                <label class="form-label">Sr Editior:</label>
                                                <span data-bind="text: republishRecoverySrEditor"></span>
                                            </div>
                                            <div class="form-group">
                                                <label class="form-label">Jr Editor:</label>
                                                <span data-bind="text: republishRecoveryJrEditor"></span>
                                            </div>
                                            <div class="form-group">
                                                <label class="form-label">Payment category:</label>
                                                <span data-bind="text: republishRecoveryPaymentCategory"></span>
                                            </div>
                                            <div class="form-group">
                                                <label class="form-label">Author Amount:</label>
                                                <span data-bind="text: republishRecoveryAuthorAmount"></span>
                                            </div>
                                            <div class="form-group">
                                                <label class="form-label">Author Percentage:</label>
                                                <span data-bind="text: republishRecoveryAuthorPercentage"></span>
                                            </div>
                                            <div class="form-group">
                                                <label class="form-label">Editor Payment:</label>
                                                <span data-bind="text: republishRecoveryEditorPercentage"></span>
                                            </div>

                                        </div>

                                        <div class="form-group w-content buyers-guide">
                                            ${this.recoveryRepublishReviewSection.getHtmlBuild()}
                                        </div>

                                        <div class="form-group w-content">
                                            <strong class="form-sub-title content" >CONTENT</strong>
                                            <div data-bind="html: republishRecoveryContent" ></div>
                                        </div>

                                        <div class="form-group w-content">
                                            ${this.recoveryRepublishDirectory.getHtmlBuild()}
                                        </div>
                                    </div>

                                </div>

                            </div>

                            <div class="w-form-body" data-bind="visible: recoveryContent() == null && sandboxRecoveryContent() == null && republishRecoveryContent() == null">
                                <div  class="form-group full-width">
                                    <p>No Recovery Available</p>
                                </div>
                            </div>


                        </div><!-- end w-tabs-content -->

                        <!-- ----------------- -->
                        <!-- Analytics         -->
                        <!-- ----------------- -->


                        <div class="w-tabs-content" data-bind="css: { 'is-showing' : selectedTab() == 'analytics'}"><!-- .is-showing -->
                            ${this.articleAnalytics.getHtmlBuild()}
                        </div>
                        <!-- end w-tabs-content -->

                        <!-- ----------------- -->
                        <!-- Reviews         -->
                        <!-- ----------------- -->


                        <div class="w-tabs-content" data-bind="css: { 'is-showing' : selectedTab() == 'reviews'}"><!-- .is-showing -->
                            ${this.articleReviewHistory.getHtmlBuild()}
                        </div>
                        <!-- end w-tabs-content -->

                        <!-- ----------------- -->
                        <!-- Newsletter        -->
                        <!-- ----------------- -->
                        <div class="w-tabs-content" data-bind="css: { 'is-showing' : selectedTab() == 'newsletter'}"><!-- .is-showing -->
                            <div class="w-form-body">
                                <div class="form-body full-width">
                                    <strong class="form-sub-title secondary" >INFORMATION</strong>
                                    <div class="form-group">
                                        <label for="subject" class="form-label">Subject</label>
                                        <div class="row link">
                                            <input id="subject" data-bind="value: newsletterSubject" type="text" class="input-text">
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="previewText" class="form-label">Preview Text</label>
                                        <div class="row link">
                                            <input id="previewText" data-bind="value: newsletterPreviewText" type="text" class="input-text">
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="w-recipents">
                                            <div>
                                                <label for="date" class="form-label">Template</label>
                                                ${this.newsletterTemplateSelector.getHtmlBuild()}
                                            </div>
                                            <div style="margin-left:1rem">
                                                <label for="date" class="form-label">Date Scheduled</label>
                                                ${this.newsletterDateScheduledSelector.getHtmlBuild()}
                                            </div>
                                        </div>
                                    </div>
                                    <strong class="form-sub-title secondary">Recipients</strong>
                                    <strong class="form-sub-title content">MAILING LISTS</strong>

                                  <div class="form-group mailinglist" >
                                      <div data-bind="foreach: newsletterMailingLists">
                                              <input type="checkbox" data-bind="attr: {id: 'recipient' + id}, value: id, checked: $parent.selectedMailingLists">
                                              <label class="form-label icon i-check"  data-bind="text: name, attr: {for: 'recipient' + id}"></label>
                                      </div>
                                  </div>
                                  <strong class="form-sub-title content">SPECIFIC EMAIL ADDRESSES</strong>
                                  <div class="form-group custom-mailing-list " data-bind="class: newsletterEmailErrors().length > 0 ? 'is-error' : ''">
                                      <label for="customRecipients" class="form-label">Custom
                                          <div class="w-tooltips-adv pos-far-right short" style="display: inline-block;transform: translateY(4px);">
                                          ${this.customRecipientsToolTipButton.getHtmlBuild()}
                                          </div>
                                      </label>
                                      <textarea id="customRecipients" data-bind="value: newsletterRecipientsEmails" type="text" class="input-text">
                                      </textarea>
                                      <ul data-bind="visible: newsletterEmailErrors().length > 0, foreach: newsletterEmailErrors" class="errors">
                                          <li data-bind="text: $data"></li>
                                      </ul>
                                  </div>
                                  <div class="form-group">
                                          <input id="myself" data-bind="checked: newsletterSendToSelf, value: 'self'" type="checkbox">
                                          <label for="myself" class="form-label icon i-check">Send to Email Address of Logged In User</label>
                                  </div>
                                    <div class="form-footer">
                                        <button class="btn highlight" data-bind="event: { click: onClickSendNewsletter }, text: 'Send', visible: permissions()['newsletter_email_edit'].write">Send</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- end w-tabs-content -->

                    </div>

                     <!-- ----------------- -->
                     <!-- SIDE FORM         -->
                     <!-- ----------------- -->

                     <div class="w-form w-form-side">
                            <div class="w-form-side-header">
                                <div class="form-side-header" data-bind="css: { 'is-locked': isArticleLocked(), 'is-autosave-error': isArticleAutoSaveError() }">
                                <div class="w-savetime" data-bind="css: {  'is-lastsave-shown': showAutoSaveMessage(), 'is-lastsave-hidden': !showAutoSaveMessage(), 'is-autosaving': showIsAutosaving }">
                                     <div class="w-icon">
                                            <span class="icon"></span>
                                      </div>
                                      <span class="message-save">Last Autosaved:</span>
                                      <span class="message-save" data-bind="text: lastSaved"></span>
                                      <span class="message-lock">ARTICLE</span>
                                      <span class="message-lock">LOCKED</span>
                                      <span class="message-autosaving">Autosaving...</span>
                                </div>
                                <button data-bind="event: { click: onClickCancel }, css: { 'is-disable' : isSaveButtonDisabled() && !isArticleLocked() }, disable: isSaveButtonDisabled() && !isArticleLocked()" class="btn " type="button">Cancel</button>
                                <button data-bind="event: { click: onClickSave }, css: { 'is-disable' : isSaveButtonDisabled() || isArticleLocked() }, text: 'Save'"   class="btn highlight" type="button">Save</button>
                                <button class="btn highlight" type="button" data-bind="event: { click: onClickSaveAndStay }, css: { 'is-disable' : isSaveButtonDisabled() || isArticleLocked() }, text: 'Save & Stay'">Save & Stay</button>
                            </div>
                            </div>
                            <div class="w-form-body">

                            <div class="form-body full-width">

                                <!-- -----------------      -->
                                <!-- Article Information -->
                                <!-- -----------------      -->

                                <div>

                                    <strong class="form-sub-title">Article Information</strong>

                                    <div class="form-group-group">
                                        <div class="form-group">
                                            <label for="" class="form-label form-label-box">Type</label>
                                            <select name="" id="template_selector" data-bind="disable: isPublishingControl() || isGlobalLockEnabled(), value: idTemplate, optionsCaption: 'Select', valueAllowUnset: true, event: { change: onChangeTemplate }">
                                                <option value="2">Regular</option>
                                                <option value="3">List</option>
                                                <option value="5" disabled>Product Review</option>
                                                <option value="6" disabled>Buyer's Guide</option>
                                                <option value="9">Buyer's Guide Light</option>
                                                <option value="10">Deals</option>
                                                <option value="12">Collection</option>
                                                <option value="7">Directory</option>
                                                <option value="11">Versus</option>
                                                <option value="13">Sub-Content</option>
                                                <option value="14">How to Watch</option>
                                                <option value="${ID_TEMPLATE_VIDEO}">Video</option>
                                                <option value="${ID_TEMPLATE_THREAD}">Thread</option>
                                            </select>
                                        </div>

                                        <div class="form-group">
                                            <label for="" class="form-label form-label-box">Template</label>
                                            <select id="template_layout_selector" data-bind="visible: true, disable: isPublishingControl() || isGlobalLockEnabled(), options: templateLayoutsFiltered, optionsText: 'name', optionsValue: 'id', value: idTemplateLayout, valueAllowUnset: true, event: { change: onChangeTemplateLayout }">
                                            </select>
                                        </div>

                                        <div class="form-group">
                                            <label class="form-label">Article ID</label>
                                            <span data-bind="text: id"></span>
                                        </div>

                                        <div class="form-group">
                                            <label class="form-label">Original Publish</label>
                                            <span data-bind="text: datePublished"></span>
                                        </div>
                                        <div class="form-group">
                                            <label class="form-label">Display Date</label>
                                            <span data-bind="text: dateMostRecentPublishStatus"></span>
                                        </div>

                                        <!-- ko if: articlePageSettings()['isTimeUpdateEnable'] && datePublished().substr(0, 10) == new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10) && idPublishStatus() == 3 && republishes().length == 0 -->
                                        <div class="form-group row" style=";flex:1 50%; margin-right: 10rem;">
                                            <input type="checkbox" data-bind="checked: isUpdateTime, disable: !permissions()['article_edit_publishingControl'].write" id="update-time">
                                            <label for="update-time" class="form-label icon i-check">Update Display Date to Current Time</label>
                                            <div class="w-tooltips-adv pos-far-left mini" style="margin-top: .5rem">
                                                ${this.updateTimeToolTipButton.getHtmlBuild()}
                                            </div>
                                        </div>
                                        <!-- /ko -->

                                        <div class="form-group">
                                            <label class="form-label">Created On</label>
                                            <span data-bind="text: dateCreated"></span>
                                        </div>
                                        <div class="form-group">
                                            <label class="form-label">Last Updated</label>
                                            <span data-bind="text: dateUpdated"></span>
                                        </div>

                                        <div class="form-group" style="flex:1 50%" data-bind="visible: segments().length > 0 ">
                                            <label for="idSegment" class="form-label form-label-box">Segment</label>
                                            <select id="idSegment" data-bind="disable: isPublishingControl() || isGlobalLockEnabled(), options: segment_options, optionsText: 'name', value: idSegment, optionsValue: 'id'"></select>
                                        </div>

                                        <div class="form-group">
                                            <label for="idClassification" class="form-label form-label-box">Classification</label>
                                            <select id="idClassification" data-bind="disable: isPublishingControl() || isGlobalLockEnabled(), options: classificationOptions, optionsText: 'name', value: idClassification, optionsValue: 'id'"></select>
                                            <!--<span data-bind="text: classificationName"></span>-->
                                        </div>

                                        <div class="form-group" style="flex:1 50%">
                                             <label for="template" class="form-label form-label form-label-box">Visibility</label>
                                             <select name="" id="" data-bind="disable: !permissions()['article_edit_publishingControl'].write || isGlobalLockEnabled(), value: displayConfiguration">
                                                <option value="1">Visible Everywhere</option>
                                                <option value="2">Hide From Homepage</option>
                                                <option value="3">Hide From Website</option>
                                                <option value="4">Hide From Trending</option>
                                                <option value="24">Hide From Homepage and Trending</option>
                                            </select>
                                        </div>
                                        <div class="form-group form-check-inline" data-bind="if: permissions()['article_edit_embargo'].read">
                                            <input type="checkbox" data-bind="disable: !permissions()['article_edit_embargo'].write || isPublishingControl() || isGlobalLockEnabled(), checked: isUnderEmbargo" id="under-embargo">
                                            <label for="under-embargo" class="form-label icon i-check" style="line-height: 1.3;">Under Embargo</label>
                                        </div>
                                        <div class="form-group form-check-inline" style="flex:1 50%">
                                            <div id="sensai-progress-bar-container">

                                            <!-- ko if : idTemplate() != ${ID_TEMPLATE_VIDEO} && idTemplate() != ${ID_TEMPLATE_THREAD} -->
                                                ${this.sensaiProgressBar.getHtmlBuild()}
                                            <!-- /ko -->
                                            </div>
                                        </div>

                                        <!--<div class="form-group">
                                            <label class="form-label">User that updated</label>
                                            <span>user</span>
                                        </div>-->

                                    </div>



                                </div>

                                <!-- ----------------- -->
                                <!-- Status            -->
                                <!-- ----------------- -->


                                <div class="status">
                                    <strong class="form-sub-title">Status</strong>

                                    <div class="form-group row">
                                         <label for="idStatus" class="form-label form-label-box">Article Status</label>
                                         <select id="idStatus" data-bind="disable: isPublishingControl() || isGlobalLockEnabled() || selectedTab() == 'republish', options: articleStatus_options, optionsText: 'name', value: idStatus, optionsValue: 'id', event: {change: onChangeArticleStatus}"></select>
                                         <div>
                                            <label class="form-label">Last Article Status</label>
                                            <span data-bind="text: dateLastStatus()"><span>
                                         </div>
                                    </div>

                                    <div class="form-group row no-border">
                                         <label for="idPublishStatus" class="form-label form-label-box">Publish Status</label>
                                         <select id="idPublishStatus" data-bind="
                                         disable: !permissions()['article_edit_publishingControl'].write ||
                                         isGlobalLockEnabled() || selectedTab() == 'republish', options: publishStatuses, optionsText: 'name', value: idPublishStatus, optionsValue: 'id', event: {change: onChangePublishStatus}"></select>
                                         <div>
                                            <label class="form-label">Last Publish Status</label>
                                            <span data-bind="text: dateLastPublishStatus()"><span>
                                         </div>
                                    </div>

                                    <div class="form-group inside-label date-w no-border" data-bind="visible: idPublishStatus() == 2">
                                        <label for="scheduleDatePicker" class="form-label">Schedule Date</label>
                                        ${this.scheduleDatePicker.getHtmlBuild()}
                                    </div>

                                   <div class="form-group row ">
                                         <div>
                                            <label for="" class="form-label">Sync Status</label>
                                             <span data-bind="text: syncStatus().toUpperCase()"></span>
                                         </div>
                                         <div>
                                            <label class="form-label">Last Sync</label>
                                            <span data-bind="text: dateLastSyncStatus()"><span>
                                         </div>
                                    </div>


                                </div>



                                <!-- ----------------- -->
                                <!-- Contributors      -->
                                <!-- ----------------- -->

                                <div class="contributors">
                                    <strong class="form-sub-title">Contributors</strong>

                                    <div class="form-group inside-label">
                                            <label for="authorName" class="form-label">Author</label>
                                             ${this.filterUser_author.getHtmlBuild()}
                                    </div>

                                    <div class="form-group inside-label">
                                            <label for="authorName" class="form-label label-tooltips">
                                                Display Authors
                                                <button class="w-tooltips icon i-tooltips" type="button">
                                                    <span class="tooltips">If this field is empty, the article on the website will have the name (and be on the author page) of the Author of this article.  If another user is tagged here, the article on the website will be attributed to the tagged user instead.  <br> <br>Note: this only effects what is used on the website, not in Emaki.</span>
                                                </button>

                                            </label>
                                             ${ this.filterUser_display_author.getHtmlBuild() }
                                             ${ this.display_authors.getHtmlBuild() }
                                    </div>

                                    <div class="form-group inside-label">
                                            <label for="srEditorName" class="form-label">Segment Lead</label>
                                             ${this.filterUser_SrEditor.getHtmlBuild()}
                                    </div>


                                    <div class="form-group inside-label">
                                            <label for="jrEditorName" class="form-label">Editor</label>
                                             ${this.filterUser_JrEditor.getHtmlBuild()}
                                    </div>

                                    <div class="form-group inside-label">
                                            <label for="ideatorName" class="form-label">Ideator</label>
                                             ${this.filterUser_ideator.getHtmlBuild()}
                                    </div>
                                </div>


                                <!-- ----------------- -->
                                <!-- Categorization    -->
                                <!-- ----------------- -->
                                <div class="form-section cat">
                                    <strong class="form-sub-title">Categorization</strong>

                                    <div class="form-group">
                                        <label for="idPaymentCategory" class="form-label form-label-box">Payment Category</label>
                                        <select id="idPaymentCategory" data-bind="disable: !permissions()['article_edit_publishingControl'].write || isGlobalLockEnabled(), options: paymentCategory_options, optionsText: 'name', value: idPaymentCategory, optionsValue: 'id'"></select>
                                    </div>

                                    <div class="form-group">
                                        <label for="idNetworkCategory" class="form-label form-label-box">Network Category</label>
                                        <select id="idNetworkCategory" data-bind="disable: isPublishingControl() || isGlobalLockEnabled() , options: networkCategory_options, optionsText: 'name', value: idNetworkCategory, optionsValue: 'id'"></select>
                                    </div>

                                    <div class="form-group">
                                        <label for="idContentType" class="form-label form-label-box">Content Type</label>
                                        <select id="idContentType" data-bind="disable: isPublishingControl() || isGlobalLockEnabled(), options: contentType_options, optionsText: 'name', value: idContentType, optionsValue: 'id'"></select>
                                    </div>

                                    <div class="form-group">
                                        <label for="idIntent" class="form-label form-label-box">Intent</label>
                                        <select id="idIntent" data-bind="disable: isPublishingControl() || isGlobalLockEnabled(), options: intent_options, optionsText: 'name', value: idIntent, optionsValue: 'id'"></select>
                                    </div>
                                    <!-- ---------------- -->
                                    <!--    SENSAI CHAT   -->
                                    <!-- ---------------- data-bind="visible: isAdmin()" -->
                                    <div class="form-group" data-bind="visible: false">
                                        ${this.sensaiChat.getTemplateHtml()}
                                    </div>
                                </div>
                            </div>

                            <!-- ----------------- -->
                            <!-- Performance Tracker -->
                            <!-- ----------------- -->

                            <div class="form-body full-width comepnsation-tracker" data-bind="visible: isSessionTrackerVisible()">
                                <strong class="form-sub-title">Content Performance</strong>
                                <div id="compensation-tracker-container"></div>
                                <div class="w-compensation" id="compensation-tracker" data-bind="css: { 'output-success': articleGoalProgressPercentage() == 100 }">
                                    <div class="w-compensation-popover" data-bind="css: { 'with-monetization': selectedView() == 'currency', 'brand' : selectedView() == 'brand' }">
                                        <div class="w-compensation-content">
                                            <div class="w-compensation-title" data-bind="text: trackerTitle"></div>
                                            <div class="w-compensation-metric hidden-for-brand">Here's your progress this month so far.</div>
                                            <div class="w-compensation-metric show-for-brand">Here's how your articles have performed against the brand target.</div>
                                        </div>
                                        <div class="w-controls">
                                        <label>
                                            <input type="radio" name="controls" id="currencyViewArticle" value="currency" data-bind="checked: selectedView, event: { click: onClickSelectView}" />
                                            <span class="icon i-currency"></span>
                                        </label>
                                        <label data-bind="visible:  brandSessionTarget() != null">
                                            <input type="radio" name="controls" id="brandViewArticle" value="brand" data-bind="checked: selectedView, event: { click: onClickSelectView }" />
                                            <span data-bind="css: 'icon i-' + brand().shortName"></span>
                                        </label>
                                        </div>
                                        <div class="w-compensation-tracker">
                                            <div class="compensation-output">
                                                <div>
                                                    <div class="label" style="margin-bottom: 4px;">Output</div>
                                                    <div class="value-article-output">
                                                        <div class="value-article-fill" data-bind="style: { height: articleGoalProgressPercentage() + '%'}, css: { 'progress-full': articleGoalProgressPercentage() == 100 }"></div>
                                                        <div class="value" data-bind="text: articleCount"></div>
                                                    </div>
                                                </div>
                                                <div class="hidden-for-brand">
                                                    <div class="label">Target</div>
                                                    <div class="label" data-bind="text: articleGoal()"></div>
                                                </div>
                                                <div class="exceeded-earnings" data-bind="visible: outputTransactionsTotal() != 0">
                                                    <div class="label">Additional <br> Output <br> Comp.</div>
                                                    <div class="label" style="font-size: 12px;" data-bind="text: '$' + outputTransactionsTotal()"></div>
                                                </div>
                                            </div>
                                            <div class="compensation-sessions">
                                                <div class="sessions-label">Sessions per Article
                                                        <span class="performance-value" data-bind="text: sessionsPerArticle"></span>
                                                </div>
                                                <div class="sessions-performance">
                                                    <div class="sessions-performance-inner hidden-for-brand">

                                                        <div class="performance-progress-bar">
                                                            <div class="progress-bar-fill" data-bind="style: { '--pos': sessionGoalProgressPercentage() + '%'}, css: { 'single-tier': !isUserHasTier2Rates(), 'tier-one-success': sessionGoalProgressPercentage() == 100, 'tier-two-success': tier2SessionGoalProgressPercentage() == 100 }">
                                                                <div class="w-user-img">
                                                                <img class="user-img" data-bind="attr:{src: userPicture}" src="/assets/images/default-user.png">
                                                                </div>
                                                            </div>
                                                            <div class="tier">
                                                                <span class="tier-label">Tier 1</span>
                                                                <span class="tier-value" data-bind="text: sessionsPerArticleTarget()"></span>
                                                                <div class="tier-monetization icon i-lock" data-bind="text: '$' + tier1Amount()"></div>
                                                            </div>
                                                            <div class="tier" data-bind="visible: isUserHasTier2Rates()">
                                                                <span class="tier-label">Tier 2</span>
                                                                <span class="tier-value" data-bind="text: tier2SessionsPerArticleTarget()"></span>
                                                                <div class="tier-monetization icon i-lock" data-bind="text: '$' + tier2Amount()"></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="sessions-performance-inner show-for-brand">
                                                        <div class="performance-progress-bar">
                                                            <div class="progress-bar-fill" data-bind="style: { '--pos': brandProgressPercentage() + '%'}">
                                                                <div class="w-user-img">
                                                                <img class="user-img" data-bind="attr:{src: userPicture}" src="/assets/images/default-user.png">
                                                                </div>
                                                            </div>
                                                            <div class="tier" data-bind="visible: brandContentTypeSessionTarget() != null, style: { '--pos': contentTypeProgressPercentage() + '%', 'left' : 'var(--pos)'}">
                                                            <span class="tier-label" data-bind="html: contentTypeName() + ' <br> ' + brandContentTypeSessionTarget()"></span>
                                                            </div>
                                                            <div class="tier flipped" style="--pos: 80%; left: var(--pos);">
                                                                <span class="tier-label" data-bind="html: 'Brand <br> ' + brandSessionTarget()"></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="message-box" data-bind="text: explanationText"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <!-- ----------------- -->
                            <!-- Republish History -->
                            <!-- ----------------- -->

                            <div class="form-body full-width republish">
                                <strong class="form-sub-title highlight">Republish History <span data-bind="text:(republishesCount() > 0 ? '(' + republishesCount() + ')': '' )"></span></strong>

                                <div class="form-group">
                                    <button class="btn full-width dark icon i-x-before" type="button" data-bind="event: { click: onClickDeleteScheduledRepublish }, visible : idRepublish && showDeleteRepublishButton">Delete Scheduled Republish</button>
                                </div>

                                <div class="w-form-group republish-new is-showing" data-bind="visible: showScheduledRepublish()">

                                    <div class="form-group inside-label date">
                                        <label class="form-label">republish date</label>
                                        ${this.scheduledRepublishDatePicker.getHtmlBuild()}
                                    </div>
                                    <div class="form-group inside-label">
                                        <label for="authorName" class="form-label">Author</label>
                                         ${this.filterUser_scheduled_republish_author.getHtmlBuild()}
                                    </div>

                                    <div class="form-group inside-label">
                                        <label for="srEditorName" class="form-label">Segment Lead</label>
                                         ${this.filterUser_scheduled_republish_SrEditor.getHtmlBuild()}
                                    </div>

                                    <div class="form-group inside-label">
                                        <label for="jrEditorName" class="form-label">Editor</label>
                                         ${this.filterUser_scheduled_republish_JrEditor.getHtmlBuild()}
                                    </div>

                                    <div class="form-group w-form-sub-title">
                                        <strong class="form-sub-title">Payment</strong>
                                    </div>

                                    <div class="form-group">
                                        <label class="form-label form-label-box">Payment Category</label>
                                        ${this.scheduledRepublishPaymentCategoryFilter.getHtmlBuild()}
                                    </div>

                                    <div class="form-group">
                                        <hr>
                                    </div>

                                     <!--Payment type dropdown-->
                                    <div class="form-group-group select">
                                        <div class="form-group">
                                            <label class="form-label form-label-box">Author Payment</label>
                                            <select
                                            data-bind="options: paymentTypeRepublish,
                                                       optionsCaption: 'Choose a payment type',
                                                       optionsValue: 'name',
                                                       optionsText: 'name' ,
                                                       value: choosenScheduledPaymentTypeRepublish,
                                                       event : {change : onChangepaymentTypeRepublish } "
                                                       >
                                            </select>
                                        </div>
                                         <!-- Show Input -->
                                        <div class="form-group row" data-bind="visible: choosenScheduledPaymentTypeRepublish">
                                            <!-- ko if: choosenScheduledPaymentTypeRepublish() == 'Amount' -->

                                            <input  id="amountAuthor"
                                                style="text-transform: capitalize;"
                                                data-bind="disable: !permissions()['article_edit_publishingControl'].write, value: scheduledAmountAuthor, attr: { 'placeholder':  choosenScheduledPaymentTypeRepublish().toLowerCase() }"
                                                class="input-text"
                                                type="number"
                                                min="0"
                                            >
                                            <span class="form-indic">$</span>

                                            <!-- /ko -->

                                            <!-- ko if: choosenScheduledPaymentTypeRepublish() == 'Percentage' -->

                                            <input  id="percentageAuthor"
                                                style="text-transform: capitalize;"
                                                data-bind=" disable: !permissions()['article_edit_publishingControl'].write,
                                                            value: scheduledPercentageAuthor,
                                                            attr: { 'placeholder':  choosenScheduledPaymentTypeRepublish().toLowerCase() }"
                                                class="input-text"
                                                type="number"
                                                min="0"
                                                max="999"
                                                step="any"
                                            >
                                            <span class="form-indic">%</span>
                                            <!-- /ko -->
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <hr>
                                    </div>

                                    <!-- Edirepublish-newtor percentage (Always %) -->
                                    <div class="form-group inside-label row start">
                                        <label class="form-label">Editor Payment</label>
                                        <input
                                            data-bind=" disable: !permissions()['article_edit_publishingControl'].write,
                                                        value: scheduledPercentageEditor,
                                                        attr: { 'placeholder': 'Percentage' }"
                                            class="input-text num"
                                            type="number"
                                            min="0"
                                            max="999"
                                            step="any"
                                        >
                                        <span class="form-indic">%</span>
                                    </div>

                                </div>
                                <div class="republish-history" data-bind="foreach: republishes">
                                    <div class="form-group form-group-header">
                                        <div>
                                            <label class="form-label">Republish date</label>
                                            <span data-bind="text: dateRepublished"></span>
                                        </div>
                                        <div>
                                            <!-- ko if: $index() == 0 && $data.dateRepublished.substr(0, 10) == new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10) && $data.publishStatus.id == 3  -->

                                            <input type="checkbox" id="latest_republish"
                                                    data-bind="checked : $parent.updateLatestRepublishDateIsChecked,
                                                    value : $parent.updateLatestRepublishDateIsChecked ,
                                                    event : {change : $parent.onChangeUpdateLatestRepublishDate },
                                                    disable: !$parent.permissions()['article_edit_publishingControl'].write
                                                    "
                                            >
                                            <label class="icon i-check" for="latest_republish">Update Time</label>
                                            <!-- /ko -->
                                        </div>

                                    </div>
                                    <div class="form-group-group border">

                                    <div class="form-group">
                                        <label class="form-label">Author</label>
                                        <span data-bind="if: author"><span data-bind="text: author.valnet_user.fullName"></span></span>
                                    </div>

                                    <div class="form-group">
                                        <label class="form-label">Sr Editor</label>
                                        <span data-bind="if: editor"><span data-bind="text: editor.valnet_user.fullName"></span></span>
                                    </div>

                                    <div class="form-group">
                                        <label class="form-label">Jr Editor</label>
                                         <span data-bind="if: juniorEditor"><span data-bind="text: juniorEditor.valnet_user.fullName"></span></span>
                                    </div>

                                    <div class="form-group">
                                        <label class="form-label">Payment Category</label>
                                        <span data-bind="if: postPaymentCategory"><span data-bind="text: postPaymentCategory.name"></span></span>
                                    </div>

                                </div>
                                </div>
                            </div>


                        </div>
                    </div>

                </div>

                <div class="w-lightbox light-theme w-compare" id="compare-popup">
                    <div class="w-form">
                        <div class="form-header">
                            <strong class="form-title icon i-compare">Compare</strong>
                            <button type="button" class="btn only-icon no-bg icon i-close-2" data-bind="event: { click: onClickCloseComparePopUp }"></button>
                        </div>
                        <div class="w-form-body revision" id="compare-revisions">

                            <div class="form-body side">
                                <div class="form-group ">
                                    <ul class="user-list" data-bind="foreach: revisions">
                                        <li class="user-item" data-bind="css: { 'is-selected' : $index() == $parent.selectedRevisionIndex() }">
                                            <div class="w-btn">
                                                 <input type="radio" data-bind="checked: checked, checkedValue:'old',disable: $data.isOldDisable, event:{ change: $parent.onClickCompareRevisionUpdate}, attr:{ name: 'revision_old',  id: 'revision_old' + $data.id}"/>
                                                 <label class="form-label" title="Old" for="active_no" data-bind="attr: { for: 'revision_old' + $data.id }"></label>
                                            </div>
                                            <div class="w-info">
                                                <strong class="side" data-bind="text: $data.dateCreated"></strong>
                                                <span data-bind="if: $data.content.author"><span data-bind="text: $data.content.author.valnet_user.fullName"></span></span>

                                            </div>
                                             <div class="w-btn">
                                                 <input type="radio"  data-bind="checked: checked, checkedValue:'new',  disable: $data.isNewDisable, event:{ change: $parent.onClickCompareRevisionUpdate}, attr:{ name: 'revision_new', id: 'revision_new' + $data.id}"/>
                                                 <label class="form-label" title="New" for="active_no" data-bind="attr: { for: 'revision_new' + $data.id }"></label>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div class="compare-body">
                                <div class="w-form-body">
                                    <div class="form-body compare w-compare-body-header">
                                        <div class="form-group compare-body-header">
                                            <div class="user-link" data-bind="if : oldVersion()">
                                                <strong data-bind="text :  oldVersion().dateCreated"></strong>
                                                <div data-bind="if : oldVersion().user">
                                                    <span data-bind="text : oldVersion().user.valnet_user.fullName"></span>
                                                </div>
                                                <button type="button" class="btn-form" data-bind="visible: selectedTab() == 'revision', event: {click: onClickShowRevision.bind($data, oldVersion()) }">show this version</button>
                                            </div>
                                            <div class="user-link" data-bind="if : newVersion()">
                                                <strong data-bind="text : newVersion().dateCreated"></strong>
                                                <div data-bind="if : newVersion().user">
                                                    <span data-bind="text : newVersion().user.valnet_user.fullName"></span>
                                                </div>
                                                <button type="button" class="btn-form" data-bind="visible: selectedTab() == 'revision', event: {click: onClickShowRevision.bind($data, newVersion()) }"> show this version </button>
                                            </div>

                                        </div>
                                       <div class="w-legend">
                                            <div>
                                                <span class="legend legend-removal">Change Removal</span>
                                                <span class="legend legend-deleted">Deleted</span>
                                            </div>
                                            <div>
                                                <span class="legend legend-addition">Change Addition</span>
                                                <span class="legend legend-added">Added</span>
                                            </div>
                                       </div>
                                       <div class="form-group w-dh2">
                                            <div data-bind="html: versionDiffResult"></div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>

                </div>

                <div data-bind="css: { 'is-visible': isRepublishMessageVisible }" class="w-lightbox light-theme">
                    <div class="lightbox-content">
                        <div class="w-form lightbox-form">
                            <div class="form-header">
                                <h3 class="form-title">Content in Sandbox</h3>
                            </div>

                            <div class="form-body">
                                <div class="form-group">
                                    <p class="form-text">The content in the sandbox doesn't match what's in the article.</p>
                                </div>
                                <div class="form-group">
                                    <p class="form-text">Are you sure you want to schedule what's in the article for republish without the sandbox changes?</p>
                                </div>
                             </div>

                            <div class="form-footer">
                                <button type="button" data-bind="event: { click: onClickContinueEditing }" class="btn">Cancel and Go Back</button>
                                <button type="button" data-bind="event: { click: onClickSaveAnyway }" class="btn highlight">Ignore and Save</button>
                            </div>
                        </div>
                    </div>
                </div>

                ${this.sensaiPromptTemplate.getHtmlBuild()}


                <div data-bind="css: { 'is-visible': isLockMessageVisible }" class="w-lightbox light-theme">
                    <div class="lightbox-content">
                        <div class="w-form lightbox-form">
                            <div class="form-header">
                                <h3 class="form-title">Edit Lock</h3>
                            </div>

                            <div class="form-body">
                                <div class="form-group">
                                    <p class="form-text" data-bind="text: lockMessage"></p>
                                </div>
                                <div class="form-group">
                                    <p class="form-text">The editing user will lose their unsaved changes if you take over.</p>
                                </div>
                                <div class="form-group">
                                    <p class="form-text">Would you like to take over the article ?</p>
                                </div>
                             </div>

                            <div class="form-footer">
                                <button type="button" data-bind="event: { click: onCancelTakeOver }" class="btn">Cancel</button>
                                <button type="button" data-bind="event: { click: onTakeOver}" class="btn highlight">Take Over</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div data-bind="css: { 'is-visible': isKickoutMessageVisible }" class="w-lightbox light-theme">
                    <div class="lightbox-content">
                        <div class="w-form lightbox-form">
                            <div class="form-header">
                                <h3 class="form-title">Edit Lock</h3>
                            </div>

                            <div class="form-body">
                                <div class="form-group">
                                    <p class="form-text" data-bind="text: kickoutMessage"></p>
                                </div>
                             </div>

                            <div class="form-footer">
                                <button type="button" data-bind="event: { click: onKickout}" class="btn highlight">OK</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="w-form w-form-sub form-buyers-guide" data-bind="css: { 'is-showing' : isReviewProductFormShown }" xmlns="http://www.w3.org/1999/html">
                   <div class="form-header">
                      <h3 class="form-title">Product Review</h3>
                      <button class="close-button icon i-close-2" type="button" data-bind="event: { click: onClickCancelSaveReviewItem }, css: { 'is-disable' : isSaveButtonDisabled() }, disable: isSaveButtonDisabled()"></button>
                   </div>

                   <!-- Beginning of new PRODUCT form -->

                   <div class="w-form-body-scroll">
                       <div class="w-form-body border">

                           <div class="form-body">

                                <div class="form-group inside-label" style="margin-bottom: 5rem">
                                    ${this.filterProductTypes.getHtmlBuild()}
                                </div>
                                <div class="form-group inside-label row">
                                    ${this.filterProducts.getHtmlBuild()}
                                    <div class="w-tooltips-adv pos-bottom x-short">
                                        ${this.selectProductTooltip.getHtmlBuild()}
                                    </div>
                                </div>

                           </div>

                           <div class="form-body" data-bind="visible: idTemplate() != 8">
                                <div class="form-group seo-description">
                                    <div style="display: flex;align-items: center">
                                        <label style="margin-bottom: 0" class="form-label" >SEO Description</label>
                                        <button class="w-tooltips icon i-tooltips" type="button">
                                            <span class="tooltips" >
                                            This is the description provided in the product schema on the website,
                                            which is leveraged by search engines (like Google), to better understand
                                            the content and can be displayed to users in search results.  It should be a short,
                                            natural, and engaging blurb about the product, which users would find relevant.
                                            </span>
                                        </button>
                                    </div>

                                    <textarea rows="3" data-bind=" value: reviewItemSeoDescription" /></textarea>
                                 </div>
                            </div>
                       </div>
                       <div class="w-form-body no-padding" data-bind="visible: idTemplate() != 8">
                            <div class="form-body">
                                <div class="form-group row start no-padding">
                                    <strong class="form-btn-title">specifications</strong>
                                    <button class="btn-form only-icon icon i-plus" type="button" data-bind="event: {click: onClickAddSpecification}"><span class="hide">add</span></button>
                                </div>
                            </div>
                       </div>
                       <div class="w-form-body list" data-bind="visible: idTemplate() != 8">
                            <div class="form-body" id="spec_section_list">
                                <!-- ko foreach: reviewItemTagSpecifications -->
                                      <div class="form-group row">
                                          <span class="form-span" data-bind="text: label"></span>
                                          <input class="input-text" data-bind="value: data, disable: dataType != 'text' " type="text">
                                          <!-- ko if: $data.canDelete -->
                                              <button type="button" class="btn icon only-icon i-close" data-bind="event: {click: $parent.onClickDeleteSpecification.bind($data, $index) }"></button>
                                         <!-- /ko -->
                                      </div>
                                <!-- /ko -->
                                <!-- ko foreach: addedReviewItemTagSpecifications -->
                                <div class="form-group row">
                                    <input class="input-text" data-bind="value: label" type="text">
                                    <input class="input-text" data-bind="value: data, disable: dataType != 'text'" type="text">
                                    <button type="button"  class="btn-form only-icon icon i-close" data-bind="event: {click: $parent.onClickDeleteAddedSpecification.bind($data,$index) }"></button>
                                </div>
                                <!-- /ko -->
                            </div>
                       </div>
                       <strong class="form-sub-title">Media</strong>
                       <div class="w-form-body">
                            <div class="form-body">
                                <div class="form-group row start">
                                    <strong class="form-btn-title">Images</strong>
                                    <button class="btn-form icon i-image" data-bind="event: { click: onClickSelectProductImages }">Select Image</button>
                                </div>
                                 <div class="form-group">
                                     <div class="w-img-article-list form" id="productImages">
                                           <ul id="img_list_product_review" class="img-article-list" data-bind="foreach: reviewItemImages">
                                                <li class="img-article-item" draggable="true" data-bind="attr: {id: id }">
                                                    <button class="btn-icon icon i-drag" ><span>drag</span></button>
                                                     <div class="w-btn">
                                                        <button class="btn-form icon i-delete" type="button" data-bind="event: { click: $parent.onClickDeleteProductImage.bind($data, $index) }"><span>delete</span></button>
                                                     </div>
                                                     <div class="ratio-content">
                                                        <img data-bind="attr: {src: url}">
                                                     </div>
                                                </li>
                                           </ul>
                                     </div>
                                </div>
                            </div>
                            <div class="form-body " data-bind="visible: idTemplate() != 8">
                                <div class="form-group row start no-padding">
                                    <strong class="form-btn-title">Videos</strong>
                                    <button class="btn-form only-icon icon i-plus" type="button" data-bind="event: { click: onClickAddReviewItemVideo }"><span class="hide">add</span></button>
                                </div>
                                <!-- ko foreach: reviewItemExtraVideos -->
                                     <div class="form-group row no-padding  inside-label">
                                         <label for="" class="form-label">URL</label>
                                         <input class="input-text" data-bind="value: data" type="text">
                                         <button class="btn-form only-icon icon i-close" type="button" data-bind="event: {click: $parent.onClickDeleteReviewItemVideo.bind($data, $index) }"></button>
                                     </div>
                                <!-- /ko -->
                            </div>

                       </div>


                       <strong class="form-sub-title" data-bind="visible: idTemplate() != 8">Reviews</strong>
                        <div class="w-form-body border" data-bind="visible: idTemplate() != 8">
                            <div class="form-body">
                                <div class="form-group row" id="featuredFive_section" data-bind="visible: idTemplate() == 6">
                                    <label for="template" class="form-label">FEATURED 5 SECTION</label>
                                    <select id="idTagAwards" data-bind="options: reviewItemAward_options, optionsCaption: 'Choose an option', optionsText: 'name', value: reviewItemIdAwardType, optionsValue: 'id' "></select>
                                </div>
                            </div>
                            <div class="form-body">
                                <div class="form-group row">
                                       <label class="form-label" for="">PRODUCT RATING (OUT OF 10)</label>
                                       <input class="input-text num"  type="text" data-bind="value: reviewItemRating">
                                </div>
                            </div>
                        </div>

                        <div class="w-form-body no-padding " data-bind="visible: idTemplate() != 8">
                            <div class="form-body">
                                <div class="form-group row start no-padding">
                                    <strong class="form-btn-title">KEY FEATURES</strong>
                                    <button class="btn-form only-icon icon i-plus" type="button" data-bind="event: { click: onClickAddKeyFeature } "><span class="hide">add</span></button>
                                </div>
                            </div>
                       </div>

                        <div class="w-form-body list border" data-bind="visible: idTemplate() != 8">
                            <div class="form-body">
                                <!-- ko foreach: reviewItemKeyFeatures -->
                                <div class="form-group row icon square-list">
                                    <input class="input-text" data-bind="value: data" type="text">
                                    <button class="btn-form only-icon icon i-close" data-bind="event: { click: $parent.onClickDeleteKeyFeature}" type="button"></button>
                                </div>
                                <!-- /ko -->
                            </div>
                       </div>

                       <div class="w-form-body no-padding" data-bind="visible: idTemplate() != 8">
                            <div class="form-body">
                                <div class="form-group row start no-padding">
                                    <strong class="form-btn-title">Pros</strong>
                                    <button class="btn-form only-icon icon i-plus pros" type="button" data-bind="event: { click: onClickAddPro } " ><span class="hide">add</span></button>
                                </div>
                            </div>
                             <div class="form-body" data-bind="visible: idTemplate() != 8">
                                <div class="form-group row start no-padding">
                                    <strong class="form-btn-title">Cons</strong>
                                    <button class="btn-form only-icon icon i-plus cons" type="button" data-bind="event: { click: onClickAddCon } "><span class="hide">add</span></button>
                                </div>
                            </div>
                       </div>
                       <div class="w-form-body" data-bind="visible: idTemplate() != 8">
                                <div class="form-body list" id="pros_section_list">
                                     <!-- ko foreach: reviewItemPros -->
                                              <div class="form-group row pros icon i-thumb-up">
                                                  <input class="input-text" data-bind="value: data" type="text">
                                                  <button class="btn-form only-icon icon i-close" type="button" data-bind="event: { click: $parent.onClickDeletePro.bind($data, $index)}"></button>
                                              </div>
                                     <!-- /ko -->
                                </div>
                                <div class="form-body list" id="cons_section_list">
                                     <!-- ko foreach: reviewItemCons -->
                                         <div class="form-group row icon cons i-thumb-down">
                                             <input class="input-text" data-bind="value: data" type="text">
                                             <button class="btn-form only-icon icon i-close" type="button" data-bind="event: { click: $parent.onClickDeleteCon.bind($data, $index)}"></button>
                                         </div>
                                     <!-- /ko -->
                                </div>
                       </div>

                       <strong class="form-sub-title">Affiliates</strong>

                       <div class="w-form-body no-padding">
                            <div class="form-body">
                                <div class="form-group inside-label top-align row">

                                    <!-- <strong class="form-btn-title">Affiliate</strong> -->
                                    ${this.filterAffiliates.getHtmlBuild()}
                                    <button class="btn-form only-icon icon i-plus" type="button" data-bind="event: {click: onClickAddAffiliateLink}"><span class="hide">add</span></button>
                                </div>
                            </div>
                       </div>

                       <div class="w-form-body list">
                            <div class="form-body"  ><!-- id="affiliate_links_section" -->


                                <!-- ko foreach: reviewItemAffiliateLinks -->
                                <div class="form-group row icon">

                                     <!-- <div class="inside-label">
                                          <label for="" class="form-label">type</label>
                                          <input class="input-text" data-bind="value: type" type="text">
                                    </div> -->
                                    <span class="form-span" data-bind="text: type"></span>

                                    <div class="inside-label">
                                        <label for="" class="form-label">url</label>
                                        <input class="input-text" style="border-radius:0;" data-bind="value: value" type="text">
                                    </div>
                                    <button class="btn-form only-icon icon i-close" type="button"  data-bind="event: { click: $parent.onClickDeleteAffiliateLinks.bind($data, $index) }"></button>
                                </div>
                                <!-- /ko -->
                            </div>
                       </div>
                       <div data-bind="visible: idTemplate() != 8">
                            <strong class="form-sub-title icon i-dropdown-simple" data-bind="click: collapseGiveawaySection, css: { 'is-open' : isGiveawaySectionCollapsed }">Giveaway</strong>
                       </div>
                       <div class="w-form-body" data-bind="visible: isGiveawaySectionCollapsed">
                            <div class="form-body">
                                 <div id="giveaway_url_section" class="form-group inside-label">
                                    <label class="form-label">Gleam Giveaway URL</label>
                                    <input type="text" class="input-text" data-bind="value: reviewItemGiveawayUrl, valueUpdate: 'keyup'" />
                                 </div>
                            </div>
                             <div class="form-body">
                                <div class="form-group inside-label">
                                    <label for="giveawayDatePicker" style="z-index: 10;" class="form-label">Giveaway Expiry Date</label>
                                    <div>
                                        ${this.giveawayDatePicker.getHtmlBuild()}
                                    </div>
                                </div>
                             </div>
                       </div>

                       <strong class="form-sub-title" data-bind="visible: amazonOnsite() && amazonOnsite().value == 'true'">Amazon Onsite</strong>

                       <div class="w-form-body" data-bind="visible: amazonOnsite() && amazonOnsite().value == 'true'">
                            <div class="form-body">
                                <div class="form-group inside-label" id="amazon_award_section" data-bind="visible: idTemplate() == 6 ">
                                    <label class="form-label">Amazon Award</label>
                                    <input type="text" class="input-text" data-bind="value:reviewItemAmazonAward, disable: selectedTab() == 'article' && datePublished() != '' && idReviewItem()" />
                                </div>
                                <div class="form-group inside-label" id="amazon_headline_section" data-bind=" visible: idTemplate() == 6">
                                    <label class="form-label">Amazon Headline</label>
                                    <textarea  data-bind="value: reviewItemAmazonHeadline, disable: selectedTab() == 'article' && datePublished() != '' && idReviewItem()" maxlength="200" rows="3" /></textarea>
                                </div>
                            </div>
                            <div class="form-body">
                                 <div class="form-group row">
                                       <label class="form-label" for="">Amazon Rating (OUT OF 10)</label>
                                       <input class="input-text num"  type="text" data-bind="value: reviewItemAmazonRating, disable: selectedTab() == 'article' && datePublished() != '' && idReviewItem()">
                                </div>
                                <div id="amazon_summary_section" class="form-group inside-label" data-bind=" visible: idTemplate() == 6">
                                    <label class="form-label">Amazon Summary</label>
                                    <textarea data-bind="value: reviewItemAmazonSummary, disable: selectedTab() == 'article' && datePublished() != '' && idReviewItem()" maxlength="200" rows="3"></textarea>
                                 </div>
                            </div>

                       </div>

                       <strong class="form-sub-title">Product Text</strong>

                        <div class="form-group form-group-textarea">
                            <textarea id="product_review_text" data-bind=" value: reviewItemReviewText" ></textarea>
                        </div>

                       <div class="w-form-body">
                          <div class="form-body full-width">
                             <div class="form-footer">
                                <button id="cancel_review" class="btn" data-bind="event: {click: onClickCancelSaveReviewItem }, css: { 'is-disable' : isSaveButtonDisabled() }, text: isSaveButtonDisabled() ? 'Autosaving...' : 'Cancel'" type="button"></button>
                                <button id="save_review" class="btn highlight" type="button" data-bind="event: {click: onClickAddReviewItem }, css: { 'is-disable' : isSaveButtonDisabled() }, text: isSaveButtonDisabled() ? 'Autosaving...' : 'Apply'"></button>
                             </div>
                          </div>
                       </div>
                   </div>
                </div>

                <!-- End of new PRODUCT form -->

                <div data-bind="css: { 'is-visible': isFaqDeleteVisible }" class="w-lightbox light-theme">
                    <div class="lightbox-content">
                        <div class="w-form lightbox-form">
                            <div class="form-header">
                                <h3 class="form-title">Confirm deletion of FAQ item</h3>
                            </div>

                            <div class="form-body">
                                <div class="form-group">
                                    <p class="form-text">Do you confirm the deletion of this item?</p>
                                </div>
                             </div>

                            <div class="form-footer">
                                <button type="button" data-bind="event: { click: onClickConfirmFaqDelete}" class="btn highlight">Confirm</button>
                                <button type="button" data-bind="event: { click: onClickCancelFaqDelete}" class="btn ">Cancel</button>
                            </div>
                        </div>

                    </div>
                </div>

                <div data-bind="css: { 'is-visible': isReviewItemUpdatesFormShown }"  class="w-lightbox light-theme product-sand">
                    <div class="lightbox-content">
                        <div class="w-form lightbox-form">
                            <div class="form-header">
                                <h3 class="form-title">Your review items have changed</h3>
                                <button class="close-button icon i-close-2" type="button" data-bind="event: { click: onReviewItemUpdateCancel }"></button>
                            </div>
                            <div class="form-body-scroll">
                            <!-- ko foreach: fieldValueChanges -->
                                <div class="form-body w-justify ">
                                    <div class="form-img w-left">
                                        <div class="w-img">
                                            <img data-bind="attr: { src: imageUrl }" onerror="this.src='/assets/images/placeholder-product.png\';" alt="">
                                        </div>
                                    </div>
                                    <div class="w-right column">
                                        <strong class="form-sub-title" data-bind="text: tag, attr: {src: imageUrl}"></strong>
                                        <div style="width: 100%;margin-left:2rem;" data-bind="if: tagNameChange">

                                            <div class="w-form-group" >

                                                <div class="form-group row">
                                                    <strong class="form-legend" data-bind="text: tag"></strong>

                                                    <button class="w-tooltips icon i-tooltips" type="button">
                                                        <span class="tooltips no-wrap" data-bind="text: 'In the time this product has been in the '+$root['edit_template_new'].sourceOfReversal()+' of this article, the name of the product on the website has been updated. The website product name will be used for the product card of this article.'">
                                                        </span>
                                                    </button>
                                                </div>
                                                <div class="form-group">
                                                    <p class="form-text">The tag this product is based on has been renamed to be <span data-bind="text: tagNameChange.oldName"></span> on the <span>website</span>.</p>
                                                    <p class="form-text">The <span>website</span> naming will be used in the article.</p>
                                                </div>
                                                <div class="form-group">
                                                    <hr>
                                                </div>
                                                <!--
                                                <div class="form-group">
                                                    <table class="list-action">
                                                        <thead>
                                                            <tr>
                                                                <th><span data-bind="text: $root['edit_template_new'].sourceOfReversal()"></span></th>
                                                                <th></th>
                                                                <th><span>Website</span></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td><span data-bind="text: tagNameChange.newName"></span></td>
                                                                <td><span class="icon i-to-arrow-right"></span></td>
                                                                <td><span ></span></td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                -->
                                            </div>
                                        </div>
                                        <div style="width: 100%;margin-left:2rem;" data-bind="if: updatedLabels.length != 0">
                                            <div class="w-form-group" >

                                                <div class="form-group">

                                                </div>
                                                <div class="form-group row">
                                                    <strong class="form-legend">Specification Field Name</strong>

                                                    <button class="w-tooltips icon i-tooltips" type="button">
                                                        <span class="tooltips no-wrap" data-bind="text: 'In the time this product has been in the '+$root['edit_template_new'].sourceOfReversal()+' of this article, the name of a specification field on the website has been updated. The website specification field name will be used for the product card of this article.'">
                                                        </span>
                                                    </button>
                                                </div>
                                                <div class="form-group">
                                                    <p class="form-text">For all products of type <span data-bind="text: tagTypeName"></span>, the following fields were changed on the <span>website</span>:</p>

                                                    <ul class="disc" data-bind="foreach: updatedLabels">
                                                         <li>
                                                             <p class="form-text"><span data-bind="text: (newLabel !='' && typeof(newLabel) != 'undefined') ? newLabel : '(empty)' ">[sandboxSpecName]</span> was renamed to be <span data-bind="text: (oldLabel !='' && typeof(oldLabel) != 'undefined') ? oldLabel : '(empty)' ">[websiteSpecName]</span> on the <span>website</span>.</p>
                                                         </li>
                                                    </ul>
                                                    <p class="form-text">The <span>website</span> naming will be used in the article.</p>
                                                </div>
                                                <div class="form-group">
                                                    <hr>
                                                </div>

                                                <!--
                                                <div class="form-group">
                                                    <table class="list-action">
                                                        <thead>
                                                        <tr>
                                                            <th><span data-bind="text: $root['edit_template_new'].sourceOfReversal()"></span></th>

                                                            <th><span>Website</span></th>
                                                        </tr>
                                                        </thead>
                                                        <tbody  data-bind="foreach: updatedLabels">
                                                            <tr>
                                                                 <td><span data-bind="text: (newLabel !='' && typeof(newLabel) != 'undefined') ? newLabel : '(empty)' "></span></td>

                                                                 <td><span data-bind="text: (oldLabel !='' && typeof(oldLabel) != 'undefined') ? oldLabel : '(empty)' "></span></td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                -->
                                            </div>
                                        </div>
                                        <div style="width: 100%;margin-left:2rem;" data-bind="if: updatedValues().length != 0">

                                            <div class="w-form-group" >
                                                <div class="form-group">

                                                </div>
                                                <div class="form-group row">
                                                    <strong class="form-legend">Specification Value</strong>
                                                    <button class="w-tooltips icon i-tooltips" type="button">
                                                        <span class="tooltips no-wrap" data-bind="text: 'Differences were found in the product specification values between the '+$root['edit_template_new'].sourceOfReversal()+' version and the current website version.'+ ($root['edit_template_new'].sourceOfReversal() !='revision' ? ' Please confirm which values should be used for the product.' : '')">
                                                        </span>
                                                    </button>
                                                </div>
                                                <div class="form-group" data-bind="if: $root['edit_template_new'].sourceOfReversal() != 'revision'" >
                                                    <p class="form-text">Confirm which values should be used for this product going forward.</p>
                                                </div>
                                                <div class="form-group" data-bind="if: $root['edit_template_new'].sourceOfReversal() == 'revision'" >
                                                    <p class="form-text">Because you are reverting a revision, all values will remain to what they already are on the <span>website</span>.</p>
                                                </div>
                                                <div class="form-group" data-bind="if: $root['edit_template_new'].sourceOfReversal() == 'revision'">
                                                    <table class="list-action ">
                                                        <thead>
                                                        <tr>
                                                            <th><span>Spec</span></th>
                                                            <th><span>Revision</span></th>
                                                            <th><span>Website</span></th>
                                                        </tr>
                                                        </thead>
                                                              <tbody data-bind="foreach: updatedValues()">
                                                                  <tr>
                                                                      <td><span class="label" data-bind="text: label"></span></td>
                                                                       <!-- <td><span data-bind="attr: {class: $root['edit_template_new'].sourceOfReversal() == 'revision' ? 'icon i-to-arrow-left' : 'icon i-to-arrow-right'}"></span></td> -->
                                                                      <td><span data-bind="text: (oldValue !='' && typeof(oldValue) != 'undefined') ? oldValue : '(empty)'"></span></td>
                                                                      <td><span data-bind="text: (newValue !='' && typeof(newValue) != 'undefined') ? newValue : '(empty)'"></span></td>
                                                                  </tr>
                                                              </tbody>
                                                        </div>
                                                    </table>
                                                </div>

                                                <div class="form-group" data-bind="if: $root['edit_template_new'].sourceOfReversal() != 'revision'">
                                                    <table class="list-action">
                                                        <thead>
                                                        <tr>
                                                            <th><span>Spec</span></th>
                                                            <th><span data-bind="text: $root['edit_template_new'].sourceOfReversal()"></span></th>
                                                            <th><span>Website</span></th>
                                                        </tr>
                                                            <tbody data-bind="foreach: updatedValues()">
                                                                <tr>
                                                                    <td><span class="label" data-bind="text: label"></span></td>
                                                                    <td data-bind="click: $root['edit_template_new'].valueSwitch.bind($data, 'newValue')">
                                                                        <div class="form-check-inline">
                                                                            <input type="radio" data-bind="attr: {value: newValue}, checked: chosenValue()" >
                                                                            <label class="form-label"  data-bind="text: (newValue !='' && typeof(newValue) != 'undefined') ? newValue : '(empty)'"></label>
                                                                        </div>
                                                                    </td>
                                                                    <td data-bind="click: $root['edit_template_new'].valueSwitch.bind($data, 'oldValue')">
                                                                          <div class="form-check-inline">
                                                                              <input type="radio"  data-bind="attr: {value: oldValue}, checked: chosenValue()">
                                                                              <label class="form-label" data-bind="text: (oldValue !='' && typeof(oldValue) != 'undefined') ? oldValue : '(empty)'"></label>
                                                                          </div>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                    </table>
                                                </div>

                                                <div class="form-group" data-bind="if: $root['edit_template_new'].sourceOfReversal() != 'revision'">

                                                    <ul class="disc" data-bind="foreach: updatedValues()">
                                                        <div data-bind="if: chosenValue() == newValue">
                                                             <li>
                                                                 <p class="form-text">The value for <span data-bind="text: label"></span>  will be updated to match the <span data-bind="text: $root['edit_template_new'].sourceOfReversal()"></span>, <span data-bind="text: (chosenValue() !='' && typeof(chosenValue()) != 'undefined') ? chosenValue() : '(empty)' "></span>.</p>
                                                             </li>
                                                        </div>
                                                        <div data-bind="if: chosenValue() == oldValue">
                                                              <li>
                                                                  <p class="form-text">The value for <span data-bind="text: label"></span> will remain as what is already used on the <span>website</span>, <span data-bind="text: (chosenValue() !='' && typeof(chosenValue()) != 'undefined') ? chosenValue() : '(empty)' "></span>.</p>
                                                              </li>
                                                        </div>
                                                    </ul>
                                                    <p class="form-text">The <span>website</span> naming will be used in the article.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            <!-- /ko -->
                            </div>

                            <div class="form-footer">
                                <button type="button" data-bind="event: { click: onReviewItemUpdateCancel }" class="btn ">Cancel</button>
                                <button type="button" data-bind="event: { click: onReviewItemReversalConfirm }" class="btn highlight">Apply</button>

                            </div>

                        </div>
                    </div>
                 </div>


                <div data-bind="css: { 'is-visible': isEmbedPopUpVisible }" class="w-lightbox light-theme lightbox-embed">
                    <div class="lightbox-content">
                        <div class="w-form lightbox-form">

                            <div class="form-header">
                                <h3 class="form-title">Insert Embed</h3>
                                <button type="button" class="close-button icon i-close-2" data-bind="event: { click: onClickCloseEmbedPopup }" ></button>
                            </div>


                            <div class="form-body">

                                 <div class="form-group">
                                    <button class="btn-form options icon i-dropdown-simple is-open" type="button" data-bind="event: { click: onClickToggleEmbedTypes }">Supported Platforms</button>
                                    <div class="inner-group" data-bind="foreach: embedType_options" >
                                        <div>
                                            <input type="radio" data-bind="checked: $parent.embedType, event:{change: $parent.onChangeEmbedInput}, attr: { value: $data.type, id: $data.type }">
                                            <label class="form-label" for="active_no" data-bind="text: $data.name, attr: { for: $data.type }"></label>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div style="display: flex;align-items: center">
                                        <label class="form-label" for="embedSource">Embed Creator</label>
                                        <div class="w-tooltips-adv pos-top">
                                            ${this.toolTipButton.getHtmlBuild()}
                                        </div>
                                    </div>
                                    <textarea style="width: 100%;height: 100px;" id="embedSource" placeholder="paste supported link or full embed code here" data-bind="textInput: embedSource, event: { input: onChangeEmbedInput }, valueUpdate : ['afterkeydown','propertychange','input'], hasFocus: isEmbedFocused" class="input-text"></textarea>
                                </div>
                                <div class="error form-group">
                                    <p class="form-text" data-bind="text: embedErrors().message" />
                                    <ul data-bind="foreach:embedErrors().softMatches">
                                        <li >
                                            <p class="form-text" data-bind="text: $data" /></p>
                                        </li>
                                    </ul>
                                    <p class="form-text" data-bind="if: embedErrors().softMatches && embedErrors().softMatches.length>0 ">Please choose a specific supported platform from the list.</p>
                                </div>

                                <div class="preview" data-bind="visible: embedCode">
                                    <div class="form-group">
                                        <label class="form-label" for="embedSource" data-bind="class: previewEmbedType">Embed Code Preview</label>
                                        <pre class="scrollable"  data-bind="text: embedCode, disable: true" ></pre>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group" id="embedGeneration">
                                <section id="calculation" hidden>
                                    <h2 class="form-title embed-animation">Generating Embed…</h2>
                                    <progress style="
                                        display: block;
                                        width: 100%;
                                        margin-bottom: 10px;">
                                        </progress>
                                    <p>
                                        Checking width:
                                        <span id="current-viewport-width"></span>
                                        <span>x</span>
                                        <span id="current-viewport-height"></span>
                                    </p>

                                    <div id="iframe-wrapper" style="display:none">
                                        <iframe src="about:blank"></iframe>
                                    </div>
                                </section>
                            </div>

                            <div class="form-footer">

                                <button type="button" data-bind="event: { click: onClickCloseEmbedPopup }" class="btn ">Cancel</button>
                                <button type="button" data-bind="disable: embedCode() == null || embedErrors() == null,  event: { click: onClickAddEmbed }" class="btn highlight">Insert</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div data-bind="css: { 'is-visible': isSensaiVaultVisible }" class="w-lightbox light-theme lightbox-embed">
                    <div class="lightbox-content">
                        <div class="w-form lightbox-form">
                            <div class="form-header">
                                <h3 class="form-title">Sensai Vault</h3>
                                <button type="button" class="close-button icon i-close-2" data-bind="event: { click: onClickCloseSensaiVaultPopup }" ></button>
                            </div>


                            <div class="form-body">

                                <div id="generatedContent" data-bind="html: sensaiVaultGeneratedHtml"></div>
                            </div>

                            <div class="form-footer">

                                <button type="button" data-bind="event: { click: onClickCloseSensaiVaultPopup }" class="btn ">Cancel</button>
                                <button type="button" data-bind="disable: embedCode() == null || embedErrors() == null,  event: { click: onClickAddEmbed }" class="btn highlight">Insert</button>
                            </div>
                        </div>
                    </div>
                </div>

                 ${this.imagePicker.getHtmlBuild()}
                 ${this.tagPicker.getHtmlBuild()}
                 ${this.videoPicker.getHtmlBuild()}
                 ${this.articlePicker.getHtmlBuild()}
                 ${this.warningDialog_WhenLogOut.getHtmlBuild()}
                 ${this.warningDialog_WhenArticleLock.getHtmlBuild()}
                 ${this.warningDialog_sandboxDelete.getHtmlBuild()}
                 ${this.warningDialog_newsletterSendingConfirmation.getHtmlBuild()}
                 ${this.warningDialog_republishDelete.getHtmlBuild()}
                 ${this.warningDialog_republishCreateAndUpdate.getHtmlBuild()}
                <style>
                .cke_button__linkbtn_label {
                    display:inline;
                }
                .cke_button__updatebtn_label {
                    display:inline;
                }
                .cke_button__linkbtn_icon{
                    display: none;
                }
                a.cke_button__keypointsbtn, .cke .cke_toolgroup a.cke_button__keypointsbtn.cke_button_off:hover {
                    background-image: rgb(99,0,143);
                    background-image: -moz-linear-gradient(0deg, rgba(99,0,143,1) 0%, rgba(24,112,185,1) 52%, rgba(43,188,171,1) 100%) !important;
                    background-image: -webkit-linear-gradient(0deg, rgba(99,0,143,1) 0%, rgba(24,112,185,1) 52%, rgba(43,188,171,1) 100%) !important;
                    background-image: linear-gradient(0deg, rgba(99,0,143,1) 0%, rgba(24,112,185,1) 52%, rgba(43,188,171,1) 100%) !important;
                    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#63008f",endColorstr="#2bbcab",GradientType=1);
                }
                .cke_button__keypointsbtn_label {
                    display:inline;
                    color: #ffffff;
                }
                .cke_button__keypointsbtn_icon {
                    background: url(/assets/images/keypoints.svg);
                }
                .cke_button__updatebtn_icon {
                    display: none;
                }
                [id^=cke_target]{
                    display:none !important;
                }

                </style>
                `;
    }

    protected initPartial(): void {

        this.filterUser_author = new filterUser_template("filterUser_author", this.getTemplateViewModel(), this.caller);
        this.filterUser_author.setUniqueIdentifier('authorId');

        this.filterUser_SrEditor = new filterUser_template("filterUser_SrEditor", this.getTemplateViewModel(), this.caller);
        this.filterUser_SrEditor.setUniqueIdentifier("srEditorId");

        this.filterUser_JrEditor = new filterUser_template("filterUser_JrEditor", this.getTemplateViewModel(), this.caller);
        this.filterUser_JrEditor.setUniqueIdentifier("jrEditorId");

        this.filterUser_ideator = new filterUser_template("filterUser_ideator", this.getTemplateViewModel(), this.caller);
        this.filterUser_ideator.setUniqueIdentifier("ideatorId");

        this.filterUser_republish_author = new filterUser_template("filterUser_republish_author", this.getTemplateViewModel(), this.caller);
        this.filterUser_republish_author.setUniqueIdentifier("repAuthorId")

        this.filterUser_republish_SrEditor = new filterUser_template("filterUser_republish_SrEditor", this.getTemplateViewModel(), this.caller);
        this.filterUser_republish_SrEditor.setUniqueIdentifier("repSrEditorID")

        this.filterUser_republish_JrEditor = new filterUser_template("filterUser_republish_JrEditor", this.getTemplateViewModel(), this.caller);
        this.filterUser_republish_JrEditor.setUniqueIdentifier("repJrEditorID")

        this.filterUser_scheduled_republish_author = new filterUser_template("filterUser_scheduled_republish_author", this.getTemplateViewModel(), this.caller);
        this.filterUser_scheduled_republish_author.setUniqueIdentifier("repAuthorId")

        this.filterUser_scheduled_republish_SrEditor = new filterUser_template("filterUser_scheduled_republish_SrEditor", this.getTemplateViewModel(), this.caller);
        this.filterUser_scheduled_republish_SrEditor.setUniqueIdentifier("scheduledRepSrEditorID")

        this.filterUser_scheduled_republish_JrEditor = new filterUser_template("filterUser_scheduled_republish_JrEditor", this.getTemplateViewModel(), this.caller);
        this.filterUser_scheduled_republish_JrEditor.setUniqueIdentifier("scheduledRepJrEditorID")

        this.filterUser_display_author = new filterUser_template("filterUser_display_author", this.getTemplateViewModel(), this.caller);
        this.filterUser_display_author.setUniqueIdentifier("displayAuthorId");

        this.filterWebsiteUser_prompt_author = new filterWebsiteUser_template("filterWebsiteUser_prompt_author", this.getTemplateViewModel(), this.caller);
        this.filterWebsiteUser_prompt_author.setUniqueIdentifier("promptAuthorId")

        this.toolTip_prompt_author = new infoButton_template("toolTip_prompt_author", this.getTemplateViewModel(), this.caller);
        this.toolTip_prompt_author.setTitle("Help: Prompt Author");
        this.toolTip_prompt_author.setContent(`The Thread can specify a website user as a prompt author. If none is set, the author of the article itself is used. Website users can be searched using display name or public ID on the brand.`)

        this.display_authors = new articleUserList_template("display_authors", this.getTemplateViewModel(), this.caller);

        this.filterProducts = new filterAutocomplete_template("filterAutocompleteProduct_template", this.getTemplateViewModel(), this.caller);
        // this.filterProducts.setFilterIconCSSClass( 'i-article-a' );
        this.filterProducts.setClearInputConfirmMessage("Are you sure you want to change the product name? Newly entered product specifications and selected fields will be lost");
        this.filterProducts.setAddNewClearConfirmMessage("Are you sure you want to add a new product name? Newly entered product specifications and selected fields will be lost");
        this.filterProducts.setAddNewOptionEnabled(true);
        this.filterProducts.setHasDisplayNameComplement(true);
        this.filterProducts.setNumberOfChars( 1 );
        this.filterProducts.setPlaceholderAndLabel( "Product" );
        this.filterProducts.setOptionType("Product name");

        this.filterAffiliates = new filterAutocomplete_template("filterAutocompleteAffiliate_template", this.getTemplateViewModel(), this.caller);
        // this.filterProducts.setFilterIconCSSClass( 'i-article-a' );
        this.filterAffiliates.setAddNewOptionEnabled(true);
        this.filterAffiliates.setNumberOfChars( 1 );
        this.filterAffiliates.setPlaceholderAndLabel( "Affiliate Partner" );
        this.filterAffiliates.setOptionType("Affiliate Partner");
        //TODO create a new filterAutoComplete_template with a new id template
        this.filterPinnedTag = new filterAutocomplete_template('filterAutocompletePinnedTags_template', this.getTemplateViewModel(), this.caller);
        this.filterPinnedTag.setPlaceholderAndLabel( 'Featured Tag' );
        this.filterPinnedTag.setOptionType("Featured Tag");
        this.filterPinnedTag.setAddNewOptionEnabled(false);

        this.filterProductTypes = new filterAutocomplete_template("filterAutocompleteProductType_template", this.getTemplateViewModel(), this.caller);
        // this.filterProductTypes.setFilterIconCSSClass( 'i-article-a' );
        this.filterProductTypes.setClearInputConfirmMessage("Are you sure you want to change the product type? Newly entered product specifications and selected fields will be lost");
        this.filterProductTypes.setAddNewClearConfirmMessage("Are you sure you want to add a new product type? Newly entered product specifications and selected fields will be lost");
        this.filterProductTypes.setPlaceholderAndLabel( 'Product Type' );
        this.filterProductTypes.setOptionType("Product Type");
        this.filterProductTypes.setNumberOfChars( 1 );
        this.filterProductTypes.setAddNewOptionEnabled(true);
        this.filterArticleDirectory = new filterArticle_template('filterAutocomplete_template', this.getTemplateViewModel(), this.caller);
        this.filterArticleDirectory = new filterArticle_template('filterArticleDirectory', this.getTemplateViewModel(), this.caller);

        this.paymentCategoryFilter = new filterDropdown_template("paymentCategoryFilter", this.getTemplateViewModel(), this.caller);
        this.paymentCategoryFilter.setLabel("Payment Category");

        this.scheduledRepublishPaymentCategoryFilter = new filterDropdown_template("scheduledRepublishPaymentCategoryFilter", this.getTemplateViewModel(), this.caller);
        this.scheduledRepublishPaymentCategoryFilter.setLabel("Payment Category");

        this.datePicker = new filterSingleDate_template("filterDate", this.getTemplateViewModel(), this.caller);
        this.imagePicker = new imagePicker_template("imagePicker", this.getTemplateViewModel(), this.caller);
        this.imagePicker.setNumberOfRecentImages(50);

        //this.imagePickerM = new imagePicker_template_mockup("imagePickerM", this.getTemplateViewModel(), this.caller);

        this.articleDirectory = new directoryEdit_template("article_directory", this.getTemplateViewModel(), this.caller)
        this.articleDirectory.setId('article_directory');

        this.filterCategory = new multipleSelector_template("article_categoryFilter", this.getTemplateViewModel(), this.caller);
        this.filterCategory.setFilterContainerClass('margin-neg');
        this.filterCategory.setSelectAllEnabled(false);
        this.filterCategory.setSearchEnabled(true);

        this.filterCategory.setLabel("Categories");

        this.filterTag = new filterTag_template("filterTag", this.getTemplateViewModel(), this.caller);
        this.filterDataset = new filterDataset_template("filterDataset", this.getTemplateViewModel(), this.caller);

        this.scheduleDatePicker = new filterSingleDate_template("filterScheduleDate", this.getTemplateViewModel(), this.caller);
        this.scheduleDatePicker.setDate(this.getFormattedEasternTimeZoneDateTime());
        this.scheduleDatePicker.setMinutesInterval(1);

        this.giveawayDatePicker = new filterSingleDate_template("giveawayDatePicker", this.getTemplateViewModel(), this.caller);

        this.republishDatePicker = new filterSingleDate_template("filterRepublishDate", this.getTemplateViewModel(), this.caller);
        this.republishDatePicker.setDate(this.getFormattedEasternTimeZoneDateTime());
        this.republishDatePicker.setMinutesInterval(1);

        this.scheduledRepublishDatePicker = new filterSingleDate_template("filterScheduledRepublishDate", this.getTemplateViewModel(), this.caller);
        this.scheduledRepublishDatePicker.setDate(this.getFormattedEasternTimeZoneDateTime());
        this.scheduledRepublishDatePicker.setMinutesInterval(1);

        this.dateDevelopingStoryCoverageStartPicker = new filterSingleDate_template("filterDateDevelopingStoryCoverageStart", this.getTemplateViewModel(), this.caller);
        this.dateDevelopingStoryCoverageStartPicker.setMinutesInterval(1);
        this.dateDevelopingStoryCoverageStartPicker.toggleClearButton(true);

        this.dateDevelopingStoryCoverageEndPicker = new filterSingleDate_template("filterDateDevelopingStoryCoverageEnd", this.getTemplateViewModel(), this.caller);
        this.dateDevelopingStoryCoverageEndPicker.setMinutesInterval(1);
        this.dateDevelopingStoryCoverageEndPicker.toggleClearButton(true);

        this.developingStoryCoverageToolTipContent = `
        <ul>
            <li>If you simply wish to display the “Live Blogging” with no schema changes, leave both datetime fields empty.</li>
            <li>Setting a start time and end time will enable LiveBlogPosting schema only during the specified time period.</li>
            <li>If you set a start time without an end time, the LiveBlogPosting schema will remain on the article indefinitely.</li>
        </ul>
        `;
        this.developingStoryCoverageToolTip = new infoButton_template('developingStoryCoverageToolTip', this.getTemplateViewModel(), this.caller)
        this.developingStoryCoverageToolTip.setTitle('Developing Story Coverage');
        this.developingStoryCoverageToolTip.setContent(this.developingStoryCoverageToolTipContent);

        this.filterArticle = new filterArticle_template("filterArticle", this.getTemplateViewModel(), this.caller);

        this.productReview = new productReview_template("productReview", this.getTemplateViewModel(), this);
        this.productReviewSandbox = new productReview_template("productReviewSandbox", this.getTemplateViewModel(), this);
        this.productReviewRepublish = new productReview_template("productReviewRepublish", this.getTemplateViewModel(), this);

        this.filterReviewTag = new filterAutocomplete_template('filterAutocompleteReviewTag_template', this.getTemplateViewModel(), this.caller);
        this.filterReviewTag.setPlaceholderAndLabel( 'Tag Reviewed by this Article' );
        this.filterReviewTag.setOptionType('Review Tag');
        this.filterReviewTag.setAddNewOptionEnabled(false);

        this.articleContent = new articleContent_template('article_content_section', this.getTemplateViewModel(), this);
        this.sandboxContent = new articleContent_template('article_sandbox_section', this.getTemplateViewModel(), this);
        this.republishContent = new articleContent_template('article_republish_section', this.getTemplateViewModel(), this);

        this.sandboxDirectory = new directoryEdit_template("sandbox_directory", this.getTemplateViewModel(), this.caller)
        this.sandboxDirectory.setId('sandbox_directory');

        this.republishDirectory = new directoryEdit_template("republish_directory", this.getTemplateViewModel(), this.caller)
        this.republishDirectory.setId('republish_directory');

        this.recoveryReviewSection = new productReviewView_template('recoveryReviewSection', this.getTemplateViewModel(), this);
        this.recoverySandboxReviewSection = new productReviewView_template('recoverySandboxReviewSection', this.getTemplateViewModel(), this);
        this.recoveryRepublishReviewSection = new productReviewView_template('recoveryRepublishReviewSection', this.getTemplateViewModel(), this);

        this.recoveryDirectory = new directoryView_template('recoveryDirectory', this.getTemplateViewModel(), this);
        this.recoverySandboxDirectory = new directoryView_template('recoverySandboxDirectory', this.getTemplateViewModel(), this);
        this.recoveryRepublishDirectory = new directoryView_template('recoveryRepublishDirectory', this.getTemplateViewModel(), this);

        this.revisionReviewSection = new productReviewView_template('revisionReviewSection', this.getTemplateViewModel(), this);
        this.revisionDirectory = new directoryView_template('revisionDirectory', this.getTemplateViewModel(), this);

        this.articleAnalytics = new articleAnalytics_template('articleAnalytics', this.getTemplateViewModel(), this);

        this.toolTipButton = new infoButton_template('toolTip', this.getTemplateViewModel(), this.caller)
        this.toolTipButton.setTitle('Help: Embed');

        let toolTipText =  '' +
            '<div style="display: flex;align-items: flex-start">' +
            '<video src="/assets/videos/article-embed.mp4" autoplay loop muted style="width: 40%; float: left; margin: 0 10px 5px 0;"></video><br>' +
            '<div>' +
            '<p>Paste into this text box information to generate the embed code.  The following are accepted:</p>' +
            '<ul>' +
            '<li>Full URL from supported platforms</li>' +
            '<li>ID of a post from supported platforms</li>' +
            '<li>Full embed code in html</li>' +
            '</ul>' +
            '</div>' +
            '</div>'
        ;

        this.toolTipButton.setContent(toolTipText);

        this.customRecipientsToolTipButton = new infoButton_template('customRecipientsToolTipButton', this.getTemplateViewModel(), this.caller)
        this.customRecipientsToolTipButton.setTitle('Help: Custom');

        let customRecipientstoolTipText =  '' +
            '<div style="display: flex;align-items: flex-start">' +
            '<p>Input comma-separated email addresses to receive a copy of the email. Spaces will be stripped.</p>' +
            '</div>'
        ;

        this.customRecipientsToolTipButton.setContent(customRecipientstoolTipText);


        this.pinnedTagTooltipContent = `
        <p>A tag must have an associated image and at least one specification value to be selected. Only those marked with a green indicator are available for use by your brand.</p>

        `
        this.pinnedTagTooltip = new infoButton_template('pinnedTagTooltip', this.getTemplateViewModel(), this.caller)
        this.pinnedTagTooltip.setTitle('Tag Selection');
        this.pinnedTagTooltip.setContent(this.pinnedTagTooltipContent);

        this.selectProductTooltipContent = `
        <p>All tags are displayed here but only those marked with a green indicator are currently available for use by your brand.</p>
        <ul>
            <li class="is-active">Available for use.</li>
            <li class="is-not-active">Not available for use.</li>
        </ul>
        `
        this.selectProductTooltip = new infoButton_template('selectProductTooltip', this.getTemplateViewModel(), this.caller)
        this.selectProductTooltip.setTitle('Tag Selection');
        this.selectProductTooltip.setContent(this.selectProductTooltipContent);

        this.copyLeaksResultsSectionTooltipContent = `
        <ul>
            <li>"Not Submitted" indicates an article will not be submitted for plagiarism detection.</li>
            <li>"Pending Submission" indicates an article will be submitted for plagiarism detection the first time it is "Scheduled" or "Published". It will also be submitted when there is a "Scheduled Republish" or it is "Republished".</li>
            <li>"Submitted" indicates an article has been submitted for plagiarism detection. Once a result is received, it will only be visible to users with the permission to publish or republish.</li>
        </ul>
        `
        this.copyLeaksResultsSectionTooltip = new infoButton_template('copyLeaksResultsSectionTooltip', this.getTemplateViewModel(), this.caller)
        this.copyLeaksResultsSectionTooltip.setTitle('COPYLEAKS Results');
        this.copyLeaksResultsSectionTooltip.setContent(this.copyLeaksResultsSectionTooltipContent);

        this.tagPicker = new tagPicker_template("tagPicker", this.getTemplateViewModel(), this.caller);
        this.tagPicker.setParent(this);
        this.tagPicker.set_isHyperLinkModeEnabled(true);
        this.articlePinnedTags = new articlePinnedTags_template('articlePinnedTags', this.getTemplateViewModel(), this.caller);

        this.articlePicker =  new articlePicker_template("articlePicker", this.getTemplateViewModel(), this.caller);
        this.articlePickerHelper = new articlePicker_helper(this.articlePicker, this.caller.getVnAppZone(), this.caller);
        this.articlePicker.setIsHyperLinkModeEnabled(true);
        this.articlePicker.setCaller(this.articlePickerHelper);

        this.featureImageTooltipContent = `
        <p>The featured image is required and will always be displayed on the article page below the article title.</p>
        `
        this._featureImageToolTip = new infoButton_template('featureImageTooltip', this.getTemplateViewModel(), this.caller)
        this._featureImageToolTip.setTitle('Feature Image');
        this._featureImageToolTip.setContent(this.featureImageTooltipContent);


        //Featured Tag section
        this.featuredTagSectionFeaturedImagePreview = `<p>This is the default image that will be used when an article is presented on the homepage, listing pages, or sidebar of a website. If you do not want to use this image, select a Thumbnail Image to be used in its place</p>`;
        this.featuredTagImagePreviewToolTip = new infoButton_template('featuredTagImagePreviewToolTip', this.getTemplateViewModel(), this.caller);
        this.featuredTagImagePreviewToolTip.setTitle('Featured Image Preview');
        this.featuredTagImagePreviewToolTip.setContent(this.featuredTagSectionFeaturedImagePreview);

        this.featuredTagSectionThumbnailImagePreview = `<p>The thumbnail image is an optional image used when an article is presented on the homepage, listing pages, or sidebar of a website. If the thumbnail is left blank the defaulted tag image (previewed above) will be used in those cases</p>`
        this.featuredTagThumbnailPreviewToolTip = new infoButton_template('featuredTagThumbnailPreviewToolTip', this.getTemplateViewModel(), this.caller);
        this.featuredTagThumbnailPreviewToolTip.setTitle('Thumbnail Image Preview');
        this.featuredTagThumbnailPreviewToolTip.setContent(this.featuredTagSectionThumbnailImagePreview);

        this.thumbnailImageTooltipContent = `
        <p>The thumbnail image is an optional image used when an article is presented on the homepage, listing pages, or sidebar of a website. If the thumbnail is left blank the featured image will be used in place of the thumbnail image.</p>
        `
        this.thumbnailImageToolTip = new infoButton_template('thumbnailImageTooltip', this.getTemplateViewModel(), this.caller)
        this.thumbnailImageToolTip.setTitle('Thumbnail Image');
        this.thumbnailImageToolTip.setContent(this.thumbnailImageTooltipContent);

        this.alternateSocialMediaImageTooltipContent = `
        <p>The alternate image is an optional image used when the article is linked on social media platforms. If the alternate image is left blank the featured will be used in place of the alternate image.</p>
        `
        this.alternateSocialMediaImageToolTip = new infoButton_template('alternateImageTooltip', this.getTemplateViewModel(), this.caller)
        this.alternateSocialMediaImageToolTip.setTitle('Alternate Image');
        this.alternateSocialMediaImageToolTip.setContent(this.alternateSocialMediaImageTooltipContent);

        this.emakiLabHelperTooltipContent = `
        <p>This button is an <strong><em>EmakiLab Helper Tool</em></strong> and will <strong><em>Automatically Populate Tag and Category</em></strong> suggestions, based on the content of the article.</p>
        <p>This works best when all of the content of the article is written, as it will base itself on that content. The results may vary with each use of the button, but it is recommended to only use the button once.  There is a limit on the amount of times the button can be used on each article.</p>
        <p><strong>Note:</strong> The tool will only base itself on the Content of the article and cannot provide results for very long articles</p><p>~3000+ words.</p>
        `
        this.emakiLabHelperTooltip = new infoButton_template('emakiLabHelperTooltip', this.getTemplateViewModel(), this.caller)
        this.emakiLabHelperTooltip.setContent(this.emakiLabHelperTooltipContent);

        let optimizableImagesSections: string[] = [
            'article_content',
            'article_faq',
            'article_directory_item_description',
            'article_republish',
            'article_sandbox',
            'featured_image'
        ];
        this.imagePickerHelper = new imagePickerHelper(
            this.imagePicker,
            this.caller.viewModel,
            this.caller.getVnAppZone(),
            this.caller,
            optimizableImagesSections
        );
        this.embedHelper = new EmbedHelper(this.caller);

        this.imageWidgetForThumbnailImage = new imageWidget_template('thumbnail_image', this.getTemplateViewModel(), this)
        this.imageWidgetForThumbnailImage.setMode('single-select');
        this.imageWidgetForThumbnailImage.setCaller(this.imagePickerHelper);

        this.imageWidgetForAlternateImage = new imageWidget_template('alternate_image', this.getTemplateViewModel(), this)
        this.imageWidgetForAlternateImage.setMode('single-select');
        this.imageWidgetForAlternateImage.setCaller(this.imagePickerHelper);

        this.imageWidgetForFeaturedImage = new imageWidget_template('featured_image', this.getTemplateViewModel(), this);
        this.imageWidgetForFeaturedImage.setMode('single-select');
        this.imageWidgetForFeaturedImage.setCaller(this.imagePickerHelper);

        this.imageWidgetForTagImageGroup = new imageWidget_template('featured_image_group', this.getTemplateViewModel(), this);
        this.imageWidgetForTagImageGroup.setMode('multi-select-no-gallery');
        this.imageWidgetForTagImageGroup.setCaller(this.imagePickerHelper);


        this.warningDialog_WhenLogOut = new warningDialog_template('dialogLogout', this.getTemplateViewModel(), this)
        this.warningDialog_WhenArticleLock = new warningDialog_template('dialogArticleLock', this.getTemplateViewModel(), this)

        this.videoInstructionToolTip = new infoButton_template('videoInstruction', this.getTemplateViewModel(), this.caller)
        this.videoInstructionToolTip.setTitle("Video Upload Instruction")
        this.videoInstructionToolTip.setContent(`
        <p>Videos are associated with articles. If a video is uploaded but not used in the content, the stored copy will be deleted on save.
        Videos should therefore be uploaded for each article they will be used in. Videos must be in MP4 format and file sizes cannot exceed 200MB.
        `)


        this.videoPicker = new videoPicker_template("videoPicker", this.getTemplateViewModel(), this.caller);

        this.videoPickerHelper = new videoPickerHelper(
            this.videoPicker,
            this.caller.viewModel,
            this.caller.getVnAppZone(),
            this.caller
        );

        this.warningDialog_sandboxDelete = new warningDialog_template('dialogSandboxDelete', this.getTemplateViewModel(), this.caller);
        this.warningDialog_sandboxDelete.setTitle('Confirm');
        this.warningDialog_sandboxDelete.setMessage('Are you sure you want to delete the sandbox. This version of the content will not be recoverable.');

        this.warningDialog_newsletterSendingConfirmation = new warningDialog_template('warningDialog_newsletterSendingConfirmation', this.getTemplateViewModel(), this.caller);
        this.warningDialog_newsletterSendingConfirmation.setTitle('Confirm');

        this.warningDialog_republishDelete = new warningDialog_template('dialogRepublishDelete', this.getTemplateViewModel(), this.caller);
        this.warningDialog_republishDelete.setTitle('Confirm');
        this.warningDialog_republishDelete.setMessage('Are you sure you want to delete the republish.  This version of the content will not be recoverable.');

        this.warningDialog_republishCreateAndUpdate = new warningDialog_template('dialogRepublishCreateAndUpdate', this.getTemplateViewModel(), this.caller);
        this.warningDialog_republishCreateAndUpdate.setTitle('Confirm');
        this.warningDialog_republishCreateAndUpdate.setMessage('Are you sure you want to create and update the article content with the republish.');

        this.updateTimeToolTipButton = new infoButton_template('toolTip', this.getTemplateViewModel(), this.caller)
        this.updateTimeToolTipButton.setTitle('Update Time');
        this.updateTimeToolTipButton.setContent('<p>If the article is saved with this option checked, the date displayed on the website will become the current time of the save. Note that this does not affect anything within Emaki.</p>');

        this.newsletterTemplateSelector = new filterDropdown_template('newsletterTemplateSelector', this.getTemplateViewModel(), this.caller);
        this.newsletterTemplateSelector.setLabel('Template');
        this.newsletterDateScheduledSelector = new filterSingleDate_template('newsletterDateScheduledSelector', this.getTemplateViewModel(), this.caller);
        this.newsletterDateScheduledSelector.setDate(this.getFormattedEasternTimeZoneDateTime());
        this.newsletterDateScheduledSelector.setMinutesInterval(1);

        this.sensaiPromptTemplate = new genericPrompt_template('sensaiPrompt', this.getTemplateViewModel(), this.caller);
        this.sensaiPromptTemplate.setTitle("Content Value Guidelines");
        this.sensaiPromptTemplate.setContent(""); // revisit this will subsequently be updated..
        this.sensaiPromptTemplate.setSensaiRulePointThreshold(this.getTemplateViewModel().sensaiCoverageScore());

        this.articleReviewHistory = new articleReviewHistory_template('articleReviewHistory', this.getTemplateViewModel(), this.caller);

        this.sensaiProgressBar = new sensaiProgressBar_template('sensaiProgressBar', this.getTemplateViewModel(), this.caller);

        this.sensaiChat = new sensai_chat_template('sensAI_vault', this.getTemplateViewModel(), this.caller);

        this.sourceNewsDatePicker = new filterSingleDate_template('sourceNewsDatePicker', this.getTemplateViewModel(), this.caller);
        this.sourceNewsDatePicker.setDate(this.getFormattedEasternTimeZoneDateTime());
        this.sourceNewsDatePicker.setMinutesInterval(1);
    }

    public buildDatePickerCalendar() {
        this.datePicker.buildCalendar();

        this.giveawayDatePicker.buildCalendar();
        this.giveawayDatePicker.getTemplateViewModel().singleDatePicker(null);

        this.scheduleDatePicker.buildCalendar(this.createEasternTimeZoneDateTime());
        this.republishDatePicker.buildCalendar(this.createEasternTimeZoneDateTime());
        this.scheduledRepublishDatePicker.buildCalendar(this.createEasternTimeZoneDateTime());
        this.newsletterDateScheduledSelector.buildCalendar(this.createEasternTimeZoneDateTime());
        this.dateDevelopingStoryCoverageStartPicker.buildCalendar();
        this.dateDevelopingStoryCoverageStartPicker.getTemplateViewModel().singleDatePicker(null);
        this.dateDevelopingStoryCoverageEndPicker.buildCalendar();
        this.dateDevelopingStoryCoverageEndPicker.getTemplateViewModel().singleDatePicker(null);

        this.tagPicker.buildDatePickerCalendars();
        this.sourceNewsDatePicker.buildCalendar();
        this.sourceNewsDatePicker.getTemplateViewModel().singleDatePicker(null);


    }

    protected getTemplateName(): string {

        return "articlesEdit_template_new";
    }

    protected buildViewModel(): any {

        const self = this;

        const vm =
            {
            id: ko.observable(""),
            permalinkHistory: ko.observableArray([]),
            isPermalinkPopupShown: ko.observable(false),
            permalinkRedirects: ko.observableArray([]),
            prompt: ko.observable(""),
            promptResponse: ko.observable(""),
            promptLink: ko.observable(""),
            idTemplate: ko.observable(null),
            idTemplateLayout: ko.observable(null),
            idTemplateLayoutPrevious: ko.observable(null),
            templateLayout: ko.observable(null),
            templateLayouts: ko.observableArray([]),
            templateLayoutsFiltered: ko.observableArray([]),
            isFeaturedTagDisabled: ko.observable(false),
            isFeaturedVideoDisabled: ko.observable(false),
            idPoll: ko.observable(null),
            pollName: ko.observable(""),
            dateUpdated: ko.observable(""),
            dateCreated: ko.observable(""),
            title: ko.observable(""),
            brand: ko.observable(""),
            affiliateBrands: ko.observableArray([42,41,29,20,21,23,27,28,31,6,4]),
            OSPBrands: ko.observableArray([21,31]),
            newsNowBrands: ko.observableArray([32,33,36]),
            selectedTab: ko.observable(Previewable.ARTICLE),
            selectedRecoveryTab: ko.observable(Recoverable.CONTENT),
            content: ko.observable(),
            recoveryContent: ko.observable(),
            sandboxRecoveryContent: ko.observable(),
            republishRecoveryContent: ko.observable(),
            sandboxRecoveryIntroText: ko.observable(),
            sandboxRecoveryReviewItems: ko.observable(),
            fieldValueChanges: ko.observableArray([]),
            tagNameChanges: ko.observableArray([]),
            recoveryReviewItems: ko.observable(),
            recoveryIntroText: ko.observable(),
            recoveryUser: ko.observable(),
            dateRecovery: ko.observable(),
            recovery: ko.observable(),
            sandboxRecovery: ko.observable(''),
            republishRecovery: ko.observable(''),
            selectedRevisionIndex: ko.observable(0),
            revisionContent: ko.observable(),
            revisionIntroText: ko.observable(),
            revisionReviewItems: ko.observableArray(),
            isAddingNewTypeOrProduct: ko.observable(false),
            reviewItemFormItemToAdd: ko.observable(""),
            newTypeOrProductName: ko.observable(""),
            idRevisionSelected: ko.observable(),
            isGiveawaySectionCollapsed: ko.observable(false),
            listOrder: ko.observable(),
            seoTitle: ko.observable(),
            featuredTags: ko.observable(null),
            defaultFeaturedTags: ko.observable(null),
            reviewTag: ko.observable(null),
            featuredImage: ko.observable(null),
            idFeaturedImage: ko.observable(""),
            IsFeaturedImageMobileOptimized: ko.observable(false),
            defaultFeaturedImage: ko.observable(null),
            validAutoPricingPartnerNames: ko.observableArray([]),
            articlePageSettings: ko.observableArray([]),
            seoDescription: ko.observable(),
            smoTitle: ko.observable(),
            smoDescription: ko.observable(),
            articles: ko.observableArray([]),
            excerpt: ko.observable(""),
            displayConfiguration: ko.observable(1),
            isAdHidden: ko.observable(false),
            isAmpDisabled: ko.observable(false),
            isUnderEmbargo: ko.observable(false),
            isUpdateTime: ko.observable(false),
            contentKeyPoints: ko.observable(''),
            isDevelopingStory: ko.observable(false),
            isVersusStyle: ko.observable(false),
            reviewCategory: ko.observable(""),
            reviewItems: ko.observableArray([]),
            backupReviewItems: ko.observableArray([]),
            sandboxReviewItems: ko.observableArray([]),
            reviewItemsToDelete: ko.observableArray([]),
            fileUrl: ko.observable(""),
            tableOfContents: ko.observable(false),
            isNewsNowArticle: ko.observable(false),
            isSponsored: ko.observable(false),
            reference: ko.observable(""),
            editor: ko.observable(""),
            datePublished: ko.observable(""),
            dateLastPublishStatus: ko.observable(""),
            dateMostRecentPublishStatus: ko.observable(""),
            dateLastSyncStatus: ko.observable(""),
            dateLastStatus: ko.observable(""),
            author: ko.observable(""),
            displayAuthor: ko.observable(""),
            jrEditor: ko.observable(""),
            ideator: ko.observable(""),
            targetAudience: ko.observable(""),
            intent: ko.observable(""),
            contentType: ko.observable(""),
            segment: ko.observable(""),
            showSegmentTab: ko.observable(false),
            segments: ko.observable([]),
            networkCategory: ko.observable(""),
            postPaymentCategory: ko.observable(""),
            canSearchUsers: ko.observable(false),
            showNewRepublish: ko.observable(false),
            showScheduledRepublish: ko.observable(false),
            showDeleteRepublishButton: ko.observable(false),
            allowEditPermalink: ko.observable(true),
            pinnedTag: ko.observable(false),
            amazonsiteArticleTitle: ko.observable(""),
            newsNowArticleTitle: ko.observable(""),
            amazonsitePublishDate: ko.observable(""),
            updateAmazonsitePublishDate: ko.observable(false),
            articleRepublishHistory: ko.observableArray([]),
            newRepublishDate: ko.observableArray(""),
            permalink: ko.observableArray(""),
            republishes: ko.observableArray([]),
            idRepublish: ko.observable(null),
            idDeleteRepublish: ko.observable(null),
            republishesCount: ko.observable(0),
            amountAuthor: ko.observable(null),
            percentageAuthor: ko.observable(null),
            percentageEditor: ko.observable(null),
            scheduledAmountAuthor: ko.observable(null),
            scheduledPercentageAuthor: ko.observable(null),
            scheduledPercentageEditor: ko.observable(null),
            publishStatuses: ko.observableArray([]),
            articleStatus_options: ko.observableArray([]),
            articleRepublishStatus_options: ko.observableArray([]),
            poll_options: ko.observableArray([]),
            reviewItemAward_options: ko.observableArray([]),
            revisions: ko.observableArray([]),
            sourceOfReversal: ko.observable(""),
            idSyncStatus: ko.observable(""),
            syncStatus: ko.observable(""),
            idPublishStatus: ko.observable(""),
            reviewItemToEdit: ko.observable(null),
            permalinkParts: ko.observableArray([]),
            factualSummary : ko.observable(''),
            simpleSummary: ko.observable(''),
            satiricalCommentary : ko.observable(''),
            reactionPost : ko.observable(''),
            isFactualSummaryEnabled : ko.observable(true),
            isSimpleSummaryEnabled : ko.observable(true),
            showSummary : ko.observable(true),
            isSatiricalCommentaryEnabled : ko.observable(true),
            updateSummariesWithContent : ko.observable(true),
            idChannel: ko.observable(null),
            channelName: ko.observable(null),
            playlists: ko.observable([]),
            reviewItem: ko.observable({
                id: null,
                award: {id: null, name: null, slug: null},
                affiliateLinks: [],
                amazonHeadline: null,
                amazonSummary: null,
                amazonAward: null,
                tag: {
                    id: null,
                    name: null,
                    shortDescription: null,
                    description: null,
                    idType: null,
                    type: {id: null, name: null, slug: null, description: null},
                    data: {id: null, data: null},
                    idImage: null,
                    image: {url: null, altText: null}
                },
                seoDescription: null,
                giveawayUrl: null,
                giveawayExpiryDate: null,
                rating: null,
                extraImages: [],
                extraVideos: null,
                keyFeatures: null,
                pros: null,
                cons: null,
                reviewText: null
            }),
            reviewItemTagName: ko.observable(),
            reviewItemTagTypeName: ko.observable(),
            originalReviewItemTagTypeName: ko.observable(),
            reviewItemIdTag: ko.observable(),
            reviewItemIdTagType: ko.observable(),
            reviewItemIdAffiliate: ko.observable(0),
            reviewItemSeoDescription: ko.observable(),
            reviewItemAmazonAward: ko.observable(),
            reviewItemAmazonHeadline: ko.observable(),
            reviewItemAmazonSummary: ko.observable(),
            idReviewItem: ko.observable(),
            reviewItemRating: ko.observable(),
            reviewItemAmazonRating: ko.observable(),
            reviewItemGiveawayUrl: ko.observable(),
            reviewItemGiveawayExpiryDate: ko.observable(),
            reviewItemReviewText: ko.observable(),
            reviewItemIdAwardType: ko.observable(),
            reviewItemTagSpecifications: ko.observableArray([]),
            addedReviewItemTagSpecifications: ko.observableArray([]),
            reviewItemKeyFeatures: ko.observableArray([]),
            reviewItemAffiliateLinks: ko.observableArray([]),
            reviewItemPros: ko.observableArray([]),
            reviewItemCons: ko.observableArray([]),
            reviewItemImages: ko.observableArray([]),
            reviewItemExtraVideos: ko.observableArray([]),
            reviewItemExtraVideo: ko.observable(""),
            articleCurrentIdArticleStatus: ko.observable(""),
            networkCategory_options: ko.observableArray([]),
            idNetworkCategory: ko.observable(""),
            contentType_options: ko.observableArray([]),
            idContentType: ko.observable(""),
            segment_options: ko.observableArray([]),
            idSegment: ko.observable(""),
            intent_options: ko.observableArray([]),
            idIntent: ko.observable(""),
            paymentCategory_options: ko.observableArray([]),
            idPaymentCategory: ko.observable(""),
            idRepublishPaymentCategory: ko.observable(""),
            idStatus: ko.observable(1),
            idPreviousStatus: ko.observable(1),
            idRepublishStatus: ko.observable(1),
            idPreviousRepublishStatus: ko.observable(1),
            question: ko.observable(""),
            selectedFaqIndex: ko.observable(null),
            productTagName: ko.observable(""),
            idTagAward: ko.observable(""),
            updatedReviewItems: ko.observableArray([]),
            productTagSeoDescription: ko.observable(""),
            productTagShortDescription: ko.observable(""),
            idAffiliateLink: ko.observable(""),
            productSpecifications: ko.observableArray([]),
            affiliateLinks_options: ko.observableArray([]),
            isFaqAddFormShown: ko.observable(false),
            isSaveBoxSticky: ko.observable(false),
            isFaqDeleteVisible: ko.observable(false),
            isReviewItemUpdatesFormShown: ko.observable(false),
            isEmbedPopUpVisible: ko.observable(false),
            isEmbedFocused:ko.observable(false),
            embedSource:ko.observable(null),
            embedCode:ko.observable(null),
            embedErrors: ko.observableArray([]),
            embedType_options: ko.observableArray(embedTypesList()),
            embedType: ko.observable('all'),
            embedContext: ko.observable(EmbedContext.CONTENT),
            previewEmbedType: ko.observable(''),
            activeCkEditorInstance: ko.observable(null),
            isReviewProductFormShown: ko.observable(false),
            faqs: ko.observableArray([]),
            faqsToDelete: ko.observableArray([]),
            selectedCategories: ko.observableArray([]),
            selectedTags: ko.observableArray([]),
            categories: ko.observableArray([]),
            contentPresets: ko.observableArray([]),
            idPrimaryCategory: ko.observable(null),
            permissions: ko.observableArray(this.initPermissions(['article_edit_embargo', 'article_edit_takeover', 'article_edit_publishingControl','article_edit_config_amp','article_edit_config_ads','article_edit_display_options','article_edit_config_affiliate_linker','emaki_lab', 'newsletter_email_edit', 'newsletter_email_view', 'article_edit_config_ads'])),
            idPrimaryTag: ko.observable(null),
            isLockMessageVisible: ko.observable(false),
            isRepublishMessageVisible: ko.observable(false),
            saveType: ko.observable(null),
            isAffiliateLinkerEnabled: ko.observable(true),
            isSaveButtonDisabled: ko.observable(false),
            lastSaved: ko.observable("Never"),
            showAutoSaveMessage: ko.observable(false),
            autoSaveMessage: ko.observable(""),
            showIsAutosaving: ko.observable(false),
            lockMessage: ko.observable(""),
            isKickoutMessageVisible: ko.observable(false),
            isNoticeVisible: ko.observable(false),
            noticeMessage: ko.observable(""),
            isArticleLocked: ko.observable(false),
            isArticleAutoSaveError: ko.observable(false),
            kickoutMessage: ko.observable(""),
            tagImage: ko.observable(null),
            keyFeature: ko.observable(""),
            imagePickerTarget: ko.observable(null),
            tagPickerTarget: ko.observable(null),
            pro: ko.observable(""),
            con: ko.observable(""),
            faqToDelete: ko.observable(null),
            oldVersion: ko.observable(null),
            newVersion: ko.observable(null),
            versionDiffResult: ko.observable(false),
            isSandboxContent: ko.observable(false),
            previewContentType: ko.observable(Previewable.ARTICLE),
            amazonOnsite: ko.observable(null),
            newsletterServiceType: ko.observable(null),
            idClassification: ko.observable(null),
            classificationName: ko.observableArray(null),
            classificationOptions : ko.observableArray([]),
            classificationAllOptions : ko.observableArray([]),
            paymentTypeRepublish : ko.observableArray([{name: "Amount"}, {name: "Percentage"}]),
            choosenPaymentTypeRepublish : ko.observable(null),
            choosenScheduledPaymentTypeRepublish : ko.observable(null),
            isPinnedTagsFormVisible:ko.observable(false),
            isFeaturedTagActive:ko.observable(false),
            updateLatestRepublishDateIsChecked : ko.observable(false),
            latestRepublishId : ko.observable(''),
            template: ko.observable(""),
            isFeaturedImageHidden: ko.observable(false),
            isCommentsDisabled: ko.observable(false),
            isCommentsPaused: ko.observable(false),
            isRatingEnabled: ko.observable(false),
            isReadNextDisabled: ko.observable(false),
            isSidebarHidden: ko.observable(false),
            isDisplayCardQuickLinksShown: ko.observable(false),
            isDisplayCardQuickLinksMobileShown: ko.observable(false),
            socialTagLine: ko.observable(),
            sessionExpiredOnSaveRecovery: ko.observable(false),
            lastSaveRecoveryAttempt: ko.observable(""),
            plagiarismStatus: ko.observable(null),
            isPublishingControl: ko.observable(false),
            isGlobalLockEnabled : ko.observable(false),
            isFeaturedVideoActive: ko.observable(false),
            isFeaturedEmbedActive: ko.observable(false),
            isFeaturedImageActive: ko.observable(true),
            featuredVideo : ko.observable(null),
            featuredEmbed : ko.observable(null),
            featuredSectionValue : ko.observable("featuredImage"),
            chosenFeaturedSectionValue : ko.observable("featuredImage"),
            autoCategorizationGenerationAttemptsRemaining : ko.observable(4),
            republishRecoveryDate: ko.observable(''),
            republishRecoveryStatus: ko.observable(''),
            republishRecoveryAuthor: ko.observable(''),
            republishRecoverySrEditor: ko.observable(''),
            republishRecoveryJrEditor: ko.observable(''),
            republishRecoveryPaymentCategory: ko.observable(''),
            republishRecoveryAuthorAmount: ko.observable(''),
            republishRecoveryAuthorPercentage: ko.observable(''),
            republishRecoveryEditorPercentage: ko.observable(''),
            isSandboxActive: ko.observable(false),
            isRepublishActive: ko.observable(false),
            isSubContent: ko.observable(false),
            newsletterSubject: ko.observable(""),
            newsletterPreviewText: ko.observable(""),
            newsletterSendToSelf: ko.observable(false),
            newsletterRecipientsEmails: ko.observable(""),
            newsletterMailingLists: ko.observableArray([]),
            selectedMailingLists: ko.observableArray([]),
            newsletterEmailErrors: ko.observableArray([]),
            sensaiPromptContent: ko.observableArray([]),
            articleReviewComments: ko.observable(""),
            articleHistoricalReviewComments: ko.observable([]),
            hasNewFeedback: ko.observable(false),
            showSubContent: ko.observable(true),
            showFeaturedImage: ko.observable(true),
            showSelectFeaturedVideo: ko.observable(true),
            showSelectFeaturedEmbed: ko.observable(true),
            showSEO: ko.observable(true),
            featuredVideoTitle: ko.observable(""),
            showFeaturedVideoTitle: ko.observable(false),
            featuredVideoDescription: ko.observable(""),
            showFeaturedVideoDescription: ko.observable(false),
            dateLastPreview: ko.observable(null),
            showFAQ: ko.observable(true),
            showContent: ko.observable(true),
            showSponsoredDisclaimer: ko.observable(true),
            showDevelopingStoryDisclaimer: ko.observable(true),
            showTableOfContents: ko.observable(true),
            showQuickShopLinks: ko.observable(true),
            isTitleDisabled: ko.observable(false),
            defaultThreadsImage: ko.observable(null),
            isAdmin: ko.observable(false),
            isPromptAuthorVisible: ko.observable(true),
            isExcerptVisible: ko.observable(true),
            previousIdPublishStatus: ko.observable(),
            sensaiCoverageScore : ko.observable(null),
            sensaiRuleScore : ko.observable(null),
            sensaiRulePointThreshold: ko.observable(null),
            showPinnedTags: ko.observable(true),
            republishIsUnderEmbargo: ko.observable(false),
            userPicture: ko.observable(""),
            roleName:  ko.observable(""),
            contentTypeName: ko.observable(""),
            monthName:  ko.observable(""),
            isSessionTrackerVisible: ko.observable(false),
            isUserHasTier2Rates: ko.observable(false),
            articleCount: ko.observable(0),
            sessionsPerArticle: ko.observable(0),
            articleGoal: ko.observable(0),
            articleGoalProgressPercentage: ko.observable(0),
            sessionGoalProgressPercentage: ko.observable(0),
            tier2SessionGoalProgressPercentage: ko.observable(0),
            sessionsPerArticleTarget: ko.observable(0),
            tier2SessionsPerArticleTarget: ko.observable(0),
            tier1Amount: ko.observable(0),
            tier2Amount: ko.observable(0),
            outputTransactionsTotal: ko.observable(0),
            brandSessionTarget: ko.observable(null),
            brandProgressPercentage: ko.observable(0),
            contentTypeProgressPercentage: ko.observable(0),
            brandContentTypeSessionTarget: ko.observable(null),
            selectedView:ko.observable("default"),
            isSensaiVaultVisible: ko.observable(false),
            sensaiVaultGeneratedHtml: ko.observable(""),
            // ----- SENSAI CHAT -----
            chatHistory: ko.observableArray([]),
            isChatDisabled: ko.observable(false),
            summaryReturned: ko.observable(false),
            similarArticlesReturned: ko.observable(false),
            systemPrompt: ko.observable(""),
            userQuery: ko.observable(""),
            temperature: ko.observable(0.5),
            summary: ko.observable(""),
            sensaiArticles: ko.observable(""),
            sensaiImagePickerTarget: ko.observable(null),
            sessionId: ko.observable(""),
            valnetImageData: ko.observable([]),
            onClickSaveAiSummaries: function (data, event) {
                self.caller.saveArticleAiSummaries();
            },
            onClickQuickPrompt: function (data, event) {
                self.onClickQuickPrompt(data, event);
            },
            onClickSummarize: function (data, event) {
                self.onClickSummarize(data, event);
            },
            onClickSimilarArticles: function (data, event) {
                self.initiateSensaiChat(null);
                this.hideHistoryTitle();
                const textarea = document.querySelector('.sensai-vault-user-query textarea') as HTMLTextAreaElement;
                if (textarea) {
                    textarea.style.height = "auto";
                }
                // Add the 'clicked' class to the container
                const container = document.querySelector('.sensai-vault-user-query-container');
                if (container) {
                    container.classList.add('clicked');
                }
            },
            onEnterKey: function (data, event) {
                if (event.keyCode === 13 && !event.shiftKey) {
                    self.initiateSensaiChat(event.target.value);
                    event.target.value = "";
                    this.hideHistoryTitle();
                    event.target.style.height = "auto";
                    // Add the 'clicked' class to the container
                    const container = document.querySelector('.sensai-vault-user-query-container');
                    if (container) {
                        container.classList.add('clicked');
                    }
                    return false;
                }
                return true;
            },
            hideHistoryTitle: function () {
                const historyTitle = document.querySelector('.history-title-above');
                if (historyTitle) {
                    historyTitle.classList.add('hidden');
                } else {
                    console.error("Element with class 'history-title-above' not found.");
                }
            },
            showArticlePickerSensai: function (data, event) {
                self.showArticlePickerSensai(data, event);
            },
            onClickClearChatHistory: function (data, event) {
                self.clearChatHistory();
            },
            onClickImage: function (data, event) {
                self.onClickImage(data, event);
            },
            onClickNewTab: function (data, event) {
                self.onClickNewTab(data, event);
            },
            editArticleElement: function (data, event) {
                self.editArticleElement(data, event);
            },
            onClickOpenArticleNewTab: function (data, event) {
                self.onClickOpenArticleNewTab(data, event);
            },
            copyPermalink: function (data, event) {
                self.copyPermalink(data, event);
            },
            onClickTag: function (data, event) {
                self.onClickTag(data, event);
            },
            onClickTagOpenInNewTab: function (data, event) {
                self.onClickTagOpenInNewTab(data, event);
            },
            trackerTitle: ko.pureComputed(() => {
                const selectedView = this.getTemplateViewModel().selectedView();
                let title = this.getTemplateViewModel().roleName() + ": " + this.getTemplateViewModel().monthName();
                if (selectedView === 'default') {
                    title = title + " Compensation Tracker";
                } else if (selectedView === 'currency') {
                    title = title + " Compensation Details";
                } else{
                    title = title + " Content Performance";
                }
                return title;
            }),
            explanationText: ko.pureComputed(() => {
                let articleGoalProgressPercentage = this.getTemplateViewModel().articleGoalProgressPercentage();

                let isUserHasTier2Rates = this.getTemplateViewModel().isUserHasTier2Rates();

                let text = "Output target reached, Monthly S/A bonus unlocked!";
                if(articleGoalProgressPercentage < 100){

                    let remainingArticles = this.getTemplateViewModel().articleGoal() - this.getTemplateViewModel().articleCount();

                    text = remainingArticles + " more articles are needed to be eligible for Monthly S/A bonus.";
                }

                let sessionGoalProgressPercentage = this.getTemplateViewModel().sessionGoalProgressPercentage();
                let tier2SessionGoalProgressPercentage = this.getTemplateViewModel().tier2SessionGoalProgressPercentage();
                if(sessionGoalProgressPercentage < 100){

                    let sessionsPerArticleTarget = this.getTemplateViewModel().sessionsPerArticleTarget();

                    let sessionsPerArticle = this.getTemplateViewModel().sessionsPerArticle();

                    let remainingSessions = parseFloat(String(sessionsPerArticleTarget).replace(/,/g, '')) - parseFloat(String(sessionsPerArticle).replace(/,/g, ''));

                    let tier1Amount = this.getTemplateViewModel().tier1Amount();

                    text = text + " Improve S/A by " + remainingSessions.toLocaleString('en-US') + " in order to earn $" + tier1Amount + " bonus payout.";
                }else if(isUserHasTier2Rates && sessionGoalProgressPercentage >= 100 && tier2SessionGoalProgressPercentage < 100){

                    let sessionsPerArticleTarget = this.getTemplateViewModel().tier2SessionsPerArticleTarget();

                    let sessionsPerArticle = this.getTemplateViewModel().sessionsPerArticle();

                    let remainingSessions = parseFloat(String(sessionsPerArticleTarget).replace(/,/g, '')) - parseFloat(String(sessionsPerArticle).replace(/,/g, ''));

                    let tier1Amount = this.getTemplateViewModel().tier1Amount();
                    let tier2Amount = this.getTemplateViewModel().tier2Amount();

                    text = text + " On track for Tier 1 bonus of $" + tier1Amount + ". Improve S/A by " + remainingSessions.toLocaleString('en-US') + " in order to each Tier 2's $" + tier2Amount + " bonus!";
                }else if(!isUserHasTier2Rates && sessionGoalProgressPercentage >= 100){

                    let tier1Amount = this.getTemplateViewModel().tier1Amount();

                    text = text + " On track for Tier 1 bonus of $" + tier1Amount + ". Maintain this S/A through the month to earn it.";
                }else if(isUserHasTier2Rates && tier2SessionGoalProgressPercentage >= 100){

                    let tier2Amount = this.getTemplateViewModel().tier2Amount();

                    text = text + " Maxxed out for Tier 2 bonus of $" + tier2Amount + ". Maintain this S/A through the month to earn it.";
                }

                return text;
            }),
            onClickSelectView: function (data, event) {
                return self.onClickSelectView(event);
            },
            onKeyUpPermalinkParts : function (data,event) {
                self.onKeyUpPermalinkParts(data,event);
            },

            checkIfReviewItemsNeedAnUpdate: function ( value, data, event ) {
                self.checkIfReviewItemsNeedAnUpdate(value);
            },
            onClickFeaturedTag: function (value, data,event){
                self.onClickFeaturedTag(value);
            },
            onChangeTemplate: function (data, event) {
                let action = self.onChangeTemplate(data, event);
                if (action === false) {
                    event.preventDefault();
                } else {
                    let permlinkOriginal = self.getTemplateViewModel().permalink();
                    let permlinkNew = self.prefixPermalink(permlinkOriginal, event.target.value);
                    self.getTemplateViewModel().permalink(permlinkNew);
                }
            },
            onChangeTemplateLayout: function (data, event) {
                let idTemplateLayoutPrevious = self.getTemplateViewModel().idTemplateLayoutPrevious();
                let action = self.onChangeTemplateLayout(data, event);
                let idTemplateLayout = self.getTemplateViewModel().idTemplateLayout();
                if (action === false) {
                    self.setIdTemplateLayout(idTemplateLayoutPrevious);
                    event.preventDefault();
                } else {
                    self.setIdTemplateLayoutPrevious(idTemplateLayout);
                }
            },
            onClickCancel: function (data, event) {
                self.onClickCancel();
            },
            onClickSync: function (data, event) {
                self.onClickSync();
            },
            onClickSave: function (data, event) {
                self.onClickSave();
            },
            onClickSaveAndStay: function (data, event) {
                self.onClickSaveAndStay();
            },
            onClickSaveAndPreview: function (contentType, data, event) {
                self.onClickSaveAndPreview(contentType);
            },
            onClickSaveAndPreviewAMP: function (contentType, data, event) {
                self.onClickSaveAndPreviewAMP(contentType);
            },
            onClickPreviewNoSave: function (contentType, data, event) {
                self.onClickPreviewNoSave(contentType);
            },
            onClickDeleteSandbox: function (data, event) {
                self.onClickDeleteSandbox();
            },
            onClickDeleteRepublish: function (data, event) {
                self.onClickDeleteRepublish();
            },
            onClickRepublishCreateAndUpdate: function (data, event) {
                self.onClickRepublishCreateAndUpdate();
            },
            onClickPreviewAMPNoSave: function (contentType, data, event) {
                self.onClickPreviewAMPNoSave(contentType);
            },
            onClickViewOnSite: function (data, event) {
                self.onClickViewOnSite();
            },
            onClickViewOnSiteAMP: function (data, event) {
                self.onClickViewOnSiteAMP();
            },
            onReviewItemReversalConfirm: function (data, event) {
                self.onReviewItemReversalConfirm();
            },
            onReviewItemUpdateCancel: function (data, event) {
                self.onReviewItemUpdateCancel();
            },
            onClickAddMedia: function (data, event) {
                self.onClickAddMedia();
            },
            onClickSelectProductImages: function (data, event) {
                self.onClickSelectProductImages();
            },
            onClickUsePinnedTagAsFeaturedImage:function (data,event){
                self.onClickUsePinnedTagAsFeaturedImage(data);
            },
            onClickAddTagImage: function (data, event) {
                self.onClickAddTagImage();
            },
            onClickEditTagImage: function (data, event) {
                self.onClickEditTagImage();
            },
            onClickViewTagImage: function (data, event) {
                self.onClickViewTagImage();
            },
            onClickFeaturedTagEdit: function(data,event){
                self.onClickFeaturedTagEdit();
            },
            onClickFeaturedTagDelete: function(data,event){
                self.onClickFeaturedTagDelete();
            },
            onClickCloseTagImage: function (data, event) {
                self.onClickCloseTagImage();
            },
            onClickRevertSandbox: function (data, event) {
                self.onClickRevertSandbox();
            },
            // onClickCopyContent: function (data, event) {
            //     self.onClickCopyContent();
            // },
            onClickAddFaq: function (data, event) {
                self.onClickAddFaq();
            },
            getPinnedTag: function(data,event){
                return self.getPinnedTag();
            },
            getFeaturedTag: function(data,event){
                return self.getFeaturedTag();
            },
            onClickEditFaq: function (value, data, event) {
                self.onClickEditFaq(value);
            },
            onClickDeleteFaq: function (data, event) {
                self.onClickDeleteFaq(data);
            },
            onClickClosePermalinkHistoryModal: function (data, event) {
                self.onClickClosePermalinkHistoryModal(false);
            },
            onClickShowPermalinkHistoryModal: function (data, event) {
                self.onClickShowPermalinkHistoryModal(true);
            },
            onClickCloseEmbedPopup: function (data, event) {
                self.onClickCloseEmbedPopup();
            },
            onClickCloseSensaiVaultPopup: function (data, event) {
                self.onClickCloseSensaiVaultPopup();
            },
            onClickToggleEmbedTypes: function (data, event) {
                self.onClickToggleEmbedTypes();
            },
            onClickAddEmbed:function (data, event) {
                self.onClickAddEmbed();
            },
            onChangeEmbedInput:function (data, event) {
                self.onChangeEmbedInput();
            },
            onClickDeleteSelectedCategory: function (data, event) {
                self.onClickDeleteSelectedCategory(data);
            },
            onClickDeleteSelectedTag: function (data, event) {
                self.onClickDeleteSelectedTag(data);
            },
            onClickSaveFaq: function (data, event) {
                self.onClickSaveFaq();
            },
            onClickCancelFaq: function (data, event) {
                self.onClickCancelFaq();
            },
            onScroll: function (data, event) {
                self.onScrollSaveBoxSticky(data, event);
            },
            onClickRevertRecovery: function (data, event) {
                self.onClickRevertRecovery();
            },
            onClickRevertSandboxRecovery: function (data, event) {
                self.onClickRevertSandboxRecovery();
            },
            onClickRevertRepublishRecovery: function (data, event) {
                self.onClickRevertRepublishRecovery();
            },
            onClickRevertRevision: function (data, event) {
                self.onClickRevertRevision();
            },
            onClickRevision: function (data, value) {
                self.onClickRevision(data, value);
            },
            onClickRecoveryTab: function (data, event) {
                self.setSelectedRecoveryTab(Recoverable.CONTENT);
            },
            onClickSandboxRecoveryTab: function (data, event) {
                self.setSelectedRecoveryTab(Recoverable.SANDBOX);
            },
            onClickRepublishRecoveryTab: function (data, event) {
                self.setSelectedRecoveryTab(Recoverable.REPUBLISH);
            },
            onFocusOutTitle: function (data, event) {
                self.onFocusOutTitle(event);
            },
            onFocusOutPrompt: function (data, event) {
                self.onFocusOutPrompt(event);
            },
            onClickTemplateTab: function (value, data, event) {
                self.onClickTemplateTab(value, event);
            },
            onClickSegmentTab: function (value) {
                self.onClickSegmentTab(value);
            },
            onClickTab: function (value, data, event) {
                self.onClickTab(value);
            },
            onClickOpenSandboxOrRepublish: function (value, data, event) {
                self.onClickOpenSandboxOrRepublish(value);
            },
            onCancelTakeOver: function (value, data, event) {
                self.onCancelTakeOver();
            },
            onTakeOver: function (value, data, event) {
                self.onTakeOver();
            },
            onKickout: function (value, data, event) {
                self.onKickout();
            },
            closeNotice: function(value, data, event) {
                self.closeNotice();
            },
            onClickDeleteScheduledRepublish: function (value, data, event) {
                self.deleteScheduledRepublish();
            },
            onChangeArticleStatus: function (data, event) {
                self.onChangeArticleStatus(data);
            },
            onChangePublishStatus: function (data, event) {
                self.onChangePublishStatus(data);
            },
            onClickAddProduct: function (value, data, event) {
                self.showReviewItemForm();
            },
            onClickAddReviewItem: function (value, data, event) {
                self.onClickAddReviewItem();
            },
            onClickCancelSaveReviewItem: function (value, data, event) {
                self.onClickCancelSaveReviewItem();
            },
            onClickAddReviewItemVideo: function (value, data, event) {
                self.onClickAddReviewItemVideo();
            },
            onClickDeleteReviewItemVideo: function (value, data, event) {
                self.onClickDeleteReviewItemVideo(data, value);
            },
            onClickAddAffiliateLink: function (value, data, event) {
                self.onClickAddAffiliateLink();
            },

            collapseGiveawaySection: function (value, data, event) {
                self.collapseGiveawaySection();
            },

            onClickDeleteAffiliateLinks: function (value, data, event) {
                self.onClickDeleteAffiliateLinks(data, value);
            },
            onClickAddSpecification: function (value, data, event) {
                self.onClickAddSpecification();
            },
            onClickDeleteSpecification: function (value, data, event) {
                self.onClickDeleteSpecification(data, value);
            },

            onClickDeleteAddedSpecification: function (value, data, event) {
                self.onClickDeleteAddedSpecification(data, value);
            },
            onClickAddKeyFeature: function (value, data, event) {
                self.onClickAddKeyFeature();
            },
            onClickDeleteKeyFeature: function (value, data, event) {
                self.onClickDeleteKeyFeature(value);
            },
            onClickAddPro: function (value, data, event) {
                self.onClickAddPro();
            },
            onClickDeletePro: function (value, data, event) {
                self.onClickDeletePro(data, value);
            },
            onClickAddCon: function (value, data, event) {
                self.onClickAddCon();
            },
            onClickDeleteCon: function (value, data, event) {
                self.onClickDeleteCon(data, value);
            },
            onClickDeleteProductImage: function (value, data, event) {
                self.onClickDeleteProductImage(data);
            },
            onClickConfirmFaqDelete: function (value, data, event) {
                self.onClickConfirmFaqDelete();
            },
            onClickCancelFaqDelete: function (value, data, event) {
                self.onClickCancelFaqDelete();
            },
            onChangePoll: function (keyword) {
                self.onChangePoll(keyword);
            },
            onSelectedPoll: function () {
            self.onSelectedPoll();
            },
            onClickCompareRevisionUpdate: function (data) {
                self.onClickCompareRevisionUpdate(data);
            },
            onClickCompareRevision: function (data, event) {
                self.onClickCompareRevision();
            },
            onClickCloseComparePopUp: function (value, data, event) {
                self.onClickCloseComparePopUp();
            },
            onClickCompareRecovery: function (type, data){
                self.onClickCompareRecovery(type);
            },
            onClickCompareSandbox: function (type, data){
                self.onClickCompareSandbox(type);
            },
            onClickShowRevision: function (revision, data) {
                self.onClickShowRevision(revision)
            },
            valueSwitch: function (value, data){
                self.valueSwitch(value, data);
            },
            onChangepaymentTypeRepublish: function (data, event) {
                self.onChangepaymentTypeRepublish(data, event)
            },
            onClickTogglePinnedTagsForm: function (value, data, event) {
                self.onClickTogglePinnedTagsForm(value);
            },
            onChangeFeaturedSection: function () {
                self.onChangeFeaturedSection();
            },
            onChangeUpdateLatestRepublishDate : function (data) {
                self.onChangeUpdateLatestRepublishDate(data)
            },
            onClickDisplayOptionToggle : function(data) {
                self.onClickDisplayOptionToggle();
            },
            onClickConfirmDialog : function (idElement) {
                self.onClickConfirmDialog(idElement)
            },
            onClickContinueEditing : function (idElement) {
                self.onClickContinueEditing()
            },
            onClickSaveAnyway : function (idElement) {
                self.onClickSaveAnyway()
            },
            onClickAutoCategorize: function (data, event) {
                self.onClickAutoCategorize();
            },
            onClickAutoTag: function (data, event) {
                self.onClickAutoTag();
            },
            onClickAutoCategorizeAndTag: function (data, event) {
                self.onClickAutoCategorizeAndTag();
            },
            onClickSendNewsletter : function (idElement) {
                self.onClickSendNewsletter()
            },
            handleDragAndDrop: function(element, currentObservableArray ,childrenSelector){ self.handleDragAndDrop(element, currentObservableArray ,childrenSelector);},
            onClickSelectFeaturedVideo : function () {self.onClickSelectFeaturedVideo()},
            onClickSelectFeaturedEmbed : function () {self.onClickSelectFeaturedEmbed()},
            onClickSelectFeaturedEmbedImage : function () {self.onClickSelectFeaturedEmbedImage()},
            onClickPreviewFeaturedVideo : function () {self.onClickPreviewFeaturedVideo()},
            onClickEditFeaturedVideo : function () {self.onClickEditFeaturedVideo()},
            onClickRemoveFeaturedVideo : function () {self.onClickRemoveFeaturedVideo()},
            onClickRemoveFeaturedEmbed : function () {self.onClickRemoveFeaturedEmbed()},
            onClickCreateRepublishAndUpdateArticle : function () {self.onClickCreateRepublishAndUpdateArticle()},
            onClickGenerateArticleSummaries : function () {self.onClickGenerateArticleSummaries()},
            getSourceNewsDatetime : function (subVm) {self.scrappingExternalSourceNewsUrl(subVm)},
            isCompletedWithAllowedTypes : function () {self.isCompletedWithAllowedTypes()}

        }

        const checkIsNewsNowArticle = ko.pureComputed(function () {
            return vm.isNewsNowArticle() === false;
        }, vm);

        const featuredImageIsPortrait = ko.pureComputed(() => {
            const featuredImage = vm.featuredImage();
            const isActive = vm.isFeaturedImageActive();

            if (featuredImage && isActive) {
                const { width, height } = featuredImage;
                if (width !== undefined && height !== undefined) {
                    return (width / height) < (16 / 9);
                }
            }

            return false;
        });
        const NEWS_ARTICLE_CONTENT_TYPES = [4, 13, 27]; // News, Niche News, Flash News

        let skipFirstHighlight = false;
        const newsArticle = {
            isNewsArticle: (() => {
                const computed = ko.pureComputed(() => NEWS_ARTICLE_CONTENT_TYPES.indexOf(vm.idContentType()) > -1, vm);
                computed.subscribe((newValue) => {
                    if (newValue === false) {
                        newsArticle.sourceUrl(null);
                        newsArticle.sourceNewsIsFromSelf(false);
                        if(self.sourceNewsDatePicker){
                            self.sourceNewsDatePicker.getTemplateViewModel().singleDatePicker(null)
                        }
                    }else{
                        if(!skipFirstHighlight){skipFirstHighlight = true; return;}
                        self.isNewsArticleHightlighted()
                    }
                });
                return computed;
            })(),
            sourceUrl: ko.observable(null),
            sourceNewsIsFromSelf: ko.observable(false),
            isLoadingSrcTimeBtn: ko.observable(false),
            isSourceUrlValid: ko.pureComputed(() => {
                const url = newsArticle.sourceUrl();
                if (!url) return false;

                if (!/^https?:\/\/.+/i.test(url)) return false;

                try {
                    // tslint:disable-next-line:no-unused-expression
                    new URL(url);
                    return true;
                } catch {
                    return false;
                }
            }),

            onClickSourceNewsIsSelf() {
                this.sourceNewsIsFromSelf(true);
                this.sourceUrl('(SELF)');
                if(self.sourceNewsDatePicker){
                    const datePublished = vm.datePublished() ? vm.datePublished() : null
                    self.sourceNewsDatePicker.getTemplateViewModel().singleDatePicker(datePublished)
                }
            },
            onClickSourceNewsGetTime() {
                const { sourceUrl, isLoadingSrcTimeBtn } = this;
                vm.getSourceNewsDatetime({ sourceUrl, isLoadingSrcTimeBtn });
            }
        };
        let skipInitialChange = true;
        newsArticle.sourceUrl.subscribe((newValue) => {
            if(skipInitialChange){skipInitialChange = false; return;}
            if (newsArticle.sourceUrl() !== '(SELF)' && self.sourceNewsDatePicker) {
                self.sourceNewsDatePicker.getTemplateViewModel().singleDatePicker(null)
            }
        })

        vm.idPublishStatus.subscribe(oldValue => {
            vm.previousIdPublishStatus(oldValue)
        }, null, "beforeChange")

        return {...vm, checkIsNewsNowArticle, featuredImageIsPortrait, ...newsArticle };
    }

    public initTagPickerCkEditors(): void{

        this.tagPicker.initializeCkEditors();
    }

    protected collapseGiveawaySection() {

        this.getTemplateViewModel().isGiveawaySectionCollapsed(!this.getTemplateViewModel().isGiveawaySectionCollapsed());
    }

    protected onChangepaymentTypeRepublish(data , event){
        let paymentTypeSelected = event.target.value

        if(paymentTypeSelected === "Amount"){
            this.getTemplateViewModel().percentageAuthor(null)
        }

        if(paymentTypeSelected === "Percentage"){
            this.getTemplateViewModel().amountAuthor(null)
        }
    }

    protected valueSwitch(value, data) {

        if (value == "oldValue") {
            data.chosenValue(data.oldValue)
        } else if (value == "newValue" ) {
            data.chosenValue(data.newValue)
        }
    }
    private revertReviewItems(updatedReviewItems, fieldUpdates) {


        let reviewItemsBeforeUpdate = this.getTemplateViewModel().backupReviewItems()

        let tagNameChange, oldTagName, newName, compositeTagName, tagImageUrl, tagTypeName,
            oldValue, newValue, oldLabel, newLabel;
        let valuesChanges, labelChanges, valuesAdded, valuesKept, labelData, fieldId;
        let fieldValueChanges = [];
        let revertedFromRevision = this.getTemplateViewModel().sourceOfReversal() == "revision";

        for (let i=0; i < reviewItemsBeforeUpdate.length; i++ ) {

            tagNameChange = null;
            if (updatedReviewItems[i].tag.id != 0)
            {
                oldTagName = reviewItemsBeforeUpdate[i].tag.name;
                newName = updatedReviewItems[i].tag.name;
                tagTypeName = updatedReviewItems[i].tag.type.name;

                if ( oldTagName != newName) {

                    tagNameChange =  {
                        "oldName": revertedFromRevision ? newName : oldTagName,
                        "newName": revertedFromRevision ? oldTagName : newName } //"updatedReviewItemsIndices": [i]
                }

                valuesChanges = [];
                labelChanges = [];
                valuesAdded = [];
                valuesKept = [];
                compositeTagName = newName + " ( " + updatedReviewItems[i].tag.type.name+" ) ";
                tagImageUrl = updatedReviewItems[i].extraImages.length > 0 ? updatedReviewItems[i].extraImages[0].url: '';
                tagImageUrl = tagImageUrl ? tagImageUrl : '';
                //tagImage

                if (fieldUpdates.hasOwnProperty(compositeTagName) ) {

                    Object.keys(fieldUpdates[compositeTagName]).forEach((label, index, array) =>{

                        labelData = fieldUpdates[compositeTagName][label];
                        oldValue = labelData.oldValue;
                        newValue = labelData.newValue;
                        oldLabel = labelData.oldLabel;
                        newLabel = labelData.newLabel;
                        fieldId = labelData.id;

                        if ( oldLabel && (typeof(oldLabel) != "undefined") && newLabel && typeof (newLabel) != "undefined" && oldLabel != newLabel) {
                            labelChanges.push( ko.observable({
                                fieldId: fieldId,
                                oldLabel: revertedFromRevision ? newLabel : oldLabel,
                                newLabel: revertedFromRevision ? oldLabel : newLabel } ))

                        }

                        if (labelData.existed && labelData.new) {

                            oldValue = (typeof(oldValue) == "undefined" || !oldValue) ? "" : oldValue;
                            newValue = (typeof(newValue) == "undefined" || !newValue) ? "" : newValue;

                            if ( oldValue != newValue ) {
                                valuesChanges.push( ko.observable({
                                    fieldId: fieldId,
                                    label: label,
                                    oldValue: revertedFromRevision ? newValue : oldValue,
                                    newValue: revertedFromRevision ? oldValue : newValue,
                                    chosenValue: ko.observable(newValue) } ))
                            }
                        }
                        else if (typeof newValue == "undefined") {
                            //Kept from main content
                            valuesKept.push( { fieldId: fieldId, label: label, value: oldValue } )
                        }
                    })
                }



                if ( valuesChanges.length > 0 || tagNameChange || labelChanges.length > 0  ) {
                    fieldValueChanges.push(
                        ko.observable({
                            tag: compositeTagName,
                            tagNameChange: tagNameChange,
                            tagTypeName: tagTypeName,
                            imageUrl: tagImageUrl,
                            tagId: updatedReviewItems[i].tag.id,
                            updatedValues: ko.observableArray(valuesChanges),
                            updatedLabels: labelChanges,
                            keptValues: valuesKept }));
                }
            }
        }

        this.getTemplateViewModel().fieldValueChanges(fieldValueChanges);
        this.getTemplateViewModel().updatedReviewItems(updatedReviewItems);
        if (fieldValueChanges && Object.keys(fieldValueChanges).length !== 0) {
            this.makeBodyUnscrollable();
            this.getTemplateViewModel().isReviewItemUpdatesFormShown(true);
        }
        else {
            this.onReviewItemReversalConfirm()
        }
    }

    public getViewModelForRequest() {

        return {

            filters: {
                authorId: this.getTemplateViewModel().filterUser_author.idUser,
                srEditorId: this.getTemplateViewModel().filterUser_SrEditor.idUser,
                jrEditorId: this.getTemplateViewModel().filterUser_JrEditor.idUser,
                ideatorId: this.getTemplateViewModel().filterUser_ideator.idUser,
                paymentCategory: this.getTemplateViewModel().paymentCategoryFilter.selectedOption
            }
        }
    }

    public setFeaturedTags(featuredTags){
        this.getTemplateViewModel().featuredTags([]);
        this.getTemplateViewModel().featuredTags(featuredTags);
        if(featuredTags !==null && featuredTags.tagObject !== null){
            if(featuredTags.tagObject[0].image !== undefined && featuredTags.tagObject[0].image !== null){

                this.imageWidgetForFeaturedImage.setImage(featuredTags.tagObject[0].image);
                this.getTemplateViewModel().featuredImage(this.getFeaturedImage());
            }else if (featuredTags.tagObject[1] !== undefined && featuredTags.tagObject[1].image !== undefined && featuredTags.tagObject[1].image !== null){
                this.imageWidgetForFeaturedImage.setImage(featuredTags.tagObject[1].image);
                this.getTemplateViewModel().featuredImage(this.getFeaturedImage());
            }else{
                this.imageWidgetForFeaturedImage.setImage([]);
                this.getTemplateViewModel().featuredImage(null);
            }
        }
    }

    public setDefaultFeaturedTags(defaultFeaturedTags): void {
        this.getTemplateViewModel().defaultFeaturedTags(defaultFeaturedTags);
    }

    public getDefaultFeaturedTags() {
        return this.getTemplateViewModel().defaultFeaturedTags();
    }


    public setDefaultFeaturedImage(defaultFeaturedImage): void {
        this.getTemplateViewModel().defaultFeaturedImage(defaultFeaturedImage);
    }

    public getDefaultFeaturedImage() {
        return this.getTemplateViewModel().defaultFeaturedImage();
    }

    public setValidAutoPricingPartnerNames(validAutoPricingPartnerNames): void {
        this.tagPicker.setValidAutoPricingPartnerNames(validAutoPricingPartnerNames);
    }

    public getValidAutoPricingPartnerNames() {
        return this.getTemplateViewModel().validAutoPricingPartnerNames();
    }

    public onClickFeaturedTag(value){
        this.caller.showTagPicker("featuredTag");
    }

    public setTopKeyWordAnalytics(response): void{
        this.articleAnalytics.setAnalytics(response);
    }

    public getTopKeyWordAnalytics(){
        return this.articleAnalytics.getAnalytics();
    }

    public setShortTermReport(response): void{

        this.articleAnalytics.setShortTermReport(response);
    }

    public getIsVersusStyle(){
        return this.getTemplateViewModel().isVersusStyle();
    }

    public setIsUserHasTier2Rates(isUserHasTier2Rates: boolean): void {
        this.getTemplateViewModel().isUserHasTier2Rates(isUserHasTier2Rates);
    }

    public setIsSessionTrackerVisible(isSessionTrackerVisible: boolean): void {
        this.getTemplateViewModel().isSessionTrackerVisible(isSessionTrackerVisible);
    }

    public setUserPicture(userPicture): void {
        this.getTemplateViewModel().userPicture(userPicture);
    }

    public setArticleGoal(articleGoal): void {
        this.getTemplateViewModel().articleGoal(articleGoal);
    }

    public setMonthName(monthName): void {
        this.getTemplateViewModel().monthName(monthName);
    }

    public setRoleName(roleName): void {
        this.getTemplateViewModel().roleName(roleName);
    }

    public setContentTypeName(contentTypeName): void {
        this.getTemplateViewModel().contentTypeName(contentTypeName);
    }

    protected onClickSelectView(event) {

        if (event.target.dataset.wasChecked === "true") {
            event.target.dataset.wasChecked = "false";
            event.target.checked = false;
            this.getTemplateViewModel().selectedView(null);
        }else{
            event.target.dataset.wasChecked = "true";
            this.getTemplateViewModel().selectedView(event.target.value);
        }

        if(event.target.value =="currency"){
            document.getElementById('brandViewArticle').dataset.wasChecked = "false";
        }else{
            document.getElementById('currencyViewArticle').dataset.wasChecked = "false";
        }

        return true;
    }

    public setArticleGoalProgressPercentage(articleGoalProgressPercentage): void {
        this.getTemplateViewModel().articleGoalProgressPercentage(articleGoalProgressPercentage);
    }

    public setSessionGoalProgressPercentage(sessionGoalProgressPercentage): void {
        this.getTemplateViewModel().sessionGoalProgressPercentage(sessionGoalProgressPercentage);
    }

    public setTier2SessionGoalProgressPercentage(tier2SessionGoalProgressPercentage): void {
        this.getTemplateViewModel().tier2SessionGoalProgressPercentage(tier2SessionGoalProgressPercentage);
    }

    public setSessionsPerArticleTarget(sessionsPerArticleTarget): void {
        this.getTemplateViewModel().sessionsPerArticleTarget(sessionsPerArticleTarget);
    }

    public setTier2SessionsPerArticleTarget(tier2SessionsPerArticleTarget): void {
        this.getTemplateViewModel().tier2SessionsPerArticleTarget(tier2SessionsPerArticleTarget);
    }

    public setArticleCount(articleCount): void {
        this.getTemplateViewModel().articleCount(articleCount);
    }

    public setSessionsPerArticle(sessionsPerArticle): void {
        this.getTemplateViewModel().sessionsPerArticle(sessionsPerArticle);
    }

    public setTier1Amount(tier1Amount): void {
        this.getTemplateViewModel().tier1Amount(tier1Amount);
    }

    public setTier2Amount(tier2Amount): void {
        this.getTemplateViewModel().tier2Amount(tier2Amount);
    }

    public setOutputTransactionsTotal(outputTransactionsTotal): void {
        this.getTemplateViewModel().outputTransactionsTotal(outputTransactionsTotal);
    }

    public setBrandSessionTarget(brandSessionTarget): void {
        this.getTemplateViewModel().brandSessionTarget(brandSessionTarget);
    }

    public setBrandProgressPercentage(brandProgressPercentage): void {
        this.getTemplateViewModel().brandProgressPercentage(brandProgressPercentage);
    }

    public setContentTypeProgressPercentage(contentTypeProgressPercentage): void {
        this.getTemplateViewModel().contentTypeProgressPercentage(contentTypeProgressPercentage);
    }

    public setBrandContentTypeSessionTarget(brandContentTypeSessionTarget): void {
        this.getTemplateViewModel().brandContentTypeSessionTarget(brandContentTypeSessionTarget);
    }


    public setArticles(articles: Array<any>) {

        if (articles && articles[0]) {

            this.getTemplateViewModel().articles(articles);
        } else {

            this.getTemplateViewModel().articles(null);
        }
    }

    public setActiveCkEditorInstance(instance){

        this.getTemplateViewModel().activeCkEditorInstance(instance);
    }

    public getActiveCkEditorInstance(){

        return this.getTemplateViewModel().activeCkEditorInstance();
    }

    public setArticlesFilter(articles) {

        this.getTemplateViewModel().filterArticle.showDetails(true);
        this.getTemplateViewModel().filterArticle.articles(articles);
    }

    public setDirectoryArticlesFilter(articles) {

        this.getTemplateViewModel().filterArticleDirectory.showDetails(true);
        this.getTemplateViewModel().filterArticleDirectory.articles(articles);
    }
    public convertStringToHtmlDoc(htmlString){
        let div = document.createElement('div');
        div.innerHTML = htmlString.trim();
        return div.firstChild;
    }
    public onClickFeaturedTagEdit(){
        let items = this.getTemplateViewModel().featuredTags();

        if(items !==null && items.tagObject.length>1 && !items.tagObject[0].name.includes("Placeholder")){
            let bigItem = this.convertStringToHtmlDoc(items.block.source);
            this.caller.getTagData();
            this.caller.onClickCkEditorElement(bigItem,{name:"featuredTag"});
        }
        else if(items.tagObject[0].name.includes("Placeholder")){
            this.onClickFeaturedTag(null);
        }
        else{
            this.caller.showTagPicker("featuredTag");
            this.tagPicker.getOnlickView(items.tagObject[0]);
        }
    }

    public onClickFeaturedTagDelete(){
        this.getTemplateViewModel().featuredTags(null);
        this.imageWidgetForFeaturedImage.setImage([]);
    }

    public setDirectoryItemFilter(articles, sourceId) {

        let usedArticles = [];
        let directoryItems = []

        if (sourceId == "sandbox_directory") {
            directoryItems = this.sandboxDirectory.getTemplateViewModel().directoryItems();
        }else if(sourceId == "republish_directory"){
            directoryItems = this.republishDirectory.getTemplateViewModel().directoryItems();
        }else{
            directoryItems = this.articleDirectory.getTemplateViewModel().directoryItems();
        }

        let recursiveTraversal = function(array) {
            array.forEach( el => {

                if ( el.item() ){
                    usedArticles.push(el.item())
                }
                if ( el.directoryItems.length > 0 )
                    recursiveTraversal(el.directoryItems)
            });
        }

        recursiveTraversal(directoryItems)

        const articlesWithoutUsedOnes = articles.filter(({ id: id1 }) => !usedArticles.some(({ id: id2 }) => id2 == id1));

        if (sourceId == "sandbox_directory") {

            this.sandboxDirectory.getTemplateViewModel().filterDirectoryItem.articles(articlesWithoutUsedOnes);
        }else if (sourceId == "republish_directory") {

            this.republishDirectory.getTemplateViewModel().filterDirectoryItem.articles(articlesWithoutUsedOnes);
        }else{

            this.articleDirectory.getTemplateViewModel().filterDirectoryItem.articles(articlesWithoutUsedOnes);
        }

    }

    public setSelectedRecoveryTab(selectedRecoveryTab) {

        this.getTemplateViewModel().selectedRecoveryTab(selectedRecoveryTab);
    }


    public setFaqs(faqs) {

        this.getTemplateViewModel().faqs(faqs);
    }

    public setAmazonOnsite(amazonOnsite) {

        this.getTemplateViewModel().amazonOnsite(amazonOnsite);
    }

    public setNewsletterServiceType(newsletterServiceType) {

        this.getTemplateViewModel().newsletterServiceType(newsletterServiceType);
    }

    public setClassificationOptions(value : [{id: number, name: string}]){
        this.getTemplateViewModel().classificationOptions(value);
    }

    public setClassificationAllOptions(value : [{id: number, name: string}]){
        this.getTemplateViewModel().classificationAllOptions(value);
    }

    public setClassificationName(classificationName){
        this.getTemplateViewModel().classificationName(classificationName);
    }

    public setIdClassification(idClassification){
        this.getTemplateViewModel().idClassification(idClassification);
    }

    public setIsSubContent(isSubContent){
        this.getTemplateViewModel().isSubContent(isSubContent);
    }

    public setArticleHistoricalReviewComments(articleHistoricalReviewComments){

        this.getTemplateViewModel().hasNewFeedback(false);
        //check if any feedback has been made in the last 48 hours
        for(let comment of articleHistoricalReviewComments){

            let date = new Date(comment.dateCreated.date);
            let current = new Date();
            let diff = Math.abs(current.getTime() - date.getTime());
            //let diffDays = Math.ceil(diff / (1000 * 3600 * 24));
            let diffHours = Math.ceil(diff / (1000 * 3600));
            if(diffHours <= 48){
                this.getTemplateViewModel().hasNewFeedback(true);
            }

        }
        this.getTemplateViewModel().articleHistoricalReviewComments(articleHistoricalReviewComments);
        this.articleReviewHistory.setReviewItems(articleHistoricalReviewComments);

    }


    public setPermissions(permissions) {

        this.getTemplateViewModel().permissions(permissions);
        this.productReview.setPermissions(permissions);
        this.productReviewSandbox.setPermissions(permissions);
        this.productReviewRepublish.setPermissions(permissions);
        this.articleContent.setPermissions(permissions);
        this.sandboxContent.setPermissions(permissions);
        this.republishContent.setPermissions(permissions);
        this.imagePicker.setPermissions(permissions);
        this.tagPicker.setPermissions(permissions);
        //
        this.imageWidgetForThumbnailImage.setPermissions(permissions);
        this.imageWidgetForAlternateImage.setPermissions(permissions);
        this.imageWidgetForFeaturedImage.setPermissions(permissions);
        this.articleAnalytics.setPermissions(permissions);
        this.videoPickerHelper.setPermissions(permissions);

    }

    public getPermissions() {

        return this.getTemplateViewModel().permissions();
    }

    public getPublishStatusOptions() {

        return this.getTemplateViewModel().publishStatuses();
    }

    public getArticleStatusOptions() {

        return this.getTemplateViewModel().articleStatus_options();
    }

    public getArticleRepublishStatusOptions() {

        return this.getTemplateViewModel().articleRepublishStatus_options();
    }

    public getReviewItemAwardOptions() {

        return this.getTemplateViewModel().reviewItemAward_options();
    }

    public updateSelectedTags() {

        let idTagSelected = this.filterTag.getTemplateViewModel().idTag();
        let tagSelected = this.filterTag.getTemplateViewModel().tagObj();
        let selectedTags = this.getTemplateViewModel().selectedTags();

        if (idTagSelected != null) {
            //add to selected tags if its not already selected
            let alreadySelected = selectedTags.find(t => t.tag.id == idTagSelected);

            if (!alreadySelected) {
                if(tagSelected.tagType != null){
                    tagSelected.type = {};
                    tagSelected.type.id = tagSelected.idType;
                    tagSelected.type.name = tagSelected.tagType;
                }
                selectedTags.push({id: null, tag: tagSelected});
            }
        }


        this.getTemplateViewModel().selectedTags([]);
        this.getTemplateViewModel().selectedTags(selectedTags);
        this.filterTag.clearInput();
    }

    public updateSelectedCategories() {


        let selectedFilterCategories = this.filterCategory.getSelectedItems();
        let categories = this.getTemplateViewModel().categories();
        let idPrimaryCategory = this.getTemplateViewModel().idPrimaryCategory();

        let categoryList = [];
        //build list of the categories that are now selected in the filter
        for (let idCategory of selectedFilterCategories) {

            let category = categories.find(c => c.id == idCategory);
            if (category) {

                categoryList.push(category);
            }

        }

        let selectedCats = this.getTemplateViewModel().selectedCategories();

        //add categories that have not yet been selected
        for (let cat of categoryList) {

            let existingCategory = selectedCats.find(c => c.category.id == cat.id);

            if (!existingCategory) {
                selectedCats.push({id: null, category: cat});
            }
        }

        //remove ones that are no longer selected in the filter
        /*for(let cat of selectedCats){

            let catToRemove = categoryList.find(c => c.id == cat.id);
            if(!catToRemove){
                //selectedCats.splice()
            }
        }*/

        for (let i = selectedCats.length - 1; i >= 0; i--) {

            let catToRemove = categoryList.find(c => c.id == selectedCats[i].category.id);
            if (!catToRemove) {
                selectedCats.splice(i, 1);
            }
        }

        //check if primary category still exists
        let primaryCategory = selectedCats.find(c => c.category.id == idPrimaryCategory);
        if (!primaryCategory) {
            this.getTemplateViewModel().idPrimaryCategory(null);
        }

        this.getTemplateViewModel().selectedCategories([]);
        this.getTemplateViewModel().selectedCategories(selectedCats);
    }
    protected onClickUsePinnedTagAsFeaturedImage(isClicked){
        if(isClicked){


        }
    }
    public onClickTemplateTab(idTemplate, event) {

        this.getTemplateViewModel().idTemplate(idTemplate);
        this.setTemplateLayoutsFiltered(idTemplate);
        let templateDropDown = <HTMLSelectElement>document.getElementById("template_selector");
        let index = templateDropDown.selectedIndex;
        let selected = templateDropDown.options[templateDropDown.selectedIndex];
        this.setTemplate(templateDropDown.options[templateDropDown.selectedIndex].text);

        let contentPresets = this.getTemplateViewModel().contentPresets();
        for (let contentPreset of contentPresets) {
            if (contentPreset['type'] == 'template' && contentPreset['idItem'] == idTemplate && contentPreset['isActive'] == true) {
                this.caller.sendToArticleContent(contentPreset['content']);
            }
        }

        if (idTemplate == 9) {
            this.setBuyersGuideLightTemplateDefaults();
        }
        else if(idTemplate == 10){
            this.setDealsTemplateDefaults();
        }else if (idTemplate == 11){
            this.setVersusTemplateDefaults();
        }else if (idTemplate == 12){
            this.setCollectionTemplateDefaults();
        }else if (idTemplate == 13){
            this.setSubContentTemplateDefaults();
        }   else if (idTemplate == ID_TEMPLATE_VIDEO){
            this.setVideoTemplateDefaults();
        } else if (idTemplate == ID_TEMPLATE_THREAD){
            this.setThreadTemplateDefaults();
        }
        else {
            this.resetTemplateDefaults(idTemplate);
        }
        this.productReview.setIdTemplate(idTemplate);
        this.productReviewSandbox.setIdTemplate(idTemplate);
        this.productReviewRepublish.setIdTemplate(idTemplate);
        this.recoverySandboxReviewSection.setIdTemplate(idTemplate);
        this.recoveryRepublishReviewSection.setIdTemplate(idTemplate);
        this.recoveryReviewSection.setIdTemplate(idTemplate);
        this.revisionReviewSection.setIdTemplate(idTemplate);
        this.getTemplateViewModel().showSegmentTab(this.getSegments().length);
    }

    public onClickSegmentTab(idSegment) {

        this.getTemplateViewModel().idSegment(idSegment);
        let segmentDropdown = <HTMLSelectElement>document.getElementById("idSegment");

        this.setSegment(segmentDropdown.options[segmentDropdown.selectedIndex].text);

        let contentPresets = this.getTemplateViewModel().contentPresets();
        for (let contentPreset of contentPresets) {
            if (contentPreset['type'] == 'segment' && contentPreset['idItem'] == idSegment && contentPreset['isActive'] == true) {
                this.caller.sendToArticleContent(contentPreset['content']);
            }
        }

        this.getTemplateViewModel().showSegmentTab(false);
    }

    protected onClickCancel() {

        if (confirm("Are you sure you want to cancel? Any unsaved changes will be lost.")) {

            this.caller.cancelEditArticle();
        }
    }

    public disableSaveButtons() {

        this.getTemplateViewModel().isSaveButtonDisabled(true);
    }

    public enableSaveButtons() {

        this.getTemplateViewModel().isSaveButtonDisabled(false);
    }

    public setLastSaved(lastSaved) {
        this.getTemplateViewModel().lastSaved(lastSaved);
    }

    public enableAutosaveBox() {
        if (this.getTemplateViewModel().lastSaved !== "") {
            //console.log("Enabled autosave box 1");
            this.getTemplateViewModel().showAutoSaveMessage(true);
        }
    }

    public disableAutosaveBox() {
        this.getTemplateViewModel().showAutoSaveMessage(false);
    }

    public showAutoSaveMessage(message) {
        this.getTemplateViewModel().autoSaveMessage(message);
    }

    public clearAutoSaveMessage() {
        this.getTemplateViewModel().autoSaveMessage(null);
    }

    public setIsAutosaving(value) {
        this.getTemplateViewModel().showIsAutosaving(value);
    }

    protected onChangeTemplate(data, event) {

        let idTemplate = event.target.value;
        let template = event.target.options[event.target.selectedIndex].text;
        let oldIdTemplate = Number(this.getIdTemplate());

        if (oldIdTemplate == 7 && idTemplate != 7) {
            const directoryItems = this.getDirectoryItems();
            let count = directoryItems.length
            const countItems = (items) => items.reduce((count, item) => {
                if (item.directoryItems().length > 0) {
                    count += countItems(item.directoryItems());
                }
                return count
            }, items.length);

            if (!confirm(`Changing the type of this article will clear ${countItems(directoryItems)} existing directory items. Are you sure you want to continue?`)) {
                this.getTemplateViewModel().idTemplate(null);
                this.getTemplateViewModel().idTemplate(oldIdTemplate);
                return false;
            }
        }

        //if thread template, remove premium classification
        let classifications = [...this.getTemplateViewModel().classificationAllOptions()];
        if(idTemplate == ID_TEMPLATE_THREAD){
            classifications = classifications.filter(function( obj ) {
                return obj.id != ID_PREMIUM_CLASSFICATION;
            });
        }
        this.getTemplateViewModel().classificationOptions(classifications);

        this.setTemplate(template);
        this.setTemplateLayoutsFiltered(idTemplate);

        if (idTemplate == 9) {
            this.setBuyersGuideLightTemplateDefaults();
        }
        else if(idTemplate == 10){
            this.setDealsTemplateDefaults();
        }else if(idTemplate == 11){
            this.setVersusTemplateDefaults();
        }else if(idTemplate == 12){
            this.setCollectionTemplateDefaults();
        } else if (idTemplate == ID_TEMPLATE_VIDEO){
            this.setVideoTemplateDefaults();
        }  else if (idTemplate == ID_TEMPLATE_THREAD){
            this.setThreadTemplateDefaults();
        }
        else {
            this.resetTemplateDefaults(idTemplate);
        }
        this.productReview.setIdTemplate(idTemplate);
        this.productReviewSandbox.setIdTemplate(idTemplate);
        this.productReviewRepublish.setIdTemplate(idTemplate);
        this.recoverySandboxReviewSection.setIdTemplate(idTemplate);
        this.recoveryRepublishReviewSection.setIdTemplate(idTemplate);
        this.recoveryReviewSection.setIdTemplate(idTemplate);
        this.revisionReviewSection.setIdTemplate(idTemplate);
        this.getTemplateViewModel().idTemplate(idTemplate);

        return true;
    }

    protected onChangeTemplateLayout(data, event) {
        if (event.isTrusted === true) {
            let prompt = "Switching template will clear the existing featured selections. Are you sure you want to continue?";
            let sectedOptionText = event.target.options[event.target.selectedIndex].text.toLowerCase();
            let featuredSectionValue = this.getTemplateViewModel().featuredSectionValue();

            if (sectedOptionText == "minimal") {

                this.setIsFeaturedTagDisabled(false);
                this.setIsFeaturedVideoDisabled(true);

                if (featuredSectionValue == "featuredVideo") {
                    if (confirm(prompt) === false) {
                        return false;
                    } else {
                        this.clearFeaturedSection("featuredVideo");
                        this.setIsFeaturedVideoActive(false);
                        this.setIsFeaturedImageActive(true);
                        this.setFeaturedSectionValue("featuredImage");
                    }
                }
            } else {
                if (featuredSectionValue == "featuredTag") {
                    if (confirm(prompt) === false) {
                        return false;
                    } else {
                        this.clearFeaturedSection("featuredTag");
                        this.setIsFeaturedVideoActive(false);
                        this.setIsFeaturedTagActive(false);
                        this.setIsFeaturedImageActive(true);
                        this.imageWidgetForFeaturedImage.setIsFeaturedTagActive(false);
                        this.imageWidgetForFeaturedImage.getTemplateViewModel().imageIsRequired(false);
                        this.setFeaturedSectionValue("featuredImage");
                    }
                }
                this.setIsFeaturedTagDisabled(true);
                this.setIsFeaturedVideoDisabled(false);
                if (sectedOptionText == "light-wide") {
                    this.setTableOfContents(true);
                }
            }

            this.setTemplateLayout(sectedOptionText);
        }
        return true;
    }

    public setIsFeaturedImageActive(isFeaturedImageActive){
        this.getTemplateViewModel().isFeaturedImageActive(isFeaturedImageActive);
    }

    public setIsFeaturedVideoActive(isFeaturedVideoActive): void {
        this.getTemplateViewModel().isFeaturedVideoActive(isFeaturedVideoActive);
    }

    public setFeaturedSectionValue(featuredSectionValue){
        this.getTemplateViewModel().featuredSectionValue(featuredSectionValue);
    }


    protected setTagFilterAutocomplete(tags) {

        this.filterTag.getTemplateViewModel().tags(tags);
    }

    protected setDatasetFilter(datasets) {
        this.tagPicker.setDatasetFilter(datasets);
    }

    protected setReviewTagFilterAutocomplete(tags) {

        this.filterReviewTag.getTemplateViewModel().tags(tags);
    }

    protected onClickTab(tab) {

        this.getTemplateViewModel().selectedTab(tab);
        this.productReview.setSelectedTab(tab);
        this.productReviewSandbox.setSelectedTab(tab);
        this.productReviewRepublish.setSelectedTab(tab);
        this.articleContent.setSelectedTab(tab);
        this.sandboxContent.setSelectedTab(tab);
        this.republishContent.setSelectedTab(tab);
        this.articleReviewHistory.resetFeedbackHistoryOption();

        if(tab == "analytics"){
            this.caller.getArticleAnalytics();
            this.caller.getShortTermReport();
        }

        if(tab == 'article'){
            this.checkIfSandboxHasContent();
            this.checkIfRepublishHasContent();
        }

        if(tab == 'newsletter'){
            this.newsletterDateScheduledSelector.setDate(this.getFormattedEasternTimeZoneDateTime())
        }

        if (tab == 'reviews') {
            // setting the 'guidlines' in the articleReviewHistory articleReviewHistory_template to the prompt 'agreement' value for the "Changes Required" status of the current content type..
            let prompt = this.getPromptToShow(3,true,true);
            if (prompt && typeof prompt === 'object' && 'agreement' in prompt) {
                this.articleReviewHistory.setGuidelines(prompt.agreement);
            }

            let idArticle = this.getTemplateViewModel().id();
            if (idArticle) {
                this.caller.getSensaiArticleReferences("article_content", idArticle);
                //this.caller.getAIContent();
            }
        }
        if (tab == 'widgets') {
            this.getTemplateViewModel().showSummary(this.isCompletedWithAllowedTypes());
        }
    }

    public onClickOpenSandboxOrRepublish(tab){
        this.onClickCopyContent(tab)
        this.onClickTab(tab)
    }

    public checkIfSandboxHasContent(){

        let boolean = false;
        let sandboxContent = this.getSandboxContent();
        let sandboxIntroText = this.getSandboxIntroText();
        let sandboxReviewItems = this.getSandboxReviewItems();
        let sandboxDirectoryItems= this.getSandboxDirectoryItems();

        if( sandboxContent != '' || sandboxIntroText != '' || sandboxReviewItems.length > 0 || sandboxDirectoryItems.length > 0 ){
            boolean = true;
        }
        this.getTemplateViewModel().isSandboxActive(boolean);
    }

    public checkIfRepublishHasContent(){

        let boolean = false;
        let republishContent = this.getRepublishContent();
        let republishIntroText = this.getRepublishIntroText();
        let republishReviewItems = this.getRepublishReviewItems();
        let republishDirectoryItems= this.getRepublishDirectoryItems();

        if( republishContent != '' || republishIntroText != '' || republishReviewItems.length > 0 || republishDirectoryItems.length > 0 ){
            boolean = true;
        }
        this.getTemplateViewModel().isRepublishActive(boolean);
    }

    protected onChangeArticleDataListUser(event, idItem) {
        let input = event.target,
            inputVal = input.value,
            optionsList = input.getAttribute('list'),
            options: any = document.getElementById(optionsList).childNodes;

        if (inputVal.length >= 3 && event.inputType != undefined) {
            this.caller.getArticlesSuggestion( inputVal );
            this.getTemplateViewModel().isShowArticleSuggestions(true);
        }

        for (let op of options) {
            if (op.value === inputVal) {
                idItem(op.id);
                input.blur();
                // this.caller.filterSimpleOnChange();
                break;
            }
        }
    }

    protected onClickSync() {

        this.caller.syncEditArticle();
    }

    protected onClickRevertSandbox() {

        this.caller.revertSandbox();
        this.caller.revertSandboxIntroText();
        this.caller.revertSandboxDirectory();
        this.clearSandboxSection();
    }

    protected onClickCopyContent(tab) {

        this.caller.copyContent(tab);
        this.caller.copyIntroText(tab);
        this.copyContentReviewsItem(tab);
        this.copyDirectoryItems(tab)
    }

    protected onClickAddFaq() {

        this.clearFaqForm();
        this.getTemplateViewModel().isFaqAddFormShown(true);
    }

    protected onClickEditFaq(index) {
        const data = this.getTemplateViewModel().faqs()[index];
        if (data) {
            this.getTemplateViewModel().selectedFaqIndex(index);
            this.getTemplateViewModel().question(data.question);
            this.caller.setFaqAnswer(data.answer);
            this.getTemplateViewModel().isFaqAddFormShown(true);
        }
    }

    protected onClickDeleteFaq(data) {

        let faqs = this.getTemplateViewModel().faqs();
        let index = faqs.findIndex(i => i == data);
        this.getTemplateViewModel().faqToDelete(index);
        this.getTemplateViewModel().isFaqDeleteVisible(true)

    }

    // region Embeds

    public onClickCloseEmbedPopup(){

        this.embedHelper.abortEmbedGeneration();
        this.setContentEmbedContext();
        this.toggleEmbedPopUp(false);
        this.resetEmbedPopUp();
    }

    public onClickCloseSensaiVaultPopup(){
        this.getTemplateViewModel().isSensaiVaultVisible(null);
        this.getTemplateViewModel().isSensaiVaultVisible(false);
    }

    public onClickToggleEmbedTypes(){

        let isFeaturedContext = this.isEmbedContext(EmbedContext.FEATURED);
        this.getTemplateViewModel().embedType(isFeaturedContext ? 'embed_youtube' : 'all');
        document.getElementsByClassName('inner-group')[0].classList.toggle('is-open');
        document.getElementsByClassName('btn-form options')[0].classList.toggle('is-open');

        let element = document.getElementsByClassName('inner-group')[0];
        if(!element.classList.contains('is-open')){

            this.onChangeEmbedInput();
        }
    }

    public toggleEmbedPopUp(value){

        document.body.classList.toggle("is-fixed");
        this.getTemplateViewModel().isEmbedPopUpVisible(value)
    }

    public setEmbedSourceFocused(value){

        setTimeout( () => {
            this.getTemplateViewModel().isEmbedFocused(value);
        }, 100)
    }

    public resetEmbedPopUp(){

        this.getTemplateViewModel().isEmbedFocused(false);
        this.getTemplateViewModel().embedSource(null);
        this.getTemplateViewModel().embedType('all');
        this.clearEmbedFormOutput();
        document.getElementsByClassName('inner-group')[0].classList.remove('is-open');
        document.getElementsByClassName('btn-form options')[0].classList.add('is-open');

    }

    public clearEmbedFormOutput(){

        this.getTemplateViewModel().embedCode(null);
        this.getTemplateViewModel().embedErrors([]);
    }

    protected onClickAddEmbed(){

        let embedContext = this.getTemplateViewModel().embedContext();
        let embedCode = this.getTemplateViewModel().embedCode();

        switch (embedContext) {
            case EmbedContext.FEATURED:
                this.caller.addEmbedCodeToFeaturedEmbed(embedCode);
                break;
            default:
                this.caller.addEmbedCodeToCkEditor(embedCode);
                break;
        }
    }

    public setFeaturedEmbed(embed) {
        this.getTemplateViewModel().featuredEmbed(embed);
    }

    public isEmbedContext(context: string): boolean {
        let embedContext = this.getTemplateViewModel().embedContext();

        return (embedContext == context);
    }
    public setContentEmbedContext() {

        this.getTemplateViewModel().embedType_options(embedTypesList());
        this.getTemplateViewModel().embedType('all');
        this.getTemplateViewModel().embedContext(EmbedContext.CONTENT);
    }

    protected onChangeEmbedInput(){

        //clear result
        this.clearEmbedFormOutput();

        // get input and make call of >3
        let source = this.getTemplateViewModel().embedSource();
        if (source && source.length >= 3) {

            let embedContext = this.getTemplateViewModel().embedContext();

            this.caller.generateEmbed(source, embedContext)
        }
    }

    // endregion embeds

    protected onClickDeleteSelectedTag(data) {

        let idPrimaryTag = this.getTemplateViewModel().idPrimaryTag();
        let selectedTags = this.getTemplateViewModel().selectedTags();
        let index = selectedTags.findIndex(i => i.tag.id == data.tag.id);
        if (index != -1) {
            selectedTags.splice(index, 1);
        }

        if (idPrimaryTag == data.tag.id) {
            this.getTemplateViewModel().idPrimaryTag(null);
        }

        this.getTemplateViewModel().selectedTags(selectedTags);
    }

    protected onClickDeleteSelectedCategory(data) {

        let idPrimaryCategory = this.getTemplateViewModel().idPrimaryCategory();
        let allCategories = this.getTemplateViewModel().categories();
        let selectedCategories = this.getTemplateViewModel().selectedCategories();
        let index = selectedCategories.findIndex(i => i.category.id == data.category.id);
        if (index != -1) {
            selectedCategories.splice(index, 1);
        }

        if (idPrimaryCategory == data.category.id) {
            this.getTemplateViewModel().idPrimaryCategory(null);
        }

        this.getTemplateViewModel().selectedCategories(selectedCategories);

        let selectedFilterCategories = this.filterCategory.getSelectedItems();

        index = selectedFilterCategories.findIndex(i => i == data.category.id);
        if (index != -1) {
            selectedFilterCategories.splice(index, 1);
        }

        let updatedCats = [];
        for (let idCat of selectedFilterCategories) {

            let cat = allCategories.find(c => c.id == idCat);
            if (cat) {
                updatedCats.push(cat);
            }
        }

        this.filterCategory.setSelectedItems(updatedCats);

    }

    protected onClickRevision(index, data ) {

        index = typeof index === "number" ? index : index();
        this.getTemplateViewModel().selectedRevisionIndex( index);
        this.setIdRevisionSelected(data.id);
        this.setRevisionContent(data.content.content);
        this.setRevisionIntroText(data.content.introText);
        this.revisionReviewSection.setReviewItems(data.content.reviewItems);
        this.revisionDirectory.setDirectoryItems(data.content.directoryItems);
    }

    protected onReviewItemReversalConfirm() {


        let valueUpdates = this.getTemplateViewModel().fieldValueChanges();
        let reviewItemsToDelete = this.productReview.getTemplateViewModel().reviewItems().map(obj => { return obj.id  } );
        this.productReview.setReviewItemsToDelete(reviewItemsToDelete);
        let valueUpdate, specExtras, updatedValues, updatedValue;
        let updatedReviewItems = this.getTemplateViewModel().updatedReviewItems();
        let valueExisted;
        let sourceOfReversal = this.getTemplateViewModel().sourceOfReversal();

        if ( sourceOfReversal == "sandbox") {

            this.onClickRevertSandbox();
        }
        else if ( sourceOfReversal == "revision") {

            this.onClickRevertRevision();
        }
        else if ( sourceOfReversal == "recovery") {

            this.onClickRevertRecovery();

        }

        for (let i=0; i < updatedReviewItems.length; i++) {

            updatedReviewItems[i].id = null;

            if (sourceOfReversal != "revision")
            {
                for (let j = 0; j <  valueUpdates.length; j++) {

                    valueUpdate = valueUpdates[j]();
                    if (updatedReviewItems[i].tag.id == valueUpdate.tagId) {

                        specExtras = updatedReviewItems[i].tag.specifications_extra;

                        updatedValues = valueUpdate.updatedValues();


                        for (let k=0; k< updatedValues.length; k++) {

                            updatedValue = updatedValues[k]();
                            valueExisted = false;
                            for (let l=0; l < specExtras.length; l++) {

                                if (specExtras[l].idField == updatedValue.fieldId ) {
                                    specExtras[l].value = updatedValue.chosenValue();
                                    valueExisted = true;
                                    break;
                                }
                            }
                            if (!valueExisted) {
                                specExtras.push({
                                    idField:updatedValue.fieldId,
                                    value: updatedValue.chosenValue(),
                                })
                            }
                        }
                        break;
                    }
                }
            }
        }
        this.productReview.setReviewItems(updatedReviewItems)
        this.makeBodyScrollableAgain();
        this.getTemplateViewModel().isReviewItemUpdatesFormShown(false);

    }

    protected onReviewItemUpdateCancel() {

        this.getTemplateViewModel().tagNameChanges([]);
        this.getTemplateViewModel().fieldValueChanges([]);
        this.makeBodyScrollableAgain();
        this.getTemplateViewModel().isReviewItemUpdatesFormShown(false);
    }

    protected onClickRevertRecovery() {

        this.caller.sendToArticleContent(this.getTemplateViewModel().recoveryContent());
        this.caller.sendToArticleIntroText(this.recoveryReviewSection.getIntroText());

        //to delete exiting ones
        let items = this.articleDirectory.getDirectoryItems();
        items.forEach( item =>  this.articleDirectory.getTemplateViewModel().deletedDirectoryItems().push(item));

        this.articleDirectory.setSandboxDirectoryItems(this.recoveryDirectory.getTemplateViewModel().directoryItems());
    }

    protected onClickRevertSandboxRecovery() {

        if (confirm("Are you sure you want to overwrite the article sandbox? You will lose any unsaved changes.")) {
            let sandboxContent = this.getTemplateViewModel().sandboxRecoveryContent();
            this.caller.revertSandboxRecovery(sandboxContent);
            let recoverySandboxIntroText = this.recoverySandboxReviewSection.getIntroText();
            this.caller.revertSandboxIntroTextRecovery(recoverySandboxIntroText);
            let sandboxRecoveryReviewItems = this.recoverySandboxReviewSection.getReviewItems();
            this.productReviewSandbox.setReviewItems(sandboxRecoveryReviewItems);

            const clone = rfdc(); // clone otherwise it will update the originals too
            let sandBoxRecoveryDirectoryItems =  clone(this.recoverySandboxDirectory.getTemplateViewModel().directoryItems());
            this.sandboxDirectory.setDirectoryItems([]);
            this.sandboxDirectory.setSandboxDirectoryItems(sandBoxRecoveryDirectoryItems)

            this.checkIfSandboxHasContent();
        }
    }


    protected onClickRevertRepublishRecovery() {

        if (confirm("Are you sure you want to overwrite the article republish? You will lose any unsaved changes.")) {
            let republishContent = this.getTemplateViewModel().republishRecoveryContent();
            this.caller.revertRepublishRecovery(republishContent);
            let recoveryRepublishIntroText = this.recoveryRepublishReviewSection.getIntroText();
            this.caller.revertRepublishIntroTextRecovery(recoveryRepublishIntroText);
            let republishRecoveryReviewItems = this.recoveryRepublishReviewSection.getReviewItems();
            this.productReviewRepublish.setReviewItems(republishRecoveryReviewItems);

            const clone = rfdc(); // clone otherwise it will update the originals too
            let republishRecoveryDirectoryItems =  clone(this.recoveryRepublishDirectory.getTemplateViewModel().directoryItems());
            this.republishDirectory.setDirectoryItems([]);
            this.republishDirectory.setSandboxDirectoryItems(republishRecoveryDirectoryItems)

            let republishes = this.getTemplateViewModel().republishRecovery().republishes;
            if(republishes && republishes.length > 0) {
                let republish = republishes[0];
                this.republishDatePicker.setDate(republish.dateRepublished);
                if(republish.author) {
                    this.getTemplateViewModel().filterUser_republish_author.user(republish.author.valnet_user.fullNameAndLogin);
                    this.getTemplateViewModel().filterUser_republish_author.idUser(republish.author.id);
                }
                if(republish.editor) {
                    this.getTemplateViewModel().filterUser_republish_SrEditor.user(republish.editor.valnet_user.fullNameAndLogin);
                    this.getTemplateViewModel().filterUser_republish_SrEditor.idUser(republish.editor.id);
                }
                if(republish.juniorEditor) {
                    this.getTemplateViewModel().filterUser_republish_JrEditor.user(republish.juniorEditor ? republish.juniorEditor.valnet_user.fullNameAndLogin : "");
                    this.getTemplateViewModel().filterUser_republish_JrEditor.idUser(republish.juniorEditor ? republish.juniorEditor.id : "");
                }
                if(republish.postPaymentCategory) {
                    this.getTemplateViewModel().paymentCategoryFilter.setSelectedOption(republish.postPaymentCategory.id);
                }
                if (republish.percentageAuthor) {
                    this.getTemplateViewModel().choosenPaymentTypeRepublish(AuthorPaymentTypeForRepublish.PERCENTAGE);
                    this.getTemplateViewModel().percentageAuthor(republish.percentageAuthor);
                }
                if (republish.amountAuthor) {
                    this.getTemplateViewModel().choosenPaymentTypeRepublish(AuthorPaymentTypeForRepublish.AMOUNT);
                    this.getTemplateViewModel().amountAuthor(republish.amountAuthor);
                }
                this.getTemplateViewModel().percentageEditor(republish.percentageEditor);
            }

            this.checkIfRepublishHasContent();
        }
    }

    protected onClickRevertRevision() {

        let revisionIndex = this.getTemplateViewModel().selectedRevisionIndex();
        let revision = this.getTemplateViewModel().revisions()[revisionIndex];

        //to delete exiting ones
        let items = this.articleDirectory.getDirectoryItems();
        items.forEach( item =>  this.articleDirectory.getTemplateViewModel().deletedDirectoryItems().push(item));
        this.articleDirectory.setDirectoryItems([]);

        //set new
        this.articleDirectory.setDirectoryItemsObservable(revision.content.directoryItems);

        this.caller.sendToArticleContent(revision.content.content);
        this.caller.sendToArticleIntroText(revision.content.introText);
    }

    protected onClickCancelFaq() {

        this.getTemplateViewModel().isFaqAddFormShown(false);
    }

    protected onScrollSaveBoxSticky(data, event) {
        console.log(data, event);
        let elem = event.target;
        console.log(elem)
        // continue with scroll
        return true;
    }

    protected onClickSaveFaq() {

        let selectedFaqIndex = this.getTemplateViewModel().selectedFaqIndex();
        let faqs = this.getTemplateViewModel().faqs();
        let question = this.getTemplateViewModel().question();
        let answer = this.caller.getFaqAnswer();

        if (answer != null && answer != "" && question != null && question != "") {

            let faq = {question: question, answer: answer};
            if (selectedFaqIndex != null) {
                faqs[selectedFaqIndex] = faq;
            } else {
                faqs.push(faq);
            }

            this.getTemplateViewModel().faqs(faqs);
            this.getTemplateViewModel().selectedFaqIndex(null);
            this.clearFaqForm();
            this.getTemplateViewModel().isFaqAddFormShown(false);
        }

    }

    protected clearFaqForm() {
        this.getTemplateViewModel().question("");
        this.caller.clearFaqAnswer();
    }


    protected onClickSave() {

        if(!this.validateArticleStatusChange()){
            return;
        }

        let type = "save";
        this.getTemplateViewModel().showNewRepublish(false);

        if (!this.caller.validateArticleSaveFrontEnd()) {
            return;
        }

        if (!this.interuptStatusChange(type)) {

            this.caller.saveEditArticle(type);
        }
    }

    protected onClickSaveAndStay() {

        if(!this.validateArticleStatusChange()){
            return;
        }

        let type = "stay";
        this.getTemplateViewModel().showNewRepublish(false);

        if (!this.caller.validateArticleSaveFrontEnd()) {
            return;
        }

        if (!this.interuptStatusChange(type)) {

            this.getTemplateViewModel().idPreviousStatus(this.getTemplateViewModel().idStatus());
            this.getTemplateViewModel().idPreviousRepublishStatus(this.getTemplateViewModel().idRepublishStatus());
            this.caller.saveEditArticle(type);
        }
    }

    /**
     * Checks for a change in status and interrupts the flow if necessary.
     * If it's interupted is also shows a modal..
     *
     * @return {boolean} Returns true if the flow was interrupted, false otherwise.
     */
    protected interuptStatusChange(type) {
        if (this.getTemplateViewModel().idTemplate() == ID_TEMPLATE_VIDEO || this.getTemplateViewModel().idTemplate() == ID_TEMPLATE_THREAD) {
            return false;
        }

        let targetStatus = false;
        if (this.getTemplateViewModel().idStatus() !== this.getTemplateViewModel().idPreviousStatus()) {

            targetStatus = this.getTemplateViewModel().idStatus();
        } else if (this.getTemplateViewModel().idRepublishStatus() !== this.getTemplateViewModel().idPreviousRepublishStatus()) {

            targetStatus = this.getTemplateViewModel().idRepublishStatus();
        }

        if (targetStatus) {



            let promptData = this.getPromptToShow(targetStatus,true,true);
            if (promptData) {

                this.showPromptModal(promptData, type);

                return true; // interupt the save
            }
        }

        return false;
    }

    protected getPromptToShow(targetStatus,commentsRequired,isCancellable): any {

        let promptData: any = false;
        const STATUS_CHANGES_REQUIRED = "3";
        const STATUS_COMPLETED = "6";
        let contentType = this.getTemplateViewModel().idContentType();


        if (targetStatus == STATUS_CHANGES_REQUIRED || targetStatus == STATUS_COMPLETED) {

            this.caller.getSensaiResults("sensai_prompt", this.getTemplateViewModel().idContentType());

            promptData = {
                content: this.getTemplateViewModel().sensaiPromptContent(),
                idTargetStatus: targetStatus,
                commentsRequired: commentsRequired,
                isCancellable: isCancellable
            }

        }

        return promptData;
    }

    protected showPromptModal(promptData, type){

        if (!promptData.content) {
            return; // nothing to show anyway
        }

        this.sensaiPromptTemplate.setContent(promptData.content);
        this.sensaiPromptTemplate.setPromptType("sensaiPrompt");

        this.sensaiPromptTemplate.setAcceptText("Submit Feedback");
        this.sensaiPromptTemplate.setDeclineText("Cancel");
        this.setArticleReviewComments("");
        this.sensaiPromptTemplate.setAgree(this.failArticleReview.bind(this));
        this.sensaiPromptTemplate.setDecline(this.onClickContinueEditingAgreement.bind(this));
        this.sensaiPromptTemplate.setIdStatus(this.getTemplateViewModel().idStatus());
        this.sensaiPromptTemplate.setSaveType(type);
        this.sensaiPromptTemplate.setCommentsRequired(promptData.commentsRequired);
        this.sensaiPromptTemplate.setIsCancellable(promptData.isCancellable);

        // this shows the modal
        this.sensaiPromptTemplate.setShow(true);

    }

    public onClickCreateRepublishAndUpdateArticle(){

        let type = "republish";
        this.getTemplateViewModel().showNewRepublish(true);
        const republishItemsToDelete = this.getDirectoryItemsNotInRepublishDirectory();
        const directoryItemsToDelete = this.articleDirectory.getTemplateViewModel().deletedDirectoryItems();
        this.republishDirectory.getTemplateViewModel().deletedDirectoryItems.push(...directoryItemsToDelete, ...republishItemsToDelete);
        this.caller.save(type);
    }

    protected updateArticleOnRepublish(){

        this.caller.sendToArticleContent(this.getRepublishContent());
        this.caller.sendToArticleIntroText(this.getRepublishIntroText());
        this.productReview.setReviewItems(this.getRepublishReviewItems());
    }

    private validateSandboxOnRepublish(type){

        let isRepublish = this.getTemplateViewModel().showNewRepublish();
        let idRepublish = this.getTemplateViewModel().idRepublish();
        let sandboxData = this.caller.getSandboxEditorContent();
        this.setSaveType(type);
        //if creating new republish and sandbox is not empty, show warning message
        if(isRepublish && !idRepublish && sandboxData && sandboxData.replaceAll(' ','').replaceAll('<br/>','').replaceAll('\n','').replaceAll('&nbsp;','') != ""){

            this.setIsRepublishMessageVisible(true);
            return false;
        }

        return true;
    }

    protected onClickSaveAndPreview(contentType) {

        this.getTemplateViewModel().previewContentType(contentType);
        this.caller.saveEditArticle("preview");
    }

    protected onClickSaveAndPreviewAMP(contentType) {

        this.getTemplateViewModel().previewContentType(contentType);
        this.caller.saveEditArticle("preview-amp");
    }

    protected onClickPreviewNoSave(contentType) {

        this.getTemplateViewModel().previewContentType(contentType);
        this.caller.previewNoSaveArticle("preview");
    }

    protected onClickDeleteSandbox() {

        this.warningDialog_sandboxDelete.setIsVisible(true);
    }

    protected onClickDeleteRepublish() {

        this.warningDialog_republishDelete.setIsVisible(true);
    }

    protected onClickRepublishCreateAndUpdate() {

        this.warningDialog_republishCreateAndUpdate.setIsVisible(true);
    }

    protected onClickPreviewAMPNoSave(contentType) {

        this.getTemplateViewModel().previewContentType(contentType);
        this.caller.previewNoSaveArticle("preview-amp");
    }

    public getContentTypeToPreview(): string {

        let activeTag = this.getTemplateViewModel().previewContentType();
        if (this.previewableTabs.indexOf(activeTag) !== -1) {
            return activeTag;
        }

        return Previewable.ARTICLE;
    }

    protected onClickViewOnSite() {

        let brand = this.getTemplateViewModel().brand();
        let permalink = this.getTemplateViewModel().permalink();
        this.caller.viewArticleOnSite(brand, permalink);
    }

    protected onClickViewOnSiteAMP() {

        let brand = this.getTemplateViewModel().brand();
        let permalink = this.getTemplateViewModel().permalink();
        this.caller.viewArticleOnSiteAMP(brand, permalink);
    }

    public setAutoCategorizationGenerationAttemptsRemaining(attempts): void {

        let attemptsRemaining = 4;

        if(attempts){
            attemptsRemaining = 4 - attempts;

            if (attemptsRemaining < 0) {
                attemptsRemaining = 0;
            }
        }

        this.getTemplateViewModel().autoCategorizationGenerationAttemptsRemaining(attemptsRemaining);
    }

    public setKeyPointsGenerationAttemptsRemaining(id): void {

        //this.getTemplateViewModel().keyPointsGenerationAttemptsRemaining(id);
    }

    public setId(id): void {

        this.getTemplateViewModel().id(id);
    }

    public setDateLastPreview(dateLastPreview): void {

        this.getTemplateViewModel().dateLastPreview(dateLastPreview);
    }


    public getId() {

        return this.getTemplateViewModel().id();
    }

    public setBrand(brand): void {

        this.getTemplateViewModel().brand(brand);
        this.articlePicker.setBrand(brand);
    }

    public setTitle(title): void {

        this.getTemplateViewModel().title(title);
    }

    public setIdTemplate(idTemplate): void {
        this.getTemplateViewModel().idTemplate(idTemplate);
        this.productReview.setIdTemplate(idTemplate);
        this.productReviewSandbox.setIdTemplate(idTemplate);
        this.productReviewRepublish.setIdTemplate(idTemplate);
        this.recoverySandboxReviewSection.setIdTemplate(idTemplate);
        this.recoveryRepublishReviewSection.setIdTemplate(idTemplate);
        this.recoveryReviewSection.setIdTemplate(idTemplate);
        this.revisionReviewSection.setIdTemplate(idTemplate);
    }



    public getIdTemplate() {

        return this.getTemplateViewModel().idTemplate();
    }


    public setDateUpdated(dateUpdated): void{

        this.getTemplateViewModel().dateUpdated(dateUpdated);
    }

    public setDateCreated(dateCreated): void{

        this.getTemplateViewModel().dateCreated(dateCreated);
    }

    public setDateRecovery(dateRecovery): void{

        this.getTemplateViewModel().dateRecovery(dateRecovery);
    }

    public setRecoveryUser(recoveryUser): void{

        this.getTemplateViewModel().recoveryUser(recoveryUser);
    }

    public setRecovery(recovery): void{

        this.getTemplateViewModel().recovery(recovery);
    }

    public setSandboxRecovery(recovery): void{

        this.getTemplateViewModel().sandboxRecovery(recovery);
    }

    public setRepublishRecovery(recovery): void{

        this.getTemplateViewModel().republishRecovery(recovery);
    }

    public setIdRevisionSelected(idRevisionSelected): void{
        this.getTemplateViewModel().idRevisionSelected(idRevisionSelected);
    }

    public setRecoveryContent(recoveryContent): void{

        this.getTemplateViewModel().recoveryContent(recoveryContent);
    }

    public setSandboxRecoveryContent(sandboxRecoveryContent): void{

        this.getTemplateViewModel().sandboxRecoveryContent(sandboxRecoveryContent);
    }

    public setRepublishRecoveryContent(republishRecoveryContent): void{

        this.getTemplateViewModel().republishRecoveryContent(republishRecoveryContent);
    }

    public setRevisionContent(revisionContent): void{

        this.getTemplateViewModel().revisionContent(revisionContent);
    }

    public setRevisionIntroText(revisionIntroText): void{

        this.revisionReviewSection.setIntroText(revisionIntroText);
    }

    public setRevisionReviewItems(revisionReviewItems): void{

        this.revisionReviewSection.setReviewItems(revisionReviewItems);
    }

    public setSandboxRecoveryIntroText(sandboxRecoveryIntroText): void{

        this.recoverySandboxReviewSection.setIntroText(sandboxRecoveryIntroText);
    }

    public setRepublishRecoveryIntroText(republishRecoveryIntroText): void{

        this.recoveryRepublishReviewSection.setIntroText(republishRecoveryIntroText);
    }

    public setRecoveryIntroText(recoveryIntroText): void{

        this.recoveryReviewSection.setIntroText(recoveryIntroText);
    }

    public setSelectedCategories(selectedCategories): void{

        this.getTemplateViewModel().selectedCategories(selectedCategories);
    }

    public setPollOptions(poll_options): void {

        this.getTemplateViewModel().poll_options(poll_options);
    }

    public setSelectedTags(selectedTags): void {

        selectedTags.forEach((t) => {
            let formattedTagTypeAndDataset = '';
            if (t.tag.type != null) {
                formattedTagTypeAndDataset = ' (' + t.tag.type.name +')';
            }

            if (!t.tag['formattedTagTypeAndDataset']) {

                t.tag['formattedTagTypeAndDataset'] = formattedTagTypeAndDataset
            }
        });

        this.getTemplateViewModel().selectedTags(selectedTags);
    }

    public showReviewItemForm() {

        this.makeBodyUnscrollable();
        this.getTemplateViewModel().isReviewProductFormShown(true);
    }

    public hideReviewItemForm() {

        this.makeBodyScrollableAgain();
        this.getTemplateViewModel().isReviewProductFormShown(false);
        this.clearReviewItemForm();
    }

    public addValidationClass() {

        document.body.classList.add('_form-sub')
    }

    public removeValidationClass() {

        document.body.classList.remove('_form-sub')
    }

    public addTagPickerValidationClass() {

        document.body.classList.add('_tagpicker')
    }

    public removeTagPickerValidationClass() {

        document.body.classList.remove('_tagpicker')
    }

    public setSelectedFilterCategories(categories): void{

        let selectedCategories = [];

        selectedCategories = categories.map(e => e.category);

        this.filterCategory.setSelectedItems(selectedCategories);
    }

    public setIdPrimaryCategory(idPrimaryCategory): void{

        this.getTemplateViewModel().idPrimaryCategory(idPrimaryCategory);
    }

    public setIdPrimaryTag(idPrimaryTag): void{

        this.getTemplateViewModel().idPrimaryTag(idPrimaryTag);
    }

    public setCategoryFilterItems(items){

        this.getTemplateViewModel().categories(items);
        this.filterCategory.setItems(items);
    }

    public setContentPresets(contentPresets): void {
        this.getTemplateViewModel().contentPresets(contentPresets);
    }

    public setExcerpt(excerpt): void{

        this.getTemplateViewModel().excerpt(excerpt);
    }

    public setDisplayConfiguration(displayConfiguration): void{

        this.getTemplateViewModel().displayConfiguration(displayConfiguration);
    }

    public setIsAdHidden(isAdHidden): void{

        this.getTemplateViewModel().isAdHidden(isAdHidden);
    }

    public setIsUnderEmbargo(isUnderEmbargo): void{

        this.getTemplateViewModel().isUnderEmbargo(isUnderEmbargo);
    }

    public setIsAmpDisabled(isAmpDisabled): void{

        this.getTemplateViewModel().isAmpDisabled(isAmpDisabled);
    }

    public setIsAffiliateLinkerEnabled(isAffiliateLinkerEnabled): void{

        this.getTemplateViewModel().isAffiliateLinkerEnabled(isAffiliateLinkerEnabled);
    }

    public setIsDevelopingStory(isDevelopingStory): void{

        this.getTemplateViewModel().isDevelopingStory(isDevelopingStory);
    }

    public setReference(reference): void{

        this.getTemplateViewModel().reference(reference);
    }

    public setAICategories(categories): void{

        let selectedCats = this.getTemplateViewModel().selectedCategories();

        for(let cat of categories){

            let existingCat = selectedCats.find(c => c.category.id == cat.id);

            if (!existingCat) {
                selectedCats.push({id: null, category: cat, isAIGenerated: true});
            }
        }

        this.getTemplateViewModel().selectedCategories(selectedCats);
    }

    public setAITags(tags): void{

        let selectedTags = this.getTemplateViewModel().selectedTags();

        for(let tag of tags){

            let existingTag = selectedTags.find(t => t.tag.id == tag.id);

            if (!existingTag) {
                if (!tag.formattedTagTypeAndDataset) {
                    tag.formattedTagTypeAndDataset = '';
                }
                if(tag.tagType != null){
                    tag.type = {};
                    tag.type.id = tag.idType;
                    tag.type.name = tag.tagType;
                    tag.formattedTagTypeAndDataset = '(' + tag.tagType + ')';

                }
                selectedTags.push({id: null, tag: tag, isAIGenerated: true});
            }
        }

        this.getTemplateViewModel().selectedTags(selectedTags);
    }

    public setPermalink(permalink): void{

        this.getTemplateViewModel().permalink(permalink);
    }

    public setDatePublished(datePublished): void{

        this.getTemplateViewModel().datePublished(datePublished);
    }

    public getDatePublished(){

        return this.getTemplateViewModel().datePublished();
    }

    public setDateMostRecentPublishedStatus(dateMostRecentPublishedStatus): void{

        this.getTemplateViewModel().dateMostRecentPublishedStatus(dateMostRecentPublishedStatus);
    }

    public setDateLastPublishStatus(dateLastPublishStatus): void{

        this.getTemplateViewModel().dateLastPublishStatus(dateLastPublishStatus);
    }

    public setDateMostRecentPublishStatus(dateMostRecentPublishStatus): void{

        return this.getTemplateViewModel().dateMostRecentPublishStatus(dateMostRecentPublishStatus);
    }

    public setIsUpdateTime(isUpdateTime): void{

        return this.getTemplateViewModel().isUpdateTime(isUpdateTime);
    }

    public setContentKeyPoints(contentKeyPoints): void{

        return this.getTemplateViewModel().contentKeyPoints(contentKeyPoints);
    }

    public setArticlePageSettings(articlePageSettings) {

        return this.getTemplateViewModel().articlePageSettings(articlePageSettings);
    }

    public setDateLastStatus(dateLastStatus): void{

        this.getTemplateViewModel().dateLastStatus(dateLastStatus);
    }

    public setDateLastSyncStatus(dateLastSyncStatus): void{

        this.getTemplateViewModel().dateLastSyncStatus(dateLastSyncStatus);
    }

    public setAuthor(author): void{

        this.getTemplateViewModel().filterUser_author.users(author);
        this.getTemplateViewModel().filterUser_author.user(author.valnet_user.fullNameAndLogin);
        this.getTemplateViewModel().filterUser_author.idUser(author.id);
        this.getTemplateViewModel().author(author);

    }

    public setDisplayAuthors(displayAuthors: Array<User>): void{

        this.display_authors.setUsers(displayAuthors);
        // this.getTemplateViewModel().filterUser_display_author.user(displayAuthor.valnet_user.fullNameAndLogin);
        // this.getTemplateViewModel().filterUser_display_author.idUser(displayAuthor.id);
        // this.getTemplateViewModel().displayAuthor(displayAuthor);

    }

    public setSensaiPrompt(sensaiPrompt): void{
        this.getTemplateViewModel().sensaiPromptContent([]);
        this.getTemplateViewModel().sensaiPromptContent(sensaiPrompt);

    }

    public getSensaiPrompt(): string{
        return this.getTemplateViewModel().sensaiPrompt();
    }

    public disableContributorFields(){

        let permissions = this.getTemplateViewModel().permissions();

        if(!permissions['article_edit_publishingControl'].write){

            this.filterUser_SrEditor.setDisabled(true);
            // this.filterUser_republish_SrEditor.setDisabled(true);
            this.filterUser_JrEditor.setDisabled(true);
            this.filterUser_ideator.setDisabled(true);
            // this.filterUser_republish_JrEditor.setDisabled(true);
            this.filterUser_display_author.setDisabled(true);
        }

        if(!permissions['article_edit_brand'].write){

            this.filterUser_author.setDisabled(true);
            // this.filterUser_republish_author.setDisabled(true);
        }

    }

    public setEditor(editor): void{

        this.getTemplateViewModel().filterUser_SrEditor.users(editor);
        this.getTemplateViewModel().filterUser_SrEditor.user(editor.valnet_user.fullNameAndLogin);
        this.getTemplateViewModel().filterUser_SrEditor.idUser(editor.id);
        this.getTemplateViewModel().editor(editor);
    }

    public setJrEditor(jrEditor): void{

        this.getTemplateViewModel().filterUser_JrEditor.users(jrEditor);
        this.getTemplateViewModel().filterUser_JrEditor.user(jrEditor.valnet_user.fullNameAndLogin);
        this.getTemplateViewModel().filterUser_JrEditor.idUser(jrEditor.id);
        this.getTemplateViewModel().jrEditor(jrEditor);
    }

    public setIdeator(ideator): void{

        this.getTemplateViewModel().filterUser_ideator.users(ideator);
        this.getTemplateViewModel().filterUser_ideator.user(ideator.valnet_user.fullNameAndLogin);
        this.getTemplateViewModel().filterUser_ideator.idUser(ideator.id);
        this.getTemplateViewModel().ideator(ideator);
    }

    public setTargetAudience(targetAudience): void{

        this.getTemplateViewModel().targetAudience(targetAudience);
    }

    public setIntent(intent): void{

        this.getTemplateViewModel().intent(intent);
    }

    public setContentType(contentType): void{

        this.getTemplateViewModel().contentType(contentType);
    }

    public setSegment(segment): void{
        this.getTemplateViewModel().segment(segment);
    }

    public setNetworkCategory(networkCategory): void{

        this.getTemplateViewModel().networkCategory(networkCategory);
    }

    public setPostPaymentCategory(postPaymentCategory): void{

        this.getTemplateViewModel().postPaymentCategory(postPaymentCategory);
    }

    public setAllowEditPermalink(allowEditPermalink): void{

        this.getTemplateViewModel().allowEditPermalink(allowEditPermalink);
    }

    public setAmazonsiteArticleTitle(amazonsiteArticleTitle): void{

        if(amazonsiteArticleTitle) {

            this.getTemplateViewModel().amazonsiteArticleTitle(amazonsiteArticleTitle);
        }else{

            this.getTemplateViewModel().amazonsiteArticleTitle(this.getTemplateViewModel().title());
        }
    }

    public setNewsNowArticleTitle(newsNowArticleTitle): void{

        if(newsNowArticleTitle) {

            this.getTemplateViewModel().newsNowArticleTitle(newsNowArticleTitle);
        }
    }


    public setAmazonsitePublishDate(PublishDate): void{
        if(PublishDate) {
            this.getTemplateViewModel().amazonsitePublishDate(PublishDate);
        }else{
            this.getTemplateViewModel().amazonsitePublishDate(this.getTemplateViewModel().dateMostRecentPublishedStatus());
        }
    }

    public setUpdateAmazonsitePublishDate(updateAmazonsitePublishDate): void{
        this.getTemplateViewModel().updateAmazonsitePublishDate(updateAmazonsitePublishDate);
    }


    public setAmazonOnSiteDate(date): void{
        this.getTemplateViewModel().amazonsitePublishDate(date);
    }

    public setDateScheduled(date): void {

        let permissions = this.getTemplateViewModel().permissions();

        if (!permissions['article_edit_publishingControl'].write) {

            this.scheduleDatePicker.setIsPickerDisabled(true);
        }

        if (date != '') {

            this.scheduleDatePicker.setDate(date);
        } else {

            this.scheduleDatePicker.setDate(this.getFormattedEasternTimeZoneDateTime());
        }
    }

    public setDateDevelopingStoryCoverageStartAndEnd(dateStart, dateEnd): void {
        this.dateDevelopingStoryCoverageStartPicker.setDate(dateStart);
        this.dateDevelopingStoryCoverageEndPicker.setDate(dateEnd);
    }

    public setListOrder(listOrder): void{

        this.getTemplateViewModel().listOrder(listOrder);
    }

    public setSeoTitle(seoTitle): void{

        this.getTemplateViewModel().seoTitle(seoTitle);
    }

    public setSeoDescription(seoDescription): void{

        this.getTemplateViewModel().seoDescription(seoDescription);
    }

    public setSmoTitle(smoTitle): void{

        this.getTemplateViewModel().smoTitle(smoTitle);
    }

    public setSmoDescription(smoDescription): void{

        this.getTemplateViewModel().smoDescription(smoDescription);
    }

    public setSocialTagLine(socialTagLine){
        this.getTemplateViewModel().socialTagLine(socialTagLine);
    }

    public setFileUrl(url){

        this.getTemplateViewModel().fileUrl(url);
    }

    public setTableOfContents(tableOfContents){

        this.getTemplateViewModel().tableOfContents(tableOfContents);
    }

    public setIsNewsNowArticle(isNewsNowArticle){
        this.getTemplateViewModel().isNewsNowArticle(isNewsNowArticle);
    }

    public setIsSponsored(isSponsored){

        this.getTemplateViewModel().isSponsored(isSponsored);
    }


    public setImage(image, target){
        if(target == 'thumbnail_image'){
            this.imageWidgetForThumbnailImage.setImage(image)
        }

        if(target == 'alternate_image'){
            this.imageWidgetForAlternateImage.setImage(image)
        }

        if(target == 'featured_image' || target == 'featured_image_embed'){
            this.imageWidgetForFeaturedImage.setImage(image);
            this.getTemplateViewModel().featuredImage(image);
            this.setIsFeaturedImageMobileOptimized(image.isMobileOptimized);
        }

    }

    public setIsFeaturedImageMobileOptimized(val) {
        this.getTemplateViewModel().IsFeaturedImageMobileOptimized(val);
    }

    public setTagImage(image){

        this.getTemplateViewModel().tagImage(image);
    }

    public setNextArticle(article){

        this.filterArticle.getTemplateViewModel().article(article.title)
        this.filterArticle.getTemplateViewModel().articleObj(article)
        this.filterArticle.getTemplateViewModel().idArticle(article.id);
    }

    public setDirectoryArticle(article) {

        this.getTemplateViewModel().filterArticle.showDetails(true);
        this.filterArticleDirectory.getTemplateViewModel().article(article.title)
        this.filterArticleDirectory.getTemplateViewModel().articleObj(article)
        this.filterArticleDirectory.getTemplateViewModel().idArticle(article.id);
        this.filterArticleDirectory.setDisableField(true);
    }

    public setUsers(users){

        this.getTemplateViewModel().filterUser_author.users(users);
        this.getTemplateViewModel().filterUser_SrEditor.users(users);
        this.getTemplateViewModel().filterUser_JrEditor.users(users);
        this.getTemplateViewModel().filterUser_ideator.users(users);
        this.getTemplateViewModel().filterUser_republish_author.users(users);
        this.getTemplateViewModel().filterUser_republish_SrEditor.users(users);
        this.getTemplateViewModel().filterUser_republish_JrEditor.users(users);
        this.getTemplateViewModel().filterUser_display_author.users(users);
    }

    public setFilterUserAuthor(users){

        this.getTemplateViewModel().filterUser_author.users(users);
    }

    public setFilterUserSrEditor(users){

        this.getTemplateViewModel().filterUser_SrEditor.users(users);
    }

    public setFilterUserJrEditor(users){

        this.getTemplateViewModel().filterUser_JrEditor.users(users);
    }

    public setFilterUserIdeator(users){
        this.getTemplateViewModel().filterUser_ideator.users(users);
    }

    public setFilterUserRepublishAuthor(users){

        this.getTemplateViewModel().filterUser_republish_author.users(users);
    }

    public setFilterUserScheduledRepublishAuthor(users){

        this.getTemplateViewModel().filterUser_scheduled_republish_author.users(users);
    }

    public setFilterUserRepublishSrEditor(users){

        this.getTemplateViewModel().filterUser_republish_SrEditor.users(users);
    }

    public setFilterUserScheduledRepublishSrEditor(users){

        this.getTemplateViewModel().filterUser_scheduled_republish_SrEditor.users(users);
    }

    public setFilterUserRepublishJrEditor(users){

        this.getTemplateViewModel().filterUser_republish_JrEditor.users(users);
    }

    public setFilterUserScheduledRepublishJrEditor(users){

        this.getTemplateViewModel().filterUser_scheduled_republish_JrEditor.users(users);
    }

    public setFilterUserDisplayAuthor(users){

        this.getTemplateViewModel().filterUser_display_author.users(users);
    }

    public setCanSearchUsers(canSearchUsers: boolean){

        this.filterUser_author.setIsVisible(canSearchUsers);
        this.filterUser_SrEditor.setIsVisible(canSearchUsers);
        this.filterUser_JrEditor.setIsVisible(canSearchUsers);
        this.filterUser_ideator.setIsVisible(canSearchUsers);
        this.filterUser_display_author.setIsVisible(canSearchUsers);

        this.filterUser_republish_author.setIsVisible(canSearchUsers);
        this.filterUser_republish_SrEditor.setIsVisible(canSearchUsers);
        this.filterUser_republish_JrEditor.setIsVisible(canSearchUsers);
        this.filterWebsiteUser_prompt_author.setIsVisible(canSearchUsers);
    }

    public deleteScheduledRepublish() {

        this.getTemplateViewModel().idDeleteRepublish(this.getTemplateViewModel().idRepublish());
        this.getTemplateViewModel().showScheduledRepublish(false)
        this.getTemplateViewModel().idRepublish(null);
        this.getTemplateViewModel().filterUser_scheduled_republish_author.user("");
        this.getTemplateViewModel().filterUser_scheduled_republish_author.idUser(null);
        this.getTemplateViewModel().filterUser_scheduled_republish_SrEditor.user("");
        this.getTemplateViewModel().filterUser_scheduled_republish_SrEditor.idUser(null);
        this.getTemplateViewModel().filterUser_scheduled_republish_JrEditor.user("");
        this.getTemplateViewModel().filterUser_scheduled_republish_JrEditor.idUser(null);
        this.getTemplateViewModel().scheduledRepublishPaymentCategoryFilter.setSelectedOption(null);
        this.getTemplateViewModel().showNewRepublish(false);
        this.getTemplateViewModel().showDeleteRepublishButton(false);
        this.getTemplateViewModel().scheduledAmountAuthor(null);
        this.getTemplateViewModel().scheduledPercentageAuthor(null);
        this.getTemplateViewModel().scheduledPercentageEditor(null);
    }

    public setArticleRepublishData(republishes): void {

        //filter to exclude non-reportable republish
        republishes = republishes.filter(republish => { return republish.isReportable == 1})

        //sort the array by date
        republishes.sort((a, b) => new Date(b.dateRepublished).valueOf() - new Date(a.dateRepublished).valueOf());

        //find the one which schedule
        let index = republishes.findIndex(element => element.publishStatus.id == 2);

        if (index != -1) {
            let scheduledRepublish = republishes[index];
            republishes.splice(index, 1);
            this.setScheduledRepublish(scheduledRepublish);
        }

        this.getTemplateViewModel().republishes(republishes);
    }

    public setScheduledRepublish(republish){

        this.getTemplateViewModel().showScheduledRepublish(true);
        this.getTemplateViewModel().showDeleteRepublishButton(true);
        this.getTemplateViewModel().idRepublish(republish.id);
        this.scheduledRepublishDatePicker.setDate(republish.dateRepublished);
        this.getTemplateViewModel().filterUser_scheduled_republish_author.user(republish.author.valnet_user.fullNameAndLogin);
        this.getTemplateViewModel().filterUser_scheduled_republish_author.idUser(republish.author.id);
        this.getTemplateViewModel().filterUser_scheduled_republish_SrEditor.user(republish.editor.valnet_user.fullNameAndLogin);
        this.getTemplateViewModel().filterUser_scheduled_republish_SrEditor.idUser(republish.editor.id);
        this.getTemplateViewModel().filterUser_scheduled_republish_JrEditor.user(republish.juniorEditor ? republish.juniorEditor.valnet_user.fullNameAndLogin : "");
        this.getTemplateViewModel().filterUser_scheduled_republish_JrEditor.idUser(republish.juniorEditor ? republish.juniorEditor.id : "");
        this.getTemplateViewModel().scheduledRepublishPaymentCategoryFilter.setSelectedOption(republish.postPaymentCategory.id);
        this.getTemplateViewModel().scheduledAmountAuthor(republish.amountAuthor);
        this.getTemplateViewModel().scheduledPercentageAuthor(republish.percentageAuthor);
        this.getTemplateViewModel().scheduledPercentageEditor(republish.percentageEditor);

        if(republish.percentageAuthor){
            this.getTemplateViewModel().choosenScheduledPaymentTypeRepublish(AuthorPaymentTypeForRepublish.PERCENTAGE)
        }else if(republish.amountAuthor){
            this.getTemplateViewModel().choosenScheduledPaymentTypeRepublish(AuthorPaymentTypeForRepublish.AMOUNT)
        }

    }

    public setRecoveryRepublishData(republish){

        this.getTemplateViewModel().republishRecoveryDate(republish.dateRepublished ? republish.dateRepublished : '');
        this.getTemplateViewModel().republishRecoveryAuthor(republish.author ? republish.author.valnet_user.fullName : '');
        this.getTemplateViewModel().republishRecoverySrEditor(republish.editor ? republish.editor.valnet_user.fullName : '');
        this.getTemplateViewModel().republishRecoveryJrEditor(republish.juniorEditor ? republish.juniorEditor.valnet_user.fullName : '');
        this.getTemplateViewModel().republishRecoveryPaymentCategory(republish.postPaymentCategory ? republish.postPaymentCategory.name : '');
        this.getTemplateViewModel().republishRecoveryAuthorAmount(republish.amountAuthor ? republish.amountAuthor : '');
        this.getTemplateViewModel().republishRecoveryAuthorPercentage(republish.percentageAuthor ? republish.percentageAuthor : '');
        this.getTemplateViewModel().republishRecoveryEditorPercentage(republish.percentageEditor ? republish.percentageEditor : '');
        this.getTemplateViewModel().republishRecoveryStatus(republish.status ? republish.status.name : '');
    }

    public setPublishStatuses(publishStatuses: Array<{}>): void{

        this.getTemplateViewModel().publishStatuses(publishStatuses);
    }

    public setPermalinkHistory(permalinkHistory) {
        this.getTemplateViewModel().permalinkHistory(permalinkHistory);
    }

    public setPermalinkRedirect(permalinkRedirect){
        this.getTemplateViewModel().permalinkRedirects(permalinkRedirect);
    }

    public setNetworkCategoryOptions(networkCategory_options: Array<{}>): void{

        this.getTemplateViewModel().networkCategory_options(networkCategory_options);
    }

    public setContentTypeOptions(contentType_options: Array<{}>): void{

        this.getTemplateViewModel().contentType_options(contentType_options);
    }

    public setSegmentOptions(segment_options: Array<{}>): void{
        this.getTemplateViewModel().segment_options(segment_options);
    }

    public setIntentOptions(intent_options: Array<{}>): void{

        this.getTemplateViewModel().intent_options(intent_options);
    }

    public setIdNetworkCategory(idNetworkCategory): void{

        this.getTemplateViewModel().idNetworkCategory(idNetworkCategory);
    }

    public setIdContentType(idContentType): void{

        this.getTemplateViewModel().idContentType(idContentType);
    }

    public setIdSegment(idSegment, segment): void{

        if (segment !== null) {
            const segment_options = this.getTemplateViewModel().segment_options();

            const segmentExists = segment_options.some(opt => opt.id === idSegment);

            if (!segmentExists) {
                this.getTemplateViewModel().segment_options([...segment_options, segment]);
            }
        }

        this.getTemplateViewModel().idSegment(idSegment);
    }

    public setIdIntent(idIntent): void{

        this.getTemplateViewModel().idIntent(idIntent);
    }

    public setPaymentCategoryOptions(paymentCategory_options: Array<{}>): void{

        this.getTemplateViewModel().paymentCategory_options(paymentCategory_options);
    }

    public setIdPaymentCategory(idPaymentCategory): void{

        this.getTemplateViewModel().idPaymentCategory(idPaymentCategory);
    }

    public setIdRepublishPaymentCategory(idRepublishPaymentCategory): void{

        this.getTemplateViewModel().idRepublishPaymentCategory(idRepublishPaymentCategory);
    }

    public setReviewCategory(reviewCategory): void{

        this.getTemplateViewModel().reviewCategory(reviewCategory);
    }

    public setReviewItems(reviewItems): void{

        this.productReview.setReviewItems(reviewItems);
    }

    public setSandboxReviewItems(reviewItems): void{

        this.productReviewSandbox.setReviewItems(reviewItems, 'sandbox');
    }

    public setArticleStatusOptions(articleStatus_options: Array<{}>): void{

        this.getTemplateViewModel().articleStatus_options(articleStatus_options);
    }

    public setArticleRepublishStatusOptions(articleRepublishStatus_options): void{

        this.getTemplateViewModel().articleRepublishStatus_options(articleRepublishStatus_options);
    }

    public setAffiliateLinksOptions(affiliateLinks_options: Array<{}>): void {

        this.getTemplateViewModel().affiliateLinks_options(affiliateLinks_options);
    }

    public setReviewItemTagOptions(reviewItemAward_options: Array<{}>): void{

        this.getTemplateViewModel().reviewItemAward_options(reviewItemAward_options);
    }

    public setIdArticleStatus(idStatus): void{

        this.getTemplateViewModel().idStatus(idStatus);
        this.sandboxContent.setIdStatus(idStatus);
        this.republishContent.setIdStatus(idStatus);
        this.articleContent.setIdStatus(idStatus);
        this.productReview.setIdStatus(idStatus);
        this.productReviewSandbox.setIdStatus(idStatus);
        this.productReviewRepublish.setIdStatus(idStatus);
        //
        this.imageWidgetForThumbnailImage.setIdStatus(idStatus);
        this.imageWidgetForAlternateImage.setIdStatus(idStatus);
        this.imageWidgetForFeaturedImage.setIdStatus(idStatus);
        // this.imageWidgetForFeaturedVideo.setIdStatus(idStatus);
    }

    public setPreviousIdArticleStatus(idStatus): void{

        this.getTemplateViewModel().idPreviousStatus(idStatus);
    }

    public setPreviousidRepublishStatus(idStatus): void{

        this.getTemplateViewModel().idPreviousRepublishStatus(idStatus);
    }

    public setIdSyncStatus(idSyncStatus): void{

        this.getTemplateViewModel().idSyncStatus(idSyncStatus);
    }

    public setSyncStatus(syncStatus): void{

        this.getTemplateViewModel().syncStatus(syncStatus);
    }

    public setIdPublishStatus(idPublishStatus): void{

        this.getTemplateViewModel().idPublishStatus(idPublishStatus);
    }

    public setArticleCurrentIdArticleStatus(articleCurrentIdArticleStatus): void{

        this.getTemplateViewModel().articleCurrentIdArticleStatus(articleCurrentIdArticleStatus);
    }


    public setFeaturedVideo(featuredVideo){
        this.getTemplateViewModel().featuredVideo(featuredVideo);
    }

    protected onClickAddMedia(){

        this.showImagePicker("multi-select", "content");
    }

    protected onClickAddFeaturedImage(){

        this.showImagePicker("single-select", "featuredImage");
    }

    protected onClickAddThumbnailImage(){

        this.showImagePicker("single-select", "thumbnailImage");
    }

    protected onClickEditThumbnailImage(){

        let thumbnailImage = this.getTemplateViewModel().thumbnailImage();
        this.showImagePicker("single-select", "thumbnailImage");
        this.imagePicker.editImage(thumbnailImage);
    }

    protected onClickViewThumbnailImage(){

        let thumbnailImageElement = document.getElementById("thumbnail-image");
        thumbnailImageElement.classList.add("is-viewing");
    }

    protected onClickCloseThumbnailImage() {

        let thumbnailImageElement = document.getElementById("thumbnail-image");
        thumbnailImageElement.classList.remove("is-viewing");
    }

    protected onClickAddTagImage(){

        this.showImagePicker("single-select", "tagImage");
    }

    protected onClickSelectProductImages(){

        this.showImagePicker("multi-select", "productImages");
    }


    protected onClickViewFeaturedImage(){
        let featuredImageElement = document.getElementById("featured-image");
        featuredImageElement.classList.add("is-viewing");
    }

    protected onClickCloseFeaturedImage() {

        let featuredImageElement = document.getElementById("featured-image");
        featuredImageElement.classList.remove("is-viewing");
    }

    protected onClickEditTagImage(){

        let tagImage = this.getTemplateViewModel().tagImage();
        this.showImagePicker("single-select", "tagImage");
        this.imagePicker.editImage(tagImage);
    }

    protected onClickViewTagImage(){

        let tagImageElement = document.getElementById("tagImage");
        tagImageElement.classList.add("is-viewing");
    }

    protected onClickCloseTagImage(){

        let tagImageElement = document.getElementById("tagImage");
        tagImageElement.classList.remove("is-viewing");
    }

    protected onClickAddAlternateImage(){

        this.showImagePicker("single-select", "alternateImage");
    }

    protected onClickEditAlternateImage(){

        let alternateImage = this.getTemplateViewModel().alternateImage();
        this.showImagePicker("single-select", "alternateImage");
        this.imagePicker.editImage(alternateImage);
    }

    protected onClickViewAlternateImage(){

        let alternateImageElement = document.getElementById("alternate-image");
        alternateImageElement.classList.add("is-viewing");
    }

    protected onClickCloseAlternateImage(){

        let alternateImageElement = document.getElementById("alternate-image");
        alternateImageElement.classList.remove("is-viewing");
    }

    public getImagePickerTarget(){
        return this.getTemplateViewModel().imagePickerTarget();
    }

    public setImagePickerTarget(imagePickerTarget)
    {
        this.getTemplateViewModel().imagePickerTarget(imagePickerTarget);
    }

    public setTagPickerTarget(tagPickerTarget){
        this.getTemplateViewModel().tagPickerTarget(tagPickerTarget);
    }

    public isImageInsertionSectionOptimizable(target) {

        let optimizableImagesSections: string[] = [
            'article_content',
            'article_faq',
            'article_directory_item_description',
            'article_republish',
            'article_sandbox',
            'featured_image'
        ];
        return (optimizableImagesSections.indexOf(target) != -1);
    }
    public showImagePicker(mode, target, selectedImages = [], keyword = null) {

        let targetName = target;
        if (target.editor) {
            targetName = target.editor;
        }

        let isImageInsertionSectionOptimizable = this.isImageInsertionSectionOptimizable(targetName);
        this.imagePicker.setIsImageOptimizable(isImageInsertionSectionOptimizable);
        this.imagePicker.setMode(mode);
        this.setImagePickerTarget(target);
        this.imagePicker.setTarget(targetName);
        this.imagePicker.setSelectedImages(selectedImages);
        this.caller.getImageData(keyword);
        if(mode == "multi-select"){
            this.caller.getImagesInContent(target);
        }
        this.imagePicker.show();
    }

    public showTagPicker(mode, target, filterKeyword = null){

        this.tagPicker.setMode(mode);
        this.tagPicker.setTarget(target);
        this.tagPicker.setSimpleFilterKeyword(filterKeyword);
        this.setTagPickerTarget(target);
        //this.caller.getTagData();
        this.tagPicker.show();
    }

    public editTagElement(tagElement, editor){

        this.showTagPicker("in-content", editor);
        this.tagPicker.editTagElement(tagElement);
    }

    public editTagGroup(groupElement, editor){

        this.showTagPicker("in-content", editor);
        this.tagPicker.setTagGroupElement(groupElement);
    }

    protected onFocusOutTitle(event){

        if (event.target.value != null && event.target.value != "") {
            this.generatePermalink(event.target.value);
        }

    }

    protected onFocusOutPrompt(event){

        let isTitleDisabled = this.getTemplateViewModel().isTitleDisabled();
        if (isTitleDisabled) {
            if (event.target.value != null && event.target.value != "") {
                this.generatePermalink(event.target.value);
            }
        }
    }

    protected generatePermalink(title){

        let p = this.getTemplateViewModel().permalink();

        if (p == null || p == "") {
            let permalink = '/' + title.toLowerCase().trim()
                    .replace(/[^\w -]+/g, '')
                    .replace(/[ _]+/g, '-')
                    .replace(/-{2,}/g, '-')
                    .replace(/-$/g, "")
                    .replace(/^-/g, "")
                + '/';

            permalink = this.prefixPermalink(permalink);
            this.getTemplateViewModel().permalink(permalink);
        }
    }

    protected prefixPermalink(permalink, idTemplate = this.getTemplateViewModel().idTemplate()){
        //console.log("original permlink: " + permalink);

        if (permalink && this.getTemplateViewModel().idStatus() != 6) {

            if (permalink.startsWith("/thread")) {
                permalink = permalink.replace("/thread", "");
            }
            if (permalink.startsWith("/video")) {
                permalink = permalink.replace("/video", "");
            }

            if (idTemplate == ID_TEMPLATE_VIDEO && !permalink.startsWith("/video")) {
                permalink = "/video" + permalink;
            }
            else if (idTemplate == ID_TEMPLATE_THREAD && !permalink.startsWith("/thread")) {
                permalink = "/thread" + permalink;
            }
        }
        //console.log("new permlink: " + permalink);
        return permalink;
    }

    public setIsLockMessageVisible(value) {

        this.getTemplateViewModel().isLockMessageVisible(value);
    }

    public setIsFaqDeleteVisible(value) {

        this.getTemplateViewModel().isFaqDeleteVisible(value);
    }

    public setLockMessage(value) {

        this.getTemplateViewModel().lockMessage(value);
    }

    public setIsKickoutMessageVisible(value) {

        this.getTemplateViewModel().isKickoutMessageVisible(value);
    }

    public setArticleLockedStatus(value) {
        this.getTemplateViewModel().isArticleLocked(value);
    }

    public setArticleReviewComments(value) {
        this.sensaiPromptTemplate.setComments(value);
        this.getTemplateViewModel().articleReviewComments(value);
    }

    public setNoticeMessage(value) {
        this.getTemplateViewModel().noticeMessage(value);
    }

    public setIsNoticeVisible(value) {
        this.getTemplateViewModel().isNoticeVisible(value);
    }

    public setArticleAutoSaveError(value) {
        this.getTemplateViewModel().isArticleAutoSaveError(value);
    }

    public setKickoutkMessage(value) {

        this.getTemplateViewModel().kickoutMessage(value);
    }

    protected onCancelTakeOver(){

        this.setIsLockMessageVisible(false);
        this.caller.cancelTakeOver();
    }

    protected onTakeOver(){

        this.setIsLockMessageVisible(false);
        this.getTemplateViewModel().showAutoSaveMessage(false);
        this.caller.editArticleData(true);
    }

    protected onKickout(){

        this.setIsKickoutMessageVisible(false);
        this.caller.onKickout();
    }

    protected closeNotice() {
        this.setIsNoticeVisible(false);
        this.caller.closeNotice();
    }

    protected onChangeArticleStatus(data) {

        if(data.idStatus() != 6) {
            this.getTemplateViewModel().idPublishStatus(1);
        }
    }

    protected onChangePublishStatus(data) {

        if(data.idPublishStatus() != 1) {
            this.getTemplateViewModel().idStatus(6);
        }
    }

    protected onClickAddReviewItem(){

        this.caller.validateReviewItem();

    }

    protected onClickCancelSaveReviewItem() {

        this.hideReviewItemForm()
        this.clearReviewItemForm();
        this.caller.clearValidationErrors();
    }

    public setProductImages(images) {

        for(let i = 0; i < images.length; i++) {
            this.addProductImage(images[i]);
        }
    }

    public addProductImage(image) {

        let imageSelected = this.getTemplateViewModel().reviewItemImages().find(x => x.id == image.id);
        if (!imageSelected) {
            let images = this.getTemplateViewModel().reviewItemImages();
            images.push(image);
            this.getTemplateViewModel().reviewItemImages([]);
            this.getTemplateViewModel().reviewItemImages(images);
        }
        this.onLoadTemplate('#img_list_product_review .img-article-item', this.reorderReviewItemImages.bind(this));

    }

    public onClickDeleteProductImage(data) {

        let index = this.getTemplateViewModel().reviewItemImages().findIndex(x => x.id == data.id);
        if(index != -1) {
            this.getTemplateViewModel().reviewItemImages.splice(index, 1);
        }
        this.onLoadTemplate('#img_list_product_review .img-article-item', this.reorderReviewItemImages.bind(this));

    }

    protected makeBodyUnscrollable() {
        document.body.classList.add('is-fixed');
    }

    protected makeBodyScrollableAgain() {
        document.body.classList.remove('is-fixed');
    }

    public onClickGenerateArticleSummaries() {
        const vm = this.getTemplateViewModel();
            const factual = vm.factualSummary() && vm.factualSummary().trim() !== "";
            const simple = vm.simpleSummary() && vm.simpleSummary().trim() !== "";
            const satirical = vm.satiricalCommentary() && vm.satiricalCommentary().trim() !== "";

            // If any summary exists, confirm before regenerating
            if (factual || simple || satirical) {
                if (!confirm("Existing article summaries found. Do you want to replace them with new AI-generated summaries? This will  overwrite the existing summaries and cannot be undone.")) {
                    return;
                }
            }
        this.caller.saveArticleAiSummaries(true);
    }
    public onClickEditReviewItem(index, reviewItems) {

        this.getTemplateViewModel().reviewItemToEdit(index);
        let reviewItem = reviewItems[index];
        this.getTemplateViewModel().idReviewItem(reviewItem.id);
        this.getTemplateViewModel().reviewItemAmazonSummary(reviewItem.amazonSummary);
        this.getTemplateViewModel().reviewItemAmazonHeadline(reviewItem.amazonHeadline);
        this.getTemplateViewModel().reviewItemAmazonAward(reviewItem.amazonAward);
        this.getTemplateViewModel().reviewItemExtraVideos(reviewItem.extraVideos ? [...reviewItem.extraVideos] : []);
        this.getTemplateViewModel().reviewItemImages([...reviewItem.extraImages]);
        this.getTemplateViewModel().reviewItemRating(reviewItem.rating);
        this.getTemplateViewModel().reviewItemAmazonRating(reviewItem.amazonRating);

        this.getTemplateViewModel().reviewItemIdTag(reviewItem.idTag);

        if(reviewItem.reviewText){

            this.caller.setReviewText(reviewItem.reviewText);
        }

        if (reviewItem.tag) {

            this.getTemplateViewModel().tagImage(reviewItem.tag.details ? reviewItem.tag.details.image : null);

            if (reviewItem.tag.type)
            {
                if (reviewItem.tag.type.id != 0)
                {
                    this.filterProductTypes.setOption(reviewItem.tag.type)
                }
                else {

                    this.filterProductTypes.getTemplateViewModel().inputText(reviewItem.tag.type.name);
                    this.filterProductTypes.getTemplateViewModel().newOptionName(reviewItem.tag.type.name);
                    this.filterProductTypes.getTemplateViewModel().addNewSelected(true);

                }
            }

            if (reviewItem.tag.id != 0)
            {
                this.filterProducts.setOption(reviewItem.tag)
            }
            else {
                this.filterProducts.getTemplateViewModel().inputText(reviewItem.tag.name);
                this.filterProducts.getTemplateViewModel().newOptionName(reviewItem.tag.name);
                this.filterProducts.getTemplateViewModel().addNewSelected(true);
            }

        }

        this.getTemplateViewModel().reviewItemTagSpecifications(reviewItem.tagSpecifications ? [...reviewItem.tagSpecifications] : []);
        this.getTemplateViewModel().addedReviewItemTagSpecifications(reviewItem.addedSpecifications ? [...reviewItem.addedSpecifications] : []);
        if (reviewItem.pros) {
            let pros = [];

            reviewItem.pros.forEach( p => {
                pros.push({ data: p })
            })

            this.getTemplateViewModel().reviewItemPros(pros);
        }
        if (reviewItem.cons) {

            let cons = [];

            reviewItem.cons.forEach( c => {
                cons.push({ data: c })
            })

            this.getTemplateViewModel().reviewItemCons(cons);
        }
        if (reviewItem.keyFeatures) {

            let keyFeatures = [];

            reviewItem.keyFeatures.forEach( kf => {
                keyFeatures.push({data:kf})
            })

            this.getTemplateViewModel().reviewItemKeyFeatures(keyFeatures);
        }
        if (reviewItem.extraVideos) {

            let extraVideos = [];

            reviewItem.extraVideos.forEach( v => {
                extraVideos.push({data:v})
            })

            this.getTemplateViewModel().reviewItemExtraVideos(extraVideos);
        }
        this.showReviewItemForm();

        this.getTemplateViewModel().reviewItemSeoDescription(reviewItem.seoDescription);

        this.getTemplateViewModel().reviewItemGiveawayUrl(reviewItem.giveawayUrl);
        if (reviewItem.giveawayExpiryDate) {
            this.giveawayDatePicker.setDate(reviewItem.giveawayExpiryDate);
        }

        if (reviewItem.giveawayUrl || reviewItem.giveawayExpiryDate) {
            this.collapseGiveawaySection();
        }


        this.getTemplateViewModel().reviewItemIdAwardType(reviewItem.idAwardType);
        this.getTemplateViewModel().reviewItemAffiliateLinks(reviewItem.affiliateLinks ? [...reviewItem.affiliateLinks] : []);

        this.onLoadTemplate('#img_list_product_review .img-article-item', this.reorderReviewItemImages.bind(this));
    }

    private clearReviewItemForm() {

        this.getTemplateViewModel().reviewItemAmazonSummary(null);
        this.getTemplateViewModel().reviewItemAmazonHeadline(null);
        this.getTemplateViewModel().reviewItemAmazonAward(null);
        this.getTemplateViewModel().reviewItemExtraVideos([]);
        this.getTemplateViewModel().reviewItemImages([]);
        this.getTemplateViewModel().reviewItemRating(null);
        this.getTemplateViewModel().reviewItemAmazonRating(null);
        this.getTemplateViewModel().reviewItemIdTagType(null);
        this.getTemplateViewModel().reviewItemIdAffiliate(0);
        this.getTemplateViewModel().reviewItemTagName(null);
        this.getTemplateViewModel().reviewItemTagSpecifications([]);
        this.getTemplateViewModel().addedReviewItemTagSpecifications([]);
        this.getTemplateViewModel().reviewItemPros([]);
        this.getTemplateViewModel().reviewItemCons([]);
        this.getTemplateViewModel().reviewItemKeyFeatures([]);
        this.getTemplateViewModel().reviewItemSeoDescription(null);
        this.getTemplateViewModel().tagImage(null);
        this.caller.setReviewText(null);
        this.getTemplateViewModel().isGiveawaySectionCollapsed(false);
        this.getTemplateViewModel().reviewItemGiveawayUrl(null);
        this.getTemplateViewModel().reviewItemGiveawayExpiryDate(null);
        this.giveawayDatePicker.getTemplateViewModel().singleDatePicker(null);
        this.getTemplateViewModel().reviewItemTagTypeName(null);
        this.getTemplateViewModel().reviewItemIdAwardType(null);
        this.getTemplateViewModel().reviewItemAffiliateLinks([]);
        this.getTemplateViewModel().reviewItemIdTag(null);
        this.getTemplateViewModel().idReviewItem(null);
        this.getTemplateViewModel().reviewItemToEdit(null);
        this.filterProducts.clearEverything();
        this.filterProductTypes.clearEverything();
        this.filterAffiliates.clearEverything();
        this.filterAffiliates.setPlaceholder("Affiliate Partner");

    }

    protected onClickAddSpecification() {

        let spec = {
            label: "",
            data: "",
            dataType: 'text'
        }

        this.getTemplateViewModel().addedReviewItemTagSpecifications.push(spec);
    }

    protected onClickDeleteSpecification(data, index) {

        this.getTemplateViewModel().reviewItemTagSpecifications.splice(index(), 1);
    }
    protected onClickDeleteAddedSpecification(data, index) {

        this.getTemplateViewModel().addedReviewItemTagSpecifications.splice(index(), 1);
    }

    protected onClickDeleteAffiliateLinks(data, index) {

        this.getTemplateViewModel().reviewItemAffiliateLinks.splice(index(), 1);
    }

    protected onClickAddReviewItemVideo() {

        this.getTemplateViewModel().reviewItemExtraVideos.push({ data: "" }  );
    }

    protected onClickDeleteReviewItemVideo(data, index) {

        this.getTemplateViewModel().reviewItemExtraVideos.splice(index(), 1);
    }

    protected onClickAddAffiliateLink() {

        let defaultPlaceholder = "Affiliate Partner";
        let noPartnerSelected = "No partner selected";

        if ( this.filterAffiliates.getTemplateViewModel().addNewSelected() ) {

            let optionName = this.filterAffiliates.getTemplateViewModel().newOptionName()

            if (optionName != "") {
                this.filterAffiliates.setPlaceholder(defaultPlaceholder);
                this.getTemplateViewModel().reviewItemAffiliateLinks.push({id: null, type: optionName, value: ""});
            } else {

                this.filterAffiliates.setPlaceholder(noPartnerSelected);
            }

        }
        else if ( this.filterAffiliates.getTemplateViewModel().optionObj() )
        {
            let affiliate = this.filterAffiliates.getTemplateViewModel().optionObj();
            this.filterAffiliates.setPlaceholder(defaultPlaceholder);
            this.getTemplateViewModel().reviewItemAffiliateLinks.push({id: affiliate.id, type: affiliate.name, value: ""});
        }
        else {

            this.filterAffiliates.setPlaceholder(noPartnerSelected);
        }

    }

    protected onClickAddKeyFeature() {

        this.getTemplateViewModel().reviewItemKeyFeatures.push({ data:"" } );
    }

    protected onClickDeleteKeyFeature(data) {

        let index = this.getTemplateViewModel().reviewItemKeyFeatures().findIndex(element => (element == data));
        if (index > -1) {
            this.getTemplateViewModel().reviewItemKeyFeatures.splice(index, 1);
        }
    }

    protected onClickAddPro() {

        this.getTemplateViewModel().reviewItemPros.push({ data: "" } );
    }

    protected onClickDeletePro(data, index) {

        this.getTemplateViewModel().reviewItemPros.splice(index(), 1);
    }

    protected onClickAddCon() {

        this.getTemplateViewModel().reviewItemCons.push({ data: "" } );
    }

    protected onClickDeleteCon(data, index){

        this.getTemplateViewModel().reviewItemCons.splice(index(), 1);
    }

    public getPinnedTag(){

        return this.filterPinnedTag.getOptionObj();
    }

    public getFeaturedTag(){
        if(this.getTemplateViewModel().featuredTags()){
            return this.getTemplateViewModel().featuredTags().tagObject;
        }else{
            return false;
        }
    }
    public setPinnedTag(pinnedTagObj){

        if(pinnedTagObj){

            this.getTemplateViewModel().isFeaturedTagActive(true);
        }
        this.filterPinnedTag.setOption(pinnedTagObj);
    }

    public onChangeSelectTag() {

        let productsViewModel = this.filterProducts.getTemplateViewModel();
        let typesViewModel = this.filterProductTypes.getTemplateViewModel();
        let productTag = ! productsViewModel.addNewSelected() ?  productsViewModel.optionObj() : null;
        let tagType = ! typesViewModel.addNewSelected() ? typesViewModel.optionObj() : null;
        let specValues = productTag && productTag.specifications_extra ? JSON.parse( JSON.stringify(productTag.specifications_extra)) : [];

        let tagExtra = productTag && productTag.details ? JSON.parse( JSON.stringify(productTag.details)) : [];

        let seoDescription = tagExtra.shortDescription ? tagExtra.shortDescription : null;
        let productText = tagExtra.description ? tagExtra.description : null;
        let affiliateLinks = tagExtra.affiliateLinks ? tagExtra.affiliateLinks : [];
        let image = tagExtra.image ? tagExtra.image : null;

        this.getTemplateViewModel().reviewItemSeoDescription(seoDescription);
        this.getTemplateViewModel().reviewItemAffiliateLinks(affiliateLinks);

        this.caller.setReviewText(productText);

        if(image){

            this.addProductImage(image);
        }

        /*
            Here, the plan is, if you have a type and a product, get specifications extra from tag type field values extra
            otherwise if you only have a type, query for the fields only with

         */

        let specs = [], spec;

        if ( tagType && typeof tagType.fields != "undefined" && tagType.fields.length > 0 ) {

            tagType.fields.forEach( field => {

                spec = {fieldId: field.id, label: field.label, data: null,  dataType: field.dataType};

                for (let i=0; i< specValues.length; i++ ) {

                    if (specValues[i].idField == field.id ) {

                        spec['data'] = specValues[i].value;
                        specValues.splice(i,1);
                        break;
                    }
                }
                specs.push(spec);
            } )
        }
        if (productTag && productTag.details && productTag.details.image) {

            this.getTemplateViewModel().tagImage(productTag.details.image);
        }

        this.getTemplateViewModel().reviewItemTagSpecifications(specs)
    }

    public addReviewItem(response) {

        let reviewItem = response.data;
        if (response.valid) {

            reviewItem.award = {};
            reviewItem.tagAwardClass = '';
            let award = this.getTemplateViewModel().reviewItemAward_options().find(element => (element.id == reviewItem.idAwardType));
            if (award) {
                reviewItem.award = award;
                reviewItem.tagAwardClass = reviewItem.award ? 'i-' + reviewItem.award.name.replace(' ', '-').toLowerCase() : "";
            }
            reviewItem.tag = {
                id: reviewItem.idTag,
                idType: reviewItem.idTagType,
                name: reviewItem.tagName,
                type: {id: reviewItem.idTagType, name: reviewItem.tagTypeName},
                details: {image: this.getTemplateViewModel().tagImage()}
            }

            if (this.getTemplateViewModel().selectedTab() == Tab.ARTICLE) {
                if (this.getTemplateViewModel().idTemplate() == 5) {
                    this.productReview.setReviewItems([]);
                    this.getTemplateViewModel().reviewItemToEdit(null);
                }
                this.productReview.addReviewItem(reviewItem, this.getTemplateViewModel().reviewItemToEdit());
            } else if (this.getTemplateViewModel().selectedTab() == Tab.SANDBOX) {
                if (this.getTemplateViewModel().idTemplate() == 5) {
                    this.productReviewSandbox.setReviewItems([]);
                    this.getTemplateViewModel().reviewItemToEdit(null);
                }
                this.productReviewSandbox.addReviewItem(reviewItem, this.getTemplateViewModel().reviewItemToEdit());
            }else if (this.getTemplateViewModel().selectedTab() == Tab.REPUBLISH) {
                if (this.getTemplateViewModel().idTemplate() == 5) {
                    this.productReviewRepublish.setReviewItems([]);
                    this.getTemplateViewModel().reviewItemToEdit(null);
                }
                this.productReviewRepublish.addReviewItem(reviewItem, this.getTemplateViewModel().reviewItemToEdit());
            }
            this.hideReviewItemForm();

            this.caller.save_recovery('applyProduct');
        }
    }

    private onLoadTemplate(dragItemSelector, sortFunction) {

        var parent = this;
        var dragSrcEl = null;

        function handleDragStart(e) {
            // Target (this) element is the source node.
            dragSrcEl = this;

            //e.dataTransfer.setData('text', 'foo');
            e.dataTransfer.effectAllowed = 'move';
            e.dataTransfer.setData('text/html', this.outerHTML);

            this.classList.add('dragElem');
        }
        function handleDragOver(e) {
            if (e.preventDefault) {
                e.preventDefault(); // Necessary. Allows us to drop.
            }

            let huit_neuf_this = this;
            //var dragItems = document.querySelectorAll('[draggable=true]');
            var dragItems = document.querySelectorAll(dragItemSelector);
            let index = 0;
            let found = false;
            for (let item of dragItems) {
                if (dragSrcEl == item) {

                    huit_neuf_this.classList.add('after');
                    huit_neuf_this.classList.remove('before');
                    found = true;
                    break;
                }
                if (this == item) {

                    huit_neuf_this.classList.add('before');
                    huit_neuf_this.classList.remove('after');
                    found = true;
                    break;
                }
            }

            if (!found) {
                this.classList.add("before");
            }

            e.dataTransfer.dropEffect = 'move';  // See the section on the DataTransfer object.

            return false;
        }

        function handleDragEnter(e) {
            // this / e.target is the current hover target.
            //this.classList.add('over');

            //this.classList.add('before');
        }

        function handleDragLeave(e) {
            this.classList.remove('before');
            this.classList.remove('after');  // this / e.target is previous target element.
        }

        function handleDrop(e) {
            // this/e.target is current target element.

            if (e.stopPropagation) {
                e.stopPropagation(); // Stops some browsers from redirecting.
            }

            if (e.preventDefault) {
                e.preventDefault(); // Necessary. Allows us to drop.
            }

            // Don't do anything if dropping the same column we're dragging.
            if (dragSrcEl != this) {


                var dropHTML = e.dataTransfer.getData('text/html');

                if (dropHTML.includes("<li")) {
                    for (let child of this.parentNode.childNodes) {

                        if (child == dragSrcEl) {
                            this.parentNode.removeChild(dragSrcEl);
                        }
                    }

                    if (this.classList.contains("before")) {
                        this.insertAdjacentHTML('beforebegin', dropHTML);
                        var dropElem = this.previousElementSibling;
                    } else {
                        this.insertAdjacentHTML('afterend', dropHTML);
                        var dropElem = this.nextElementSibling;
                    }

                    addDnDHandlers(dropElem);
                    //this.reorderImages();
                }



            }
            sortFunction(parent);
            this.classList.remove('before');
            this.classList.remove('after');
            return false;
        }

        function handleDragEnd(e) {
            // this/e.target is the source node.
            this.classList.remove('before');
            this.classList.remove('after');

            [].forEach.call(cols, function (col) {
                col.classList.remove('before');
                col.classList.remove('after');
            });
        }

        function addDnDHandlers(elem) {
            elem.addEventListener('dragstart', handleDragStart, false);
            elem.addEventListener('dragenter', handleDragEnter, false)
            elem.addEventListener('dragover', handleDragOver, false);
            elem.addEventListener('dragleave', handleDragLeave, false);
            elem.addEventListener('drop', handleDrop, false);
            elem.addEventListener('dragend', handleDragEnd, false);

        }

        //var dragItems = document.querySelectorAll('[draggable=true]');
        var cols = document.querySelectorAll(dragItemSelector);
        [].forEach.call(cols, addDnDHandlers);
    }

    protected reorderReviewItemImages(huit_neuf_this) {
        let images = huit_neuf_this.getTemplateViewModel().reviewItemImages();
        let selector = '#img_list_product_review .img-article-item';
        let liElements = document.querySelectorAll(selector);

        //reorder the images based on HTML order
        let newImages = []
        for (let element of liElements) {

            let idElement = element.id;
            let image = images.find(i => i.id === Number(element.id));
            if (image) {
                newImages.push(image);
            }
        }
        huit_neuf_this.getTemplateViewModel().reviewItemImages([]);
        huit_neuf_this.getTemplateViewModel().reviewItemImages(newImages);
        huit_neuf_this.onLoadTemplate(selector, huit_neuf_this.reorderReviewItemImages.bind(huit_neuf_this));
    }

    private checkIfReviewItemsNeedAnUpdate( sourceOfReversal ) {

        let reviewItems;
        if ( sourceOfReversal == "sandbox") {

            reviewItems = this.productReviewSandbox.getReviewItems();
        }
        else if ( sourceOfReversal == "revision") {

            let index = this.getTemplateViewModel().selectedRevisionIndex();
            reviewItems = this.getTemplateViewModel().revisions()[index].content.reviewItems;
        }
        else if ( sourceOfReversal == "recovery") {

            reviewItems =this.recoveryReviewSection.getReviewItems();
        }

        //HERE set reviewitems based on the source of the call
        //Can be either sandbox, or revision
        if (confirm("Are you sure you want to overwrite the article content? You will lose any unsaved changes.")) {

            this.getTemplateViewModel().sourceOfReversal(sourceOfReversal);
            this.getTemplateViewModel().backupReviewItems(reviewItems);
            this.caller.checkForReviewItemsUpdate(sourceOfReversal);
        }
    }

    private copyContentReviewsItem(tab) {

        this.productReviewSandbox.markReviewItemsAsToDelete();
        let reviewItems = this.productReview.getReviewItems();
        // make a deep copy of content review items before assigning them to sandbox.
        const clone = rfdc();

        let dp = clone(reviewItems);

        dp.forEach((e) => e.id = null);

        if(tab == 'sandbox'){
            this.productReviewSandbox.setReviewItems(dp);
        }

        if(tab == 'republish'){
            this.productReviewRepublish.setReviewItems(dp);
        }

    }

    private copyDirectoryItems(tab){

        let items = this.articleDirectory.getDirectoryItems();
        items = ko.toJS(items); //convert observable array ot simple array

        if(tab == 'sandbox'){
            this.sandboxDirectory.setSandboxDirectoryItems(items);
        }

        if(tab == 'republish'){
            this.republishDirectory.setSandboxDirectoryItems(items);
        }

    }

    public getReviewItems() {

        return this.productReview.getReviewItems();
    }

    public getSandboxReviewItems() {

        return this.productReviewSandbox.getReviewItems();
    }

    public getRepublishReviewItems() {

        return this.productReviewRepublish.getReviewItems();
    }

    public getDirectoryItems() {

        return this.articleDirectory.getDirectoryItems();
    }

    public getSandboxDirectoryItems() {

        return this.sandboxDirectory.getDirectoryItems();
    }

    public getRepublishDirectoryItems() {

        return this.republishDirectory.getDirectoryItems();
    }

    public setRecoveryReviewItems(recoveryReviewItems) {

        this.recoveryReviewSection.setReviewItems(recoveryReviewItems);
    }

    public setRecoverySandboxReviewItems(sandboxRecoveryReviewItems) {

        this.recoverySandboxReviewSection.setReviewItems(sandboxRecoveryReviewItems);
    }

    public setRecoveryRepublishReviewItems(republishRecoveryReviewItems) {

        this.recoveryRepublishReviewSection.setReviewItems(republishRecoveryReviewItems);
    }

    public getReviewItemsToDelete() {

        return this.productReview.getReviewItemsToDelete();
    }

    public getSandboxReviewItemsToDelete() {

        return this.productReviewSandbox.getReviewItemsToDelete();
    }

    public getRepublishReviewItemsToDelete() {

        return this.productReviewRepublish.getReviewItemsToDelete();
    }

    public clearSandboxSection() {

        this.productReviewSandbox.setReviewItems([]);
        this.sandboxDirectory.setDirectoryItems([]);
        this.caller.setSandboxIntroText("");
        this.caller.setSandboxContent("");
        this.getTemplateViewModel().selectedTab('article');
        this.checkIfSandboxHasContent();
        this.checkIfRepublishHasContent();
    }

    public clearRepublishSection() {

       this.filterUser_republish_author.clearData();
       this.filterUser_republish_SrEditor.clearData();
       this.filterUser_republish_JrEditor.clearData();
       this.paymentCategoryFilter.setSelectedOption(null);
       this.getTemplateViewModel().choosenPaymentTypeRepublish(null);
       this.getTemplateViewModel().amountAuthor(null);
       this.getTemplateViewModel().percentageAuthor(null);
       this.getTemplateViewModel().percentageEditor(null);
       this.getTemplateViewModel().idRepublishStatus(1);
       this.getTemplateViewModel().idPreviousRepublishStatus(1);
       this.productReviewRepublish.setReviewItems([]);
       this.republishDirectory.setDirectoryItems([]);
       this.caller.setRepublishIntroText("");
       this.caller.setRepublishContent("");
       this.getTemplateViewModel().selectedTab('article');
       this.getTemplateViewModel().showNewRepublish(false);
       this.checkIfSandboxHasContent();
       this.checkIfRepublishHasContent();
    }

    private onClickConfirmFaqDelete() {

        let index = this.getTemplateViewModel().faqToDelete();
        this.setIsFaqDeleteVisible(false);
        let faqs = this.getTemplateViewModel().faqs();

        if (index > -1) {
            this.getTemplateViewModel().faqToDelete(null);
            this.getTemplateViewModel().faqsToDelete.push(faqs[index].id);
            this.getTemplateViewModel().faqs.splice(index, 1);
        }
    }

    private onClickCancelFaqDelete() {

        this.setIsFaqDeleteVisible(false);

    }

    public setSandboxIntroTextEditorStatus(result) {
        this.caller.setSandboxIntroTextEditorStatus(result)
    }

    public setIntroTextEditorStatus(result) {
        this.caller.setIntroTextEditorStatus(result);
    }

    public setSandboxEditorStatus(result) {
        this.caller.setSandboxEditorStatus(result)
    }

    public setContentEditorStatus(result) {
        this.caller.setContentEditorStatus(result);
    }

    public setRepublishEditorStatus(result) {
        this.caller.setRepublishEditorStatus(result);
    }

    private createEasternTimeZoneDateTime(date?: Date): Date {

        if (!date) {
            date = new Date();
        }

        date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
        //checks if DST is currently being observed, adjusts offset accordingly
        let easternTimeOffset = this.isDstObserved(date) ? -240 : -300;
        date.setMinutes(date.getMinutes() + easternTimeOffset);

        return date;
    }

    public isDstObserved (date?: Date) {
        let jan = new Date(date.getFullYear(), 0, 1);
        let jul = new Date(date.getFullYear(), 6, 1);
        let stdTimezoneOffset = Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());

        return date.getTimezoneOffset() < stdTimezoneOffset;
    }


    public getFormattedEasternTimeZoneDateTime(_date? : string): any {
        let dateObj: Date | null;
        if (_date) {
            try{
                dateObj = new Date(_date);
            }catch(e){
                dateObj = null;
            }
        }

        const date = this.createEasternTimeZoneDateTime(dateObj);

        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const hour = date.getHours();
        const minutes = date.getMinutes();

        return year + '/' + this.padInteger(month,2) + '/' + this.padInteger(day,2) + ' ' + this.padInteger(hour,2) + ':' + this.padInteger(minutes,2);
    }

    private padInteger(number: number, size: number)
    {
        let s = number+"";
        while (s.length < size) s = "0" + s;
        return s;
    }


    public setEasternTimeOnScheduled(): void {
        this.scheduleDatePicker.setDate(this.getFormattedEasternTimeZoneDateTime());
    }

    protected onChangePoll(keyword : string){

        this.caller.searchPoll(keyword);
    }

    protected onSelectedPoll(){
        const selectedPollName = this.getTemplateViewModel().pollName();
        const selectedPoll = this.getTemplateViewModel().poll_options().find(poll => poll.name === selectedPollName);
        if(selectedPoll){
            this.getTemplateViewModel().idPoll(selectedPoll.id);
            this.getTemplateViewModel().pollName(selectedPoll.name);
            this.getTemplateViewModel().poll_options([]);
        }
    }

    public setPoll(poll){

        if(poll != null){
            this.getTemplateViewModel().idPoll(poll.id);
            this.getTemplateViewModel().pollName(poll.name);
        }
    }

    public openComparePopup(){

        document.getElementById('compare-popup').classList.add('is-visible');
        document.body.classList.add('is-fixed');

    }

    public addClassToComparePopupHeader(className){
        document.getElementById('compare-revisions').classList.add(className)

    }

    public onClickCloseComparePopUp(){

        document.getElementById('compare-popup').classList.remove('is-visible');
        document.getElementById('compare-revisions').classList.remove('is-nolist', 'is-labelsandbox', 'is-labelrecoverysandbox', 'is-revoverycontent');
        document.body.classList.remove('is-fixed');
    }

    public hideSideListOnComparePopup(){

        document.getElementById('compare-revisions').classList.add('is-nolist');
    }

    public setVersionDiffResult(result): void{

        this.getTemplateViewModel().versionDiffResult(result);
    }

    public compareTwoVersions(){

        let oldVersion = this.getTemplateViewModel().oldVersion();
        let newVersion = this.getTemplateViewModel().newVersion();

        if (oldVersion && newVersion) {
            let newVersionContent = '';
            if(newVersion.content.content != undefined){
                newVersionContent = newVersion.content.content
            }
            let oldVersionContent = '';
            if(oldVersion.content.content != undefined) {
                oldVersionContent = oldVersion.content.content;
            }
            this.caller.diffVersionText(oldVersionContent,  newVersionContent);
        }

    }

    public onClickCompareRevision(){

        this.openComparePopup();
        let revisions = this.getTemplateViewModel().revisions();
        this.setRevisions(revisions);
        if(revisions.length < 3) {
            this.hideSideListOnComparePopup();
        }
    }

    public onClickShowRevision(revision){

        this.onClickCloseComparePopUp();
        this.onClickRevision(revision, 0);
    }

    public onClickCompareRevisionUpdate(data){


        if(data.checked == 'old'){
            this.getTemplateViewModel().oldVersion(data);
        }
        if(data.checked == 'new'){
            this.getTemplateViewModel().newVersion(data);
        }

        let revisions = this.getTemplateViewModel().revisions();
        let index =  revisions.findIndex(element => (element.id == data.id));
        if(index > -1) {

            let lastChecked = data.checked;
            let lastNewChecked = this.getTemplateViewModel().newVersion().checked;
            let lastOldChecked = this.getTemplateViewModel().oldVersion().checked;

            //reset the opposite disable field and empty checked value
            revisions.forEach(revision =>{
                if(lastChecked == 'new') {
                    revision.isOldDisable = false;
                }
                if(lastChecked == 'old') {
                    revision.isNewDisable = false;
                }
                revision.checked = '';
            });

            // put back the checked value of selected one
            data.checked = lastChecked;

            // disable/enable the radio selections
            if (lastChecked == 'old') {
                this.getTemplateViewModel().newVersion().checked = lastNewChecked;
                for (let i = index; i < revisions.length; i++) {
                    revisions[i].isNewDisable = true;
                }
            }
            if (lastChecked == 'new') {
                this.getTemplateViewModel().oldVersion().checked = lastOldChecked;
                for (let i = 0; i <= index; i++) {
                    revisions[i].isOldDisable = true;
                }
            }
        }
        this.getTemplateViewModel().revisions([]);
        this.getTemplateViewModel().revisions(revisions);
        this.compareTwoVersions();

    }

    public setRevisions(revisions): void{

        for(let i = 0 ; i < revisions.length; i++){

            if(i == 0){
                revisions[i].checked = 'new';
                revisions[i].isOldDisable = true;
                this.getTemplateViewModel().newVersion(revisions[0]);
            }else if(i == 1){
                revisions[i].checked = 'old';
                revisions[i].isNewDisable = true;
                this.getTemplateViewModel().oldVersion(revisions[1]);
            }else {
                revisions[i].checked = false;
                revisions[i].isNewDisable = true;
            }
        }
        this.getTemplateViewModel().revisions(revisions);
        this.compareTwoVersions();
    }

    public onClickCompareRecovery(type){

        let revisions = this.getTemplateViewModel().revisions();
        let recovery = this.getTemplateViewModel().recovery();
        let sandboxRecovery = this.getTemplateViewModel().sandboxRecovery();
        let republishRecovery = this.getTemplateViewModel().republishRecovery();

        let newVersion = {'content': recovery};
        let oldVersion = {'content': revisions ? revisions[0].content : ''};
        let className = 'is-revoverycontent';

        if(type == 'sandbox'){

            newVersion = {'content': sandboxRecovery};
            oldVersion = {'content': {'content' : this.getSandboxContent()}};
            className = 'is-labelrecoverysandbox';

        }else if(type == 'republish'){

            newVersion = {'content': republishRecovery};
            oldVersion = {'content': {'content' : this.getRepublishContent()}};
            className = 'is-labelrecoverysandbox';
        }

        if(newVersion && newVersion.content && oldVersion && oldVersion.content) {

            this.getTemplateViewModel().newVersion(newVersion);
            this.getTemplateViewModel().oldVersion(oldVersion);
            this.compareTwoVersions();
            this.openComparePopup();
            this.hideSideListOnComparePopup();
            this.addClassToComparePopupHeader(className);
        }
    }

    public getArticleContent(){

        let content = this.caller.getArticleContent();
        return content;
    }

    public getArticleIntroText(){

        let content = this.caller.getArticleIntroText();
        return content;
    }

    public getSandboxContent(){

        let content = this.caller.getSandboxInViewContent();
        return content;
    }

    public getSandboxIntroText(){

        let content = this.caller.getSandboxIntroText();
        return content;
    }

    public getRepublishContent(){

        let content = this.caller.getRepublishInViewContent();
        return content;
    }

    public getRepublishIntroText(){

        let content = this.caller.getRepublishIntroText();
        return content;
    }

    public onClickCompareSandbox(type){

        let revisions = this.getTemplateViewModel().revisions();

        let content = '';
        let className = 'is-labelsandbox'
        if(type == 'sandbox'){
            content = this.getSandboxContent();
        }else{
            content = this.getRepublishContent();
            className = 'is-labelrepulish'
        }

        if(revisions.length > 0) {

            this.getTemplateViewModel().newVersion({'content': {'content': content }});
            this.getTemplateViewModel().oldVersion(revisions[0]);
            this.compareTwoVersions();
            this.openComparePopup();
            this.hideSideListOnComparePopup();
            this.addClassToComparePopupHeader(className)
        }
    }

    public setIsSandboxContent(data) {

        this.getTemplateViewModel().isSandboxContent(data);
    }

    public setUserPreferences(userPreferences): void {

        //check the value of spellcheck, if userPreference length is 0 (meaning no saved preferences) then use default of spellcheck on
        //There should be no case where user has saved preference without spellcheck option
        if (userPreferences == null || userPreferences['spellcheck'] || userPreferences.length === 0) {

            const script = document.createElement('script');
            script.src = "https://svc.webspellchecker.net/spellcheck31/wscbundle/wscbundle.js"
            document.body.appendChild(script);
        }
    }

    public setTemplate(template): void{

        this.getTemplateViewModel().template(template);
    }

    public setIsFeaturedImageHidden(isFeaturedImageHidden): void {

        this.getTemplateViewModel().isFeaturedImageHidden(isFeaturedImageHidden);
    }

    public setIsCommentsDisabled(isCommentsDisabled): void {

        this.getTemplateViewModel().isCommentsDisabled(isCommentsDisabled);
    }

    public setIsCommentsPaused(isCommentsPaused): void {

        this.getTemplateViewModel().isCommentsPaused(isCommentsPaused);
    }

    public setIsRatingEnabled(isRatingEnabled): void {

        this.getTemplateViewModel().isRatingEnabled(isRatingEnabled);
    }

    public setIsTitleDisabled(isTitleDisabled): void {

        this.getTemplateViewModel().isTitleDisabled(isTitleDisabled);
    }

    public setIsReadNextDisabled(isReadNextDisabled): void {

        this.getTemplateViewModel().isReadNextDisabled(isReadNextDisabled);
    }

    public setIsSidebarHidden(isSidebarHidden): void {

        this.getTemplateViewModel().isSidebarHidden(isSidebarHidden);
    }

    public setIsDisplayCardQuickLinksShown(isDisplayCardQuickLinksShown): void {

        this.getTemplateViewModel().isDisplayCardQuickLinksShown(isDisplayCardQuickLinksShown);
    }

    public setIsDisplayCardQuickLinksMobileShown(isDisplayCardQuickLinksMobileShown): void {

        this.getTemplateViewModel().isDisplayCardQuickLinksMobileShown(isDisplayCardQuickLinksMobileShown);
    }

    public setIsVersusStyle(value){
        this.getTemplateViewModel().isVersusStyle(value);
    }
    public setVersusTemplateDefaults():void{
        this.setIsAmpDisabled(false);
        this.setIsCommentsDisabled(true);
        this.setIsVersusStyle(true);
        this.setIsFeaturedTagActive(true);
        this.setIsSidebarHidden(false);
        this.setIsDisplayCardQuickLinksMobileShown(false);
        this.setIsTitleDisabled(false);

        if ([4, 20, 29].indexOf(this.caller.getIdBrand()) !== -1) {
            this.setIsSponsored(true);
        }
        this.imageWidgetForFeaturedImage.setIsFeaturedTagActive(this.getTemplateViewModel().isFeaturedTagActive());
        //let featuredTag = {"block":[],"tagObject": [{"id":412467,"name": "Placeholder Tag #1"},{"id":413404, "name":"Placeholder Tag #2"}]}

        if(this.getTemplateViewModel().featuredTags() == null ){

            this.getTemplateViewModel().featuredSectionValue("featuredTag")
            this.getTemplateViewModel().chosenFeaturedSectionValue("featuredTag")

            let featuredTags = this.getDefaultFeaturedTags();
            let defaultFeaturedImage = this.getDefaultFeaturedImage();

            this.getTemplateViewModel().featuredTags([]);
            this.getTemplateViewModel().featuredTags(featuredTags);
            this.imageWidgetForFeaturedImage.setImage(defaultFeaturedImage);
            this.getTemplateViewModel().featuredImage(defaultFeaturedImage);
        }
        this.setIsPromptAuthorVisible(true);
        this.setIsExcerptVisible(true);
    }
    public setSubContentTemplateDefaults(): void {
        this.setIsAdHidden(false);
        this.setIsCommentsDisabled(true);
        this.setIsReadNextDisabled(false);
        this.setIsDisplayCardQuickLinksShown(false);
        this.setTableOfContents(false);
        this.setIsAmpDisabled(false);
        this.setIsSponsored(true);
        this.setIsSidebarHidden(true);
        this.setIsDisplayCardQuickLinksMobileShown(false);
        this.setIsSubContent(true);
        this.setIsTitleDisabled(false);
        this.setIsPromptAuthorVisible(true);
        this.setIsExcerptVisible(true);
    }
    public setCollectionTemplateDefaults(): void {
        this.setIsAdHidden(false);
        this.setIsCommentsDisabled(false);
        this.setIsReadNextDisabled(false);
        this.setIsDisplayCardQuickLinksShown(false);
        this.setTableOfContents(false);
        this.setIsAmpDisabled(false);
        this.setIsSponsored(true);
        this.setIsSidebarHidden(true);
        this.setIsDisplayCardQuickLinksMobileShown(true);
        this.setIsTitleDisabled(false);
        this.setIsPromptAuthorVisible(true);
        this.setIsExcerptVisible(true);
    }
    public setBuyersGuideLightTemplateDefaults(): void {
        this.setIsAdHidden(false);
        this.setIsCommentsDisabled(true);
        this.setIsReadNextDisabled(false);
        this.setIsDisplayCardQuickLinksShown(true);
        this.setTableOfContents(false);
        this.setIsAmpDisabled(false);
        this.setIsTitleDisabled(false);

        if ([4, 20, 29].indexOf(this.caller.getIdBrand()) !== -1) {

            this.setIsSponsored(true);
        }
        this.setIsSidebarHidden(false);
        this.setIsDisplayCardQuickLinksMobileShown(false);
        this.setIsPromptAuthorVisible(true);
        this.setIsExcerptVisible(true);
    }

    public setDealsTemplateDefaults(){
        this.setIsAdHidden(true);
        this.setIsCommentsDisabled(true);
        this.setIsAmpDisabled(false);
        this.setIsReadNextDisabled(false);
        this.setIsDisplayCardQuickLinksShown(false);
        this.setTableOfContents(false);
        this.setIsTitleDisabled(false);

        if ([4, 20, 29].indexOf(this.caller.getIdBrand()) !== -1) {
            this.setIsSponsored(true);
        }
        this.setIsSidebarHidden(false);
        this.setIsDisplayCardQuickLinksMobileShown(false);
        this.setIsPromptAuthorVisible(true);
        this.setIsExcerptVisible(true);
    }

    public resetTemplateDefaults(idTemplate): void {
        if (idTemplate != ID_TEMPLATE_VIDEO) {
            //this.resetVideoTemplateDefaults();
        }
        if (idTemplate != ID_TEMPLATE_THREAD) {
            this.resetThreadTemplateDefaults();
        }

        this.setIsAdHidden(false);
        this.setIsCommentsDisabled(false);
        this.setIsReadNextDisabled(false);
        this.setIsDisplayCardQuickLinksShown(false);
        this.setIsSidebarHidden(false);
        this.setIsDisplayCardQuickLinksMobileShown(false);
        this.setTableOfContents(idTemplate == 7)
        this.setIsAmpDisabled(false);
        this.setIsSponsored(idTemplate == 5 || idTemplate == 6);
        this.setIsSidebarHidden(idTemplate == 12);
        this.setIsDisplayCardQuickLinksMobileShown(idTemplate == 12);
        this.setIsSponsored(idTemplate == 12);
        this.setIsSubContent(false);
        this.setIsTitleDisabled(false);
        this.setIsPromptAuthorVisible(true);
        this.setIsExcerptVisible(true);

    }

    public onClickDisplayOptionToggle() {
        document.getElementsByClassName('w-form-dropdown-menu')[0].classList.toggle('is-visible');
    }

    public addDisplayAuthor(): void {

        this.display_authors.addUser(
            this.filterUser_display_author.getUserObject()
        );

        this.filterUser_display_author.clearData();
    }

    public onClickTogglePinnedTagsForm(value){

        this.getTemplateViewModel().isPinnedTagsFormVisible(value);

    }

    public onChangeFeaturedSection(){

        let message : string

        let featuredImage = this.imageWidgetForFeaturedImage.getImage();
        let featuredTag = this.getTemplateViewModel().featuredTags();
        let featuredSectionValue = this.getTemplateViewModel().featuredSectionValue();
        let featuredVideo = this.getTemplateViewModel().featuredVideo();
        let featuredEmbed = this.getTemplateViewModel().featuredEmbed();
        let chosenFeaturedSectionValue = this.getTemplateViewModel().chosenFeaturedSectionValue();

        if(featuredImage || featuredTag || featuredVideo || featuredEmbed){
            message = "Switching featured content will clear the existing selections. Are you sure you want to continue?";
            if(confirm(message)){
                this.clearFeaturedSection(featuredSectionValue);
            }else {
                this.getTemplateViewModel().featuredSectionValue(chosenFeaturedSectionValue)
            }
        }else{
            this.clearFeaturedSection(featuredSectionValue);
        }
    }

    private clearFeaturedSection(featuredSectionValue) {
        this.getTemplateViewModel().isFeaturedTagActive(featuredSectionValue === "featuredTag");
        this.getTemplateViewModel().isFeaturedVideoActive(featuredSectionValue === "featuredVideo");
        this.getTemplateViewModel().isFeaturedEmbedActive(false);
        this.getTemplateViewModel().isFeaturedImageActive(featuredSectionValue === "featuredImage");

        this.imageWidgetForFeaturedImage.setIsFeaturedVideoActive(featuredSectionValue === "featuredVideo");
        this.imageWidgetForFeaturedImage.setIsFeaturedEmbedActive(false);
        this.imageWidgetForFeaturedImage.setIsFeaturedTagActive(this.getTemplateViewModel().isFeaturedTagActive());
        this.getTemplateViewModel().chosenFeaturedSectionValue(featuredSectionValue);

        this.imageWidgetForFeaturedImage.clearImage();
        this.getTemplateViewModel().featuredImage(null)

        this.getTemplateViewModel().featuredTags(null);
        this.getTemplateViewModel().featuredVideo(null);
        this.getTemplateViewModel().featuredEmbed(null);
        this.getTemplateViewModel().isVersusStyle(false);
    }


    public setIsFeaturedTagActive(value){
        this.getTemplateViewModel().isFeaturedTagActive(value);
    }
    public onChangeUpdateLatestRepublishDate(latest_republish): any {
        //Toggle value on change
        if(this.getTemplateViewModel().updateLatestRepublishDateIsChecked()){
            this.getTemplateViewModel().latestRepublishId(latest_republish.id)
        }else{
            this.getTemplateViewModel().latestRepublishId('')
        }

    }

    public addImage(target, viewMode, selectedImages): any {
        this.showImagePicker(viewMode, target, selectedImages);
    }

    public viewImage(target){
        let element = document.getElementById(target);
        element.classList.add("is-viewing");

    }

    public closeImage(target){
        let element = document.getElementById(target);
        element.classList.remove("is-viewing");

    }

    public removeImage(target){

        if(target == 'thumbnail_image'){
            this.imageWidgetForThumbnailImage.clearImage()
        }


        if(target == 'alternate_image'){
            this.imageWidgetForAlternateImage.clearImage()
        }

        if(target == 'featured_image' || target == 'featured_image_embed'){
            this.imageWidgetForFeaturedImage.clearImage()
            if(target == "featured_image") this.getTemplateViewModel().featuredImage(null)
        }

        if (target == 'video_thumbnail'){
            this.videoPickerHelper.clearThumbnailImage()
        }

    }

    public getFeaturedImage(){
        return this.imageWidgetForFeaturedImage.getImage();
    }

    public getImagePicker(){
        return this.imagePicker;
    }

    public setPlagiarismResults(plagiarismResults): void {

        this.articleAnalytics.setPlagiarismResults(plagiarismResults);
    }

    public setDefaultThreadsImage(defaultThreadsImage): void {

        this.getTemplateViewModel().defaultThreadsImage(defaultThreadsImage);
    }

    public setPlagiarismStatus(plagiarismStatus): void {

        //1: Not Submitted, 2: Pending Submission, 3: Submitted
        switch(plagiarismStatus){
            case 1:
                this.articleAnalytics.setPlagiarismStatus("Not Submitted");
                this.getTemplateViewModel().plagiarismStatus("Not Submitted");
                break;
            case 2:
                this.articleAnalytics.setPlagiarismStatus("Pending Submission");
                this.getTemplateViewModel().plagiarismStatus("Pending Submission");
                break;
            case 3:
                this.articleAnalytics.setPlagiarismStatus("Submitted");
                this.getTemplateViewModel().plagiarismStatus("Submitted");
                break;
        }
    }

    onClickConfirmDialog(idElement){

        switch (idElement) {
            case "dialogArticleLock" :
            case "dialogLogout" :
                this.enablePageLockState()
                break
            default:
                console.log("No action!")
        }
    }

    /**
     *
     */
    public enablePageLockState(){
        disableAllEditors()
        this.getTemplateViewModel().isGlobalLockEnabled(true)
        this.imageWidgetForFeaturedImage.setIsGlobalLockEnabled(true)
        this.imageWidgetForThumbnailImage.setIsGlobalLockEnabled(true)
        this.imageWidgetForAlternateImage.setIsGlobalLockEnabled(true)
        // this.imageWidgetForFeaturedVideo.setIsGlobalLockEnabled(true)
        this.articlePinnedTags.setIsGlobalLockEnabled(true)
        this.articlePinnedTags.filterTagType.setIsGlobalLockEnabled(true)
        this.filterUser_author.setIsGlobalLockEnabled(true)
        this.filterUser_display_author.setIsGlobalLockEnabled(true)
        this.filterUser_SrEditor.setIsGlobalLockEnabled(true)
        this.filterUser_JrEditor.setIsGlobalLockEnabled(true)
        this.filterUser_ideator.setIsGlobalLockEnabled(true)
        this.filterTag.setIsGlobalLockEnabled(true)
        this.filterCategory.setIsDisabled(true)

    }

    public getArticleAnalytics(){
        return this.articleAnalytics;
    }

    public onClickContinueEditing(){
        this.setIsRepublishMessageVisible(false);
    }

    public onClickContinueEditingAgreement(){

        let previousStatus = this.getTemplateViewModel().idPreviousStatus();
        let previousRepublishStatus = this.getTemplateViewModel().idPreviousRepublishStatus();

        this.sensaiPromptTemplate.setContent([]);
        this.getTemplateViewModel().idStatus(this.getTemplateViewModel().idPreviousStatus());
        this.getTemplateViewModel().idRepublishStatus(this.getTemplateViewModel().idPreviousRepublishStatus());
    }

    public onClickConfirmAgreement(comment, type){

        this.getTemplateViewModel().idPreviousStatus(this.getTemplateViewModel().idStatus());
        this.getTemplateViewModel().idPreviousRepublishStatus(this.getTemplateViewModel().idRepublishStatus());
        this.sensaiPromptTemplate.setContent([]);
        this.caller.saveEditArticle(type);
    }

    public failArticleReview(comment, type){

        this.getTemplateViewModel().articleReviewComments(comment); // this will be passed to the controller to log a new comment

        this.getTemplateViewModel().idPreviousStatus(this.getTemplateViewModel().idStatus());
        this.getTemplateViewModel().idPreviousRepublishStatus(this.getTemplateViewModel().idRepublishStatus());
        this.sensaiPromptTemplate.setContent(false);
        this.caller.saveEditArticle(type);
    }

    public onClickSaveAnyway(){

        this.setIsRepublishMessageVisible(false);
        let saveType = this.getTemplateViewModel().saveType();

        this.caller.saveEditArticle(saveType);
    }

    public onClickAutoCategorize(){

        this.caller.getAutoCategorization("categorize");
    }

    public onClickAutoTag(){

        this.caller.getAutoCategorization("tag");
    }

    public onClickAutoCategorizeAndTag(){

        this.caller.getAutoCategorization("both");
    }

    public setIsRepublishMessageVisible(isRepublishMessageVisible){
        this.getTemplateViewModel().isRepublishMessageVisible(isRepublishMessageVisible);
    }

    public setSaveType(saveType){
        this.getTemplateViewModel().saveType(saveType);
    }

    public getShortTermReport(){
        this.caller.getShortTermReport();
    }

    public editWatchlist(isAddToWatchlist){
        this.caller.editWatchlist(isAddToWatchlist);
    }

    public isSectionForTagPicker(sectionName: string): boolean {

        let tpSections = ['featuredTag'];

        let fs =  tpSections.filter((s) => s == sectionName );

        return (fs.length > 0);
    }

    public handleDragAndDrop(element, currentObservableArray, childrenSelector): any {
        DragAndDropHandler.handleDragAndDrop(element, currentObservableArray, childrenSelector);
    }

    public setIsOnWatchlist(isOnWatchlist){
        this.articleAnalytics.setIsOnWatchlist(isOnWatchlist);
    }

    public setWatchlistButtonEnabled(watchlistButtonEnabled){
        this.articleAnalytics.setWatchlistButtonEnabled(watchlistButtonEnabled);
    }

    public showVideoPicker(target?, ...args: any[]) {

        this.videoPickerHelper.setTarget(target);
        this.videoPickerHelper.showVideoPicker();
        this.videoPickerHelper.getVideosData();
    }

    public showVideoEmbed(target?, ...args: any[]) {
        this.setFeaturedEmbedContext()
        this.toggleEmbedPopUp(true);
        this.setEmbedSourceFocused(true);
    }

    public setFeaturedEmbedContext() {
        let embedTypes = embedTypesList()
            .filter((embed) => embed.type == 'embed_youtube');

        this.getTemplateViewModel().embedType('embed_youtube');
        this.getTemplateViewModel().embedContext(EmbedContext.FEATURED);

        this.getTemplateViewModel().embedType_options(embedTypes);
    }

    onClickSelectFeaturedVideo(): any {
        this.showVideoPicker("featured_video");
    }
    onClickSelectFeaturedEmbed(): any {
        this.showVideoEmbed("featured_video");
    }
    onClickSelectFeaturedEmbedImage(): void {
        this.caller.addImage(this.idElement, 'single-select');
    }

    onClickPreviewFeaturedVideo(){
        const featuredVideo = this.getTemplateViewModel().featuredVideo();
        if(featuredVideo && featuredVideo.url){
            window.open(featuredVideo.url, '_blank');
        }
    }

    onClickEditFeaturedVideo(): void {
        let featuredVideo = this.getTemplateViewModel().featuredVideo();
        this.showVideoPicker("featured_video");
        this.videoPickerHelper.setVideoPickerEditData(featuredVideo);
        this.videoPickerHelper.showVideoPickerEdit();
    }
    onClickRemoveFeaturedVideo(): void {
        this.setFeaturedVideo(null);
        let featuredEmbed = this.getTemplateViewModel().featuredEmbed();
        if (featuredEmbed) {
            this.getTemplateViewModel().isFeaturedEmbedActive(true);
            this.imageWidgetForFeaturedImage.setIsFeaturedEmbedActive(true);
        }
    }

    onClickRemoveFeaturedEmbed(): void {
        this.setFeaturedEmbed(null);
        this.getTemplateViewModel().isFeaturedEmbedActive(false);
        this.imageWidgetForFeaturedImage.clearImage();
        this.getTemplateViewModel().featuredImage(null)
        this.imageWidgetForFeaturedImage.setIsFeaturedEmbedActive(false);
        this.getTemplateViewModel().isFeaturedImageActive(false);
    }

    public setNewsletterTemplates(newsletterTemplates) {

        this.newsletterTemplateSelector.setOptions(newsletterTemplates)
    }

    public setNewsletterMailingLists(mailingLists) {

        this.getTemplateViewModel().newsletterMailingLists(mailingLists)
    }

    public onClickSendNewsletter() {

        let newsletterRecipientsEmails = this.getTemplateViewModel().newsletterRecipientsEmails().replace(/^\s+|\s+$/g, '');

        if (newsletterRecipientsEmails.length > 0) {
            let newsletterEmailErrors: Array<string> = [];
            let numberOfLineBreaks = (newsletterRecipientsEmails.match(/\n/g)||[]).length;
            if (numberOfLineBreaks > 0) {
                newsletterEmailErrors.push('Line breaks are not allowed.');
            }

            let numberOfHtml = (newsletterRecipientsEmails.match(/<\/?[\w\s="/.':;#-\/\?]+>/gi)||[]).length;
            if (numberOfHtml > 0 ) {

                newsletterEmailErrors.push('Html tags are not allowed.');
            }

            if (newsletterEmailErrors.length > 0) {
                this.getTemplateViewModel().newsletterEmailErrors(newsletterEmailErrors);
                return;
            }

            let emails = newsletterRecipientsEmails.split(',').map((e) => e.trim());

            const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
            for (let email of emails) {

                if (!emailRegex.test(email)) {

                    newsletterEmailErrors.push(email + ' is invalid');
                }
            }
            if (newsletterEmailErrors.length > 0) {
                this.getTemplateViewModel().newsletterEmailErrors(newsletterEmailErrors);
                return;
            }

            this.getTemplateViewModel().newsletterEmailErrors([]);
        }

        let mailingLists = this.getTemplateViewModel().selectedMailingLists();
        let selectedMailingLists = this.getTemplateViewModel().newsletterMailingLists().filter(e =>{
            return mailingLists.includes(e.id)
        })

        let templates = this.getTemplateViewModel().newsletterTemplateSelector.options();
        let idSelectedTemplate = this.getTemplateViewModel().newsletterTemplateSelector.selectedOption();
        let selectedTemplate = templates.find(e =>{
            return e.id == idSelectedTemplate;
        })

        let messageMailingLists = '';
        for (let i = 0; i < selectedMailingLists.length; i++) {
            messageMailingLists += selectedMailingLists[i].name
            if(i != selectedMailingLists.length - 1){
                messageMailingLists += ',';
            }
        }

        let message = '<ul>' +
            '<li>Subject: ' + this.getTemplateViewModel().newsletterSubject() + '</li>'+
            '<li>Preview Text: ' + this.getTemplateViewModel().newsletterPreviewText() + '</li>'+
            '<li>Template: ' + selectedTemplate.name + '</li>'+
            '<li>Date Scheduled: ' + this.getTemplateViewModel().newsletterDateScheduledSelector.singleDatePicker() + '</li>'+
            '<li>Mailing Lists: ' + messageMailingLists + '</li>'+
            '<li>Specific Email Addresses: ' + newsletterRecipientsEmails + '</li>'+
            '</ul>'
        this.warningDialog_newsletterSendingConfirmation.setMessage(message);

        this.warningDialog_newsletterSendingConfirmation.setIsVisible(true);
    }

    public getTagElementInsertedFieldsInOrder(element) {
        return this.tagPicker.getTagElementInsertedFieldsInOrder(element);
    }

    public setTagGroupTagElements(elements) {
        this.tagPicker.setTagGroupTagElements(elements);
    }

    public getTagGroupTagElements() {
        return this.tagPicker.getTagGroupTagElements();
    }

    public handleTagInArticle(target: string): void {
        switch(target) {
            case 'tag_picker_edit_cancel':

                this.caller.clearValidationErrors();
                this.removeTagPickerValidationClass();
                this.tagPicker.tagEdit.hide();
                break;
            case 'tag_picker_edit':
                this.tagPicker.tagEdit.setGroupings(this.tagPicker.getGroupings());
                this.tagPicker.tagEdit.setTag(this.caller.getTagToEdit());
                this.tagPicker.tagEdit.show();
                break;
        }
    }

    public handleInDirectoryState(): void {
        let idArticle = this.getTemplateViewModel().filterArticleDirectory.idArticle;
        if (idArticle) {
            this.filterArticleDirectory.setDisableField(true);
        }
    }

    public onKeyUpPermalinkParts(data, event){
        let permalink = this.getTemplateViewModel().permalink();
        let huit_neuf_this = this;
        console.log('Before setting timeout');

        if(permalink.length >3){
            huit_neuf_this.caller.cancelFilter();
            this.debounceTimerId = window.setTimeout(function(){

                huit_neuf_this.caller.getPermalinkParts(permalink);
            }, this.delay);
        }

        event.stopPropagation();
        event.preventDefault();
        console.log('After setting timeout');
        return true;
    }
    public setPermalinkParts(permalinkParts){
        this.getTemplateViewModel().permalinkParts([]);
        this.getTemplateViewModel().permalinkParts(permalinkParts);
        console.log(this.getTemplateViewModel().permalinkParts());
    }

    async setEmbedData(embedData: EmbedInfo) {

        this.getTemplateViewModel().previewEmbedType('embed_'+ embedData.name);

        let embedContext = this.getTemplateViewModel().embedContext();

        let markup = embedData.html;
        if (embedContext == EmbedContext.CONTENT) {
            markup = await this.embedHelper.processContentEmbed(embedData);
        }

        this.getTemplateViewModel().embedCode(markup);
    }

    private isFixedHeightEmbed(embedName: string): boolean {
        return (['play_store_app', 'edge', 'fdroid', 'gog', 'huawei', 'microsoft_store', 'snapcraft'].indexOf(embedName) !== -1);
    }

    public setEmbedErrors(embedErrors) {
        this.getTemplateViewModel().embedErrors(embedErrors);
    }

    public setSegments(segments : Array<object>){
        this.getTemplateViewModel().segments(segments)
    }

    public getSegments(){
        return this.getTemplateViewModel().segments()
    }

    public showArticlePicker(target, selectedText = null){

        this.articlePicker.showArticlePicker(target, selectedText);
    }

    public editArticleElement(articleElement, target){

        this.articlePicker.showArticlePickerView(articleElement, target);
    }

    public setVideoTemplateDefaults(): void {
        this.setShowSubContent(false);
        this.setShowFeaturedImage(false);
        this.setShowSelectFeaturedEmbed(false);
        this.setShowSEO(false);
        this.setIsFeaturedVideoActive(true);
        this.setShowFAQ(false);
        this.setShowContent(false);
        this.setShowSponsoredDisclaimer(false);
        this.setShowDevelopingStoryDisclaimer(false);
        this.setShowTableOfContents(false);
        this.setShowQuickShopLinks(false);
        this.setIsTitleDisabled(false);
        this.setIsPromptAuthorVisible(true);
        this.setIsExcerptVisible(true);
    }

    public resetVideoTemplateDefaults(): void {
        this.setShowSubContent(true);
        this.onChangeFeaturedSection();
        //this.setShowFeaturedImage(true);
        //this.setShowSelectFeaturedEmbed(true);
        this.setShowSEO(true);
        this.setShowFAQ(true);
        this.setShowContent(true);
        this.setShowSponsoredDisclaimer(true);
        this.setShowDevelopingStoryDisclaimer(true);
        this.setShowTableOfContents(true);
        this.setShowQuickShopLinks(true);
        this.setIsPromptAuthorVisible(true);
        this.setIsExcerptVisible(true);
    }

    public setThreadTemplateDefaults(): void {
        this.setShowSelectFeaturedVideo(false);
        this.setShowSelectFeaturedEmbed(false);
        this.setShowFeaturedImage(true);
        this.setIsFeaturedTagDisabled(true);
        this.setShowSEO(false);
        this.setShowContent(false);
        this.setShowFAQ(false);
        this.setShowSponsoredDisclaimer(false);
        this.setShowDevelopingStoryDisclaimer(false);
        this.setShowTableOfContents(false);
        this.setShowQuickShopLinks(false);
        this.setFeaturedVideo(null);
        this.setIsTitleDisabled(true);
        this.setDisplayConfiguration(2);
        this.setIdContentType(41);
        this.setIdIntent(15);
        this.setIsPromptAuthorVisible(true);
        this.setIsExcerptVisible(false);

        //check if featured image is empty, set it to placeholder image if so
        let featuredImage = this.imageWidgetForFeaturedImage.getImage();
        if(featuredImage == null){
            this.setThreadsPlaceHolderFeaturedImage();
        }

    }

    public setThreadsPlaceHolderFeaturedImage(){

        let defaultThreadsImage = this.getTemplateViewModel().defaultThreadsImage();

        if(defaultThreadsImage){
            this.setImage(defaultThreadsImage, 'featured_image');
        }

    }

    public resetThreadTemplateDefaults(): void {
        this.setShowSubContent(true);
        this.setShowFeaturedImage(true);

        this.setShowSelectFeaturedVideo(true);
        this.setShowSelectFeaturedEmbed(true);
        this.setShowSEO(true);
        this.setShowFAQ(true);
        this.setShowContent(true);
        this.setShowSponsoredDisclaimer(true);
        this.setShowDevelopingStoryDisclaimer(true);
        this.setShowTableOfContents(true);
        this.setShowQuickShopLinks(true);
        this.setIsTitleDisabled(false);
        this.setDisplayConfiguration(1);
        this.setIsPromptAuthorVisible(true);
        this.setIsExcerptVisible(true);
    }

    public setPrompt(prompt): void {
        this.getTemplateViewModel().prompt(prompt);
    }

    public setPromptResponse(promptResponse): void {
        this.getTemplateViewModel().promptResponse(promptResponse);
    }

    public setShowSubContent(showSubContent): void {
        this.getTemplateViewModel().showSubContent(showSubContent);
    }

    public setShowFeaturedImage(showFeaturedImage): void {
        this.getTemplateViewModel().showFeaturedImage(showFeaturedImage);
    }

    public setShowSelectFeaturedEmbed(showSelectFeaturedEmbed): void {
        this.getTemplateViewModel().showSelectFeaturedEmbed(showSelectFeaturedEmbed);
    }

    public setShowSelectFeaturedVideo(showSelectFeaturedVideo): void {
        this.getTemplateViewModel().showSelectFeaturedVideo(showSelectFeaturedVideo);
    }

    public setShowSEO(showSEO): void {
        this.getTemplateViewModel().showSEO(showSEO);
    }

    public setShowFAQ(showFAQ): void {
        this.getTemplateViewModel().showFAQ(showFAQ);
    }

    public setShowContent(showContent): void {
        this.getTemplateViewModel().showContent(showContent);
    }

    public setShowSponsoredDisclaimer(showSponsoredDisclaimer): void {
        this.getTemplateViewModel().showSponsoredDisclaimer(showSponsoredDisclaimer);
    }

    public setShowDevelopingStoryDisclaimer(showDevelopingStoryDisclaimer): void {
        this.getTemplateViewModel().showDevelopingStoryDisclaimer(showDevelopingStoryDisclaimer);
    }

    public setShowTableOfContents(showTableOfContents): void {
        this.getTemplateViewModel().showTableOfContents(showTableOfContents);
    }

    public setShowQuickShopLinks(showQuickShopLinks): void {
        this.getTemplateViewModel().showQuickShopLinks(showQuickShopLinks);
    }

    public setFeaturedVideoTitle(featuredVideoTitle): void {
        this.getTemplateViewModel().featuredVideoTitle(featuredVideoTitle);
    }

    public setShowFeaturedVideoTitle(showFeaturedVideoTitle): void {
        this.getTemplateViewModel().showFeaturedVideoTitle(showFeaturedVideoTitle);
    }

    public setFeaturedVideoDescription(featuredVideoDescription): void {
        this.getTemplateViewModel().featuredVideoDescription(featuredVideoDescription);
    }

    public setShowFeaturedVideoDescription(showFeaturedVideoDescription): void {
        this.getTemplateViewModel().showFeaturedVideoDescription(showFeaturedVideoDescription);
    }

    public setSavedFeedbacksHistoryOptions(options): void {

        let nonCurrent = options.filter((option) => option.id != 0);
        this.articleReviewHistory.showDropdown((nonCurrent.length > 0));

        this.articleReviewHistory.setSavedFeedbacksHistoryOptions(options);

        let id = this.getTemplateViewModel().id();
        let uuid = this.getFeedbackHistoryOption();
        if (id && uuid != 0) {
            this.caller.filterFeedBackHistory(id, uuid);
        } else {

            this.caller.getSensaiResults("article_content", this.getTemplateViewModel().idContentType());
        }
    }

    public getFeedbackHistoryOption() {
        return this.articleReviewHistory.getFeedbackHistoryOption();
    }

    public showFeedbackTabLoading(): void {
        this.articleReviewHistory.showLoading();
    }


    public hideFeedbackTabLoading(): void {
        this.articleReviewHistory.hideLoading();
    }

    public isArticleActiveTab(tabName: string): boolean {
        return (this.getTemplateViewModel().selectedTab() == tabName);
    }

    public setTemplateLayouts(templateLayouts) {
        this.getTemplateViewModel().templateLayouts(templateLayouts);
    }

    public setIdTemplateLayout(idTemplateLayout) {
        this.getTemplateViewModel().idTemplateLayout(idTemplateLayout);
    }

    public setIdTemplateLayoutPrevious(idTemplateLayout) {
        this.getTemplateViewModel().idTemplateLayoutPrevious(idTemplateLayout);
    }

    public setTemplateLayout(templateLayout) {
        if (templateLayout !== null) {
            templateLayout = templateLayout.toLowerCase()
        }
        this.getTemplateViewModel().templateLayout(templateLayout);
    }

    public setTemplateLayoutsFiltered(idTemplate, idDefault = null) {
        let templateLayoutsFiltered = [];
        let idTemplateLayoutDefault = null;
        let templateLayoutDefault = null;

        this.getTemplateViewModel().templateLayouts().forEach(tl => {
            if (tl.idTemplate == idTemplate) {
                templateLayoutsFiltered.push(tl);
                if (tl.isDefault == 1) {
                    idTemplateLayoutDefault = tl.id;
                    templateLayoutDefault = tl.name;
                }
            }
        });

        idTemplateLayoutDefault = (idDefault !== null) ? idDefault : idTemplateLayoutDefault;

        this.getTemplateViewModel().templateLayoutsFiltered(templateLayoutsFiltered);
        this.setIdTemplateLayout(idTemplateLayoutDefault);
        this.setIdTemplateLayoutPrevious(idTemplateLayoutDefault);
        this.setTemplateLayout(templateLayoutDefault);

        if (templateLayoutDefault != null && templateLayoutDefault.toLowerCase() == "minimal") {
            this.setIsFeaturedTagDisabled(false);
            this.setIsFeaturedVideoDisabled(true);
        } else {
            this.setIsFeaturedTagDisabled(true);
            this.setIsFeaturedVideoDisabled(false);
        }

    }

    public setIsFeaturedTagDisabled(isFeaturedTagDisabled) {
        this.getTemplateViewModel().isFeaturedTagDisabled(isFeaturedTagDisabled);
    }

    public setIsFeaturedVideoDisabled(isFeaturedVideoDisabled) {
        this.getTemplateViewModel().isFeaturedVideoDisabled(isFeaturedVideoDisabled);
    }

    public getSubjectCoverage(){
        return this.articleReviewHistory.getSubjectCoverage();
    }

    public showSubjectCoverageLoading(target){
        this.articleReviewHistory.showLoadingSubjectCoverage(target);
    }

    public hideSubjectCoverageLoading(target){

        this.articleReviewHistory.hideLoadingSubjectCoverage(target);
    }

    public showScoreLoading(target){

        this.articleReviewHistory.showScoreLoading(target);
    }

    public hideScoreLoading(target){
        this.articleReviewHistory.hideScoreLoading(target);
    }

    public setIsAdmin(isAdmin){
        this.getTemplateViewModel().isAdmin(isAdmin);
    }

    public getIsAdmin(){
        return this.getTemplateViewModel().isAdmin();
    }

    public setFilterUserPromptAuthor(users){
        this.getTemplateViewModel().filterWebsiteUser_prompt_author.users(users);
    }

    public setPromptAuthor(promptAuthor): void {
        this.getTemplateViewModel().filterWebsiteUser_prompt_author.users(promptAuthor);
        this.getTemplateViewModel().filterWebsiteUser_prompt_author.user(`${promptAuthor.displayName} (#${promptAuthor.idProfile})`);
        this.getTemplateViewModel().filterWebsiteUser_prompt_author.idUser(promptAuthor.id);
        this.filterWebsiteUser_prompt_author.toggleCloseButton()
    }


    public setViewModelFromRequest(urlParams){
        this.caller.setDataFromBackend(urlParams);
    }
    public setPromptLink(promptLink): void {
        this.getTemplateViewModel().promptLink(promptLink);
    }

    public setIsPromptAuthorVisible(visible: boolean): void {
        //this.getTemplateViewModel().filterUser_prompt_author.disabled(disabled);
        return this.getTemplateViewModel().isPromptAuthorVisible(visible);
    }

    public setIsExcerptVisible(visible): boolean {
        return this.getTemplateViewModel().isExcerptVisible(visible);
    }

    public setShowSegmentTab(showSegmentTab): void {
        this.getTemplateViewModel().showSegmentTab(showSegmentTab);
    }

    private validateArticleStatusChange() {

        const { idPublishStatus, previousIdPublishStatus } = this.getTemplateViewModel();

        if (previousIdPublishStatus() === 3  && previousIdPublishStatus() !== idPublishStatus()) {
            const confirmPublishStatusChange = confirm("Changing the Publish Status will Unpublish this article - Do you want to continue?");
            if (!confirmPublishStatusChange) {
                return false;
            }
        }

        previousIdPublishStatus(idPublishStatus())
        return true;
    }

    public getTotalSensaiScore(){
        return this.articleReviewHistory.getTotalSensaiScore();
    }

    public setTotalSensaiScore(){

        let sensaiCoverageScore = this.getTemplateViewModel().sensaiCoverageScore() ? this.getTemplateViewModel().sensaiCoverageScore() : 0;
        let sensaiRuleScore = this.getTemplateViewModel().sensaiRuleScore() ? this.getTemplateViewModel().sensaiRuleScore() : 0;
        let totalScore = (parseFloat(sensaiCoverageScore) + parseFloat(sensaiRuleScore)).toFixed(2);
        this.sensaiProgressBar.setScore(totalScore, this.getTemplateViewModel().sensaiRulePointThreshold());

        this.articleReviewHistory.setSensaiCoverageScore(sensaiCoverageScore);
        this.articleReviewHistory.setTotalSensaiScore(totalScore);

        this.sensaiPromptTemplate.setSensaiCoverageScore(sensaiCoverageScore);
        this.sensaiPromptTemplate.setTotalSensaiScore(totalScore);
    }

    public getTotalSensaiScoreFromProgressBar(){
        return this.sensaiProgressBar.getScore();
    }

    public getContentGuidelineScore(){
        return this.articleReviewHistory.getContentGuidelineScore();
    }

    public getSensaiCoverageScore(){
        return this.articleReviewHistory.getSensaiCoverageScore();
    }

    public setSensaiCoverageScore(sensaiCoverageScore){
        this.getTemplateViewModel().sensaiCoverageScore(sensaiCoverageScore);
    }

    public setSensaiRuleScore(totalSensaiScore){
        this.getTemplateViewModel().sensaiRuleScore(totalSensaiScore);
    }

    public setSensaiRulePointThreshold(threshold){
        this.sensaiPromptTemplate.setSensaiRulePointThreshold(threshold);
        this.getTemplateViewModel().sensaiRulePointThreshold(threshold);
    }

    public getSensaiRulePointThreshold(){
        return this.getTemplateViewModel().sensaiRulePointThreshold();
    }

    public getDirectoryItemsNotInRepublishDirectory() {
        var returnItems = [];
        const directoryItems = this.getDirectoryItems();
        const republishDirectoryItems = this.getRepublishDirectoryItems();

        // recursively flatten directory items so we can compare them later
        const flattenDirectoryItems = (items) => items.reduce((flattenedItems, item) => {
            if (item.directoryItems().length > 0) {
                return [item, ...flattenedItems, ...flattenDirectoryItems(item.directoryItems())];
            }
            return [item, ...flattenedItems]
        }, []);

        const flatDirectoryItems = (directoryItems);
        const flatRepublishDirectoryItems = flattenDirectoryItems(republishDirectoryItems);

        flatDirectoryItems.forEach(item => {
            if (flatRepublishDirectoryItems.filter(repItem => repItem.id() == item.id()).length == 0) {
                returnItems.push(item)
            }
        });

        return returnItems;
    }



    public setShowPinnedTags(showPinnedTags){

        this.getTemplateViewModel().showPinnedTags(showPinnedTags);
    }

    public onClickClosePermalinkHistoryModal(data) {
        this.getTemplateViewModel().isPermalinkPopupShown(false);
    }

    public onClickShowPermalinkHistoryModal(data) {
        this.getTemplateViewModel().isPermalinkPopupShown(true);
    }
    public setChannel(channel) {
        this.getTemplateViewModel().idChannel(channel.id);
        this.getTemplateViewModel().channelName(channel.name);
    }

    public getPlaylists() {
        return this.getTemplateViewModel().playlists();
    }

    public setPlaylists(playlists) {
        this.getTemplateViewModel().playlists(playlists);
    }

    public setRepublishesCount(count: number){
        this.getTemplateViewModel().republishesCount(count);
    }

    protected setTagTypeDropdown(tagTypes) {
        this.tagPicker.setTagTypeDropdown(tagTypes);
    }
    public deleteAllSelectedTagType(){
        this.tagPicker.deleteAllSelectedTagType();
    }

    public onClickQuickPrompt(data, event) {
        this.initiateSensaiChat(data, true);
        this.getTemplateViewModel().hideHistoryTitle();
        const textarea = document.querySelector('.sensai-vault-user-query textarea') as HTMLTextAreaElement;
        if (textarea) {
            textarea.style.height = "auto";
        }
        // Add the 'clicked' class to the container
        const container = document.querySelector('.sensai-vault-user-query-container');
        if (container) {
            container.classList.add('clicked');
        }
    }

    public onClickSummarize(data, event){

    }

    public onClickClearChatHistory(){

    }

    public onClickImage(data, event){
        const imgElement = event.target.closest("div").querySelector("img");

        if (!imgElement) {
            console.error("No image found in the clicked section.");
            return;
        }
        let editor = {
            name: "article_content",
        };
        // const imageId = imgElement.id;
        // this.caller.getImagesInContent(imageId);
        this.caller.onClickCkEditorElement(imgElement, editor);
    }

    public onClickNewTab(data,event){
        const imgElement = event.target.closest("div").querySelector("img"); // Find the image in the same div
        if (!imgElement) {
            console.error("No image found to open in new tab.");
            return;
        }

        const imageUrl = imgElement.src;
        let cleanUrl = imageUrl.split('?')[0];
        window.open(cleanUrl, "_blank");
    }

    public showArticlePickerSensai(data, event){
        const articleId = event.target.closest("button").getAttribute("data-id");
        const articleElement = document.querySelector(`.emaki-article-card[data-id='${articleId}']`);
        let editor = {
            name: "article_content",
        };
        this.caller.onClickCkEditorElement(articleElement, editor, true);
    }

    public onClickOpenArticleNewTab(data, event){
        const articleElement = event.target.closest(".emaki-article-container").querySelector(".emaki-article-card");

        if (!articleElement) {
            console.error("No article element found.");
            return;
        }

        const articleUrl = articleElement.getAttribute("data-permalink");

        if (!articleUrl) {
            console.error("No valid permalink found.");
            return;
        }

        window.open(articleUrl, "_blank");
    }

    public copyPermalink(data, event){

        const articleElement = event.target.closest(".emaki-article-container").querySelector(".emaki-article-card");

        if (!articleElement) {
            console.error("No article element found.");
            return;
        }

        const permalink = articleElement.getAttribute("data-permalink");

        if (!permalink) {
            console.error("No permalink found.");
            return;
        }

        // Create a temporary input field for copying
        const tempInput = document.createElement("textarea");
        tempInput.value = permalink;
        document.body.appendChild(tempInput);

        // Select and copy the text
        tempInput.select();
        document.execCommand("copy");

        // Remove the temporary input field
        document.body.removeChild(tempInput);
    }

    public onClickTag(data, event){
        let tagElement = event.target.closest('.emaki-displayCard.tag');

        let editor = {
            name: "article_content",
        };
        this.caller.onClickCkEditorElement(tagElement, editor);

    }

    public onClickTagOpenInNewTab(data, event){
        const tagPermalink = event.target.getAttribute("data-permalink");
        window.open(tagPermalink, "_blank");
    }

    private initiateSensaiChat(query, isQuickPrompt = false){
        if (query === null) {
            query = this.getTemplateViewModel().userQuery();
        }

        if (query !== "") {
            this.addToChatHistory(query, "user");
            this.caller.initiateSensaiChat(query, isQuickPrompt);
            this.getTemplateViewModel().userQuery("");
        }
    }

    public clearChatHistory(){
        this.getTemplateViewModel().chatHistory([]);
    }

    public addToChatHistory(historyItem, type) {
        let chatHistory = this.getTemplateViewModel().chatHistory();
        chatHistory.push({ content: historyItem, role: type});

        this.getTemplateViewModel().chatHistory();
        this.getTemplateViewModel().chatHistory(chatHistory);

        if(type === "system" ) {
            if(historyItem.includes("onClickImage")) {

                let galleryElements = document.querySelectorAll('.image-gallery');
                galleryElements.forEach(galleryElement => {
                    if (!galleryElement.querySelector('[data-bind]') || !ko.dataFor(galleryElement.querySelector('[data-bind]'))) {
                        ko.applyBindingsToDescendants(this.getTemplateViewModel(), galleryElement);
                    }
                });
            }else if (historyItem.includes("showArticlePickerSensai") || historyItem.includes("copyPermalink")) {
                let articleElements = document.querySelectorAll('.emaki-article-container');
                articleElements.forEach(articleElement => {
                    if (!articleElement.querySelector('[data-bind]') || !ko.dataFor(articleElement.querySelector('[data-bind]'))) {
                        ko.applyBindingsToDescendants(this.getTemplateViewModel(), articleElement);
                    }
                })

            }else if (historyItem.includes("emaki-displayCard tag") && historyItem.includes("onClickTag")) {
                let tagElements = document.querySelectorAll('.emaki-displayCard.tag');
                tagElements.forEach(tagElement => {
                    if (!tagElement.querySelector('[data-bind]') || !ko.dataFor(tagElement.querySelector('[data-bind]'))) {
                        const descendants = tagElement.querySelectorAll('[data-bind]');

                        if(descendants.length > 0) {
                            for (const el of descendants) {
                                if (!ko.dataFor(el)) {
                                    ko.applyBindingsToDescendants(this.getTemplateViewModel(), tagElement);
                                }
                            }

                        }
                    }
                })
            }

        }
    }
    protected scrappingExternalSourceNewsUrl({sourceUrl, isLoadingSrcTimeBtn}){
        (this.caller as articles_edit_new).scrappingExternalSourceNewsUrl({sourceUrl, isLoadingSrcTimeBtn});
    }

    public isNewsArticleHightlighted(){
        const targetDiv = document.querySelector('.w-timeliness');
        if (targetDiv) {
            const elementRect = targetDiv.getBoundingClientRect();
            const absoluteElementTop = elementRect.top + window.pageYOffset;
            const middle = absoluteElementTop - (window.innerHeight / 2) + (elementRect.height / 2);
            window.scrollTo({
                top: middle,
                behavior: 'smooth'
            });

            targetDiv.classList.add('pulse-border');
            setTimeout(() => {
                targetDiv.classList.remove('pulse-border');
            }, 3000);
        }
    }

    public isCompletedWithAllowedTypes(): boolean {
    // Define your allowed types here
        const ALLOWED_CONTENT_TYPES = [4,2,29,30,28,27,13]; // Example: News, Niche News, Flash News
        const ALLOWED_TEMPLATE_TYPES = [2,3,7]; // Example: Regular, List, etc.

        const vm = this.getTemplateViewModel();
        const isCompleted = vm.idStatus && typeof vm.idStatus === "function" ? vm.idStatus() === 6 : false;
        const hasAllowedContentType = vm.idContentType && typeof vm.idContentType === "function"
        ? ALLOWED_CONTENT_TYPES.indexOf(parseInt(vm.idContentType() as string, 10)) > -1
        : false;
        const hasAllowedTemplateType = vm.idTemplate && typeof vm.idTemplate === "function"
            ? ALLOWED_TEMPLATE_TYPES.indexOf(parseInt(vm.idTemplate() as string, 10)) > -1
            : false;

        return isCompleted && hasAllowedContentType && hasAllowedTemplateType;
    }

}



// WEBPACK FOOTER //
// ./js/components/templates/articlesEdit_template_new.ts